export const headerFooter = {
  pharmaprix: {
    en: {
      navigation: [
        {
          name: 'Shop',
          uid: 'FrontShopShopNavNode',
          link: 'https://magasiner.pharmaprix.ca/?lang=en&_ga=2.25909621.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Holidays',
              uid: 'FrontShopHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Explore Holidays',
                  uid: 'FrontShopHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Our Picks',
                  uid: 'FrontShopHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Online Exclusives',
                  uid: 'FrontShopHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Gifts by Price",
                  uid: 'FrontShopHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'under $25',
                      uid: 'FrontShopHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'under $50',
                      uid: 'FrontShopHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Beauty Gifts',
                  uid: 'FrontShopHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Makeup',
                      uid: 'FrontShopHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care',
                      uid: 'FrontShopHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrances',
                      uid: 'FrontShopHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care',
                      uid: 'FrontShopHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tools & Accessories',
                      uid: 'FrontShopHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home',
                      uid: 'FrontShopHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Quo Beauty Holiday',
                      uid: 'FrontShopHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Advent Calendars',
                      uid: 'FrontShopHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Discovery Collections',
                      uid: 'FrontShopHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Value Sets',
                      uid: 'FrontShopHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Personal Care Gifts',
                  uid: 'FrontShopHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Electronic Gifts',
                  uid: 'FrontShopHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio & Video Games',
                      uid: 'FrontShopHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Smart Tech',
                      uid: 'FrontShopHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Wellness Gifts',
                  uid: 'FrontShopHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Men's shop",
                  uid: 'FrontShopHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mens Fragrances',
                      uid: 'FrontShopHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Mens Care',
                      uid: 'FrontShopHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Kids Shop',
                  uid: 'FrontShopHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gifts for Pets',
                  uid: 'FrontShopHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Stocking Stuffers',
                  uid: 'FrontShopHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Home & Seasonal Gifts',
                  uid: 'FrontShopHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Thoughtful Choices',
                  uid: 'FrontShopHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Greeting Cards',
                  uid: 'FrontShopHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauty',
              uid: 'FrontShopBeautyNavNode',
              link: '/Beaute?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Gift & Sets',
                  uid: 'FrontShopBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Gifts & Sets',
                          uid: 'FrontShopBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Gifts & Sets',
                          uid: 'FrontShopBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Beauty Tools',
                      uid: 'FrontShopBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home Gifts',
                      uid: 'FrontShopBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Gift By Price',
                      uid: 'FrontShopBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: '$25 or less',
                          uid: 'FrontShopBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$50 or less',
                          uid: 'FrontShopBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$100 or less',
                          uid: 'FrontShopBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Over $100',
                          uid: 'FrontShopBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Value Gift Sets',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Value Gift Sets',
                          uid: 'FrontShopBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advent Calendars',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advent Calendars',
                          uid: 'FrontShopBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Makeup',
                  uid: 'FrontShopBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers?nav=/shop/Categories/Makeup/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face',
                      uid: 'FrontShopBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Foundation',
                          uid: 'FrontShopBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'BB & CC Creams',
                          uid: 'FrontShopBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Concealer',
                          uid: 'FrontShopBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Primer',
                          uid: 'FrontShopBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Powder',
                          uid: 'FrontShopBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blush',
                          uid: 'FrontShopBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bronzer',
                          uid: 'FrontShopBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contour',
                          uid: 'FrontShopBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Highlighter',
                          uid: 'FrontShopBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Setting Spray',
                          uid: 'FrontShopBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eyes',
                      uid: 'FrontShopBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascara',
                          uid: 'FrontShopBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeshadow',
                          uid: 'FrontShopBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeliner',
                          uid: 'FrontShopBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Primer',
                          uid: 'FrontShopBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brows',
                          uid: 'FrontShopBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Treatments',
                          uid: 'FrontShopBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Eyelashes',
                          uid: 'FrontShopBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lips',
                      uid: 'FrontShopBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lipstick',
                          uid: 'FrontShopBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Gloss',
                          uid: 'FrontShopBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Stain',
                          uid: 'FrontShopBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Plumper',
                          uid: 'FrontShopBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm & Treatment',
                          uid: 'FrontShopBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Liner',
                          uid: 'FrontShopBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Palettes',
                      uid: 'FrontShopBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nails',
                      uid: 'FrontShopBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nail Colour',
                          uid: 'FrontShopBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Top & Base Coats',
                          uid: 'FrontShopBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Makeup',
                          uid: 'FrontShopBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Makeup',
                          uid: 'FrontShopBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Makeup',
                          uid: 'FrontShopBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Makeup Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Makeup Gifts',
                          uid: 'FrontShopBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Quo Beauty Holiday Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty Holiday Gifts',
                          uid: 'FrontShopBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Skin Care',
                  uid: 'FrontShopBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers?nav=/shop/Categories/SkinCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face Moisturizers',
                      uid: 'FrontShopBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Night Cream',
                          uid: 'FrontShopBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Oils',
                          uid: 'FrontShopBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Mists',
                          uid: 'FrontShopBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cleansers',
                      uid: 'FrontShopBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Wash & Cleansers',
                          uid: 'FrontShopBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/c/FS-S201?nav=shop/Catrgories/SkinCare/Cleansers/FaceWashAndCleansers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Scrubs & Exfoliators',
                          uid: 'FrontShopBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toners',
                          uid: 'FrontShopBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Treatments',
                      uid: 'FrontShopBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Serums',
                          uid: 'FrontShopBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Anti-aging',
                          uid: 'FrontShopBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brightening',
                          uid: 'FrontShopBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Acne & Blemish Treatments',
                          uid: 'FrontShopBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Peels',
                          uid: 'FrontShopBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masks',
                      uid: 'FrontShopBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Masks',
                          uid: 'FrontShopBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sheet Masks',
                          uid: 'FrontShopBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Creams & Treatment',
                          uid: 'FrontShopBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balm & Treatment',
                      uid: 'FrontShopBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Sunscreen',
                          uid: 'FrontShopBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Body Skin Care',
                      uid: 'FrontShopBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Skincare',
                          uid: 'FrontShopBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Skincare',
                          uid: 'FrontShopBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Skincare',
                          uid: 'FrontShopBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Try our virtual skin analysis tool',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P1/WK02/CollectionTile/EN/wk02_featuredcollectiontile_skintool_b1_en.png',
                            imageLink: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/skindiagnostic',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Try our virtual skin analysis tool',
                          uid: 'FrontShopBeautySkinCareSkinDiagnosticFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Shop Skin Care by Ingredient',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_p3clinical_skincare/wk09_featurecollecctiontile_p3clinicalskincare_enfr.png',
                            imageLink:
                              '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Shop Skin Care by Ingredient',
                          uid: 'FrontShopBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Skin Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Skin Care Gifts',
                          uid: 'FrontShopBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Hair Care',
                  uid: 'FrontShopBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers?nav=/shop/Categories/HairCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampoos & Conditioners',
                      uid: 'FrontShopBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampoo',
                          uid: 'FrontShopBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Conditioner',
                          uid: 'FrontShopBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dry Shampoo',
                          uid: 'FrontShopBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Type',
                      uid: 'FrontShopBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thin & Fine',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straight',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wavy & Curly',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coarse & Thick',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Concern',
                      uid: 'FrontShopBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shine',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Damaged',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Frizz Control',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dryness & Dandruff',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volumizing',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Styling Products & Treatments',
                      uid: 'FrontShopBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hair Treatments',
                          uid: 'FrontShopBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Masks',
                          uid: 'FrontShopBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Spray',
                          uid: 'FrontShopBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Mousse',
                          uid: 'FrontShopBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Wax & Gel',
                          uid: 'FrontShopBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Loss & Regrowth Supplements',
                          uid: 'FrontShopBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Colour',
                      uid: 'FrontShopBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Permanent Hair Colour',
                          uid: 'FrontShopBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Root Touch-Up',
                          uid: 'FrontShopBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Temporary Hair Colour',
                          uid: 'FrontShopBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-T500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Gifts & Sets',
                      uid: 'FrontShopBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Hair Care',
                          uid: 'FrontShopBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Hair Care',
                          uid: 'FrontShopBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Hair Care',
                          uid: 'FrontShopBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Hair Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Hair Care Gifts',
                          uid: 'FrontShopBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Fragrance',
                  uid: 'FrontShopBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers?nav=/shop/Categories/Fragrance/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Her',
                      uid: 'FrontShopBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Perfume',
                          uid: 'FrontShopBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Fragrance Mists',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for her',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for him',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Home Scents & Candles',
                      uid: 'FrontShopBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rollerballs & Travel size',
                      uid: 'FrontShopBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Fragrance',
                          uid: 'FrontShopBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Fragrance Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-fragrance-gifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Fragrance Gifts',
                          uid: 'FrontShopBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers?nav=/shop/Categories/ToolsAndAccessories/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Handbands & Head Wraps',
                          uid: 'FrontShopBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Tools & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Tools & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Salon-level hair tools',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2020/evergreen/collection-tiles/menufeaturedtile_toolsaccessories_b1_en.jpg',
                            imageLink:
                              '/c/FS-T400?nav=/shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Salon-level hair tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tools & Accessories by Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/Evergreen/collection-tiles-nav/quo/wk16_featurecollectiontile_quo-tools-accessories_enfr.png',
                            imageLink:
                              '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tools & Accessories by Quo Beauty',
                          uid: 'FrontShopBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers?nav=/shop/Categories/Mens/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care for Him',
                      uid: 'FrontShopBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cleansers & Accessories',
                          uid: 'FrontShopBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Treatments',
                          uid: 'FrontShopBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm',
                          uid: 'FrontShopBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances',
                          uid: 'FrontShopBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Shave',
                          uid: 'FrontShopBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair for Him',
                      uid: 'FrontShopBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Luxury Men's Care",
                          uid: 'FrontShopBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Derm Men's Care",
                          uid: 'FrontShopBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Thoughtful Choices Men's Care",
                          uid: 'FrontShopBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Men's Gifts",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Men's Gifts",
                          uid: 'FrontShopBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shop by Brand',
                  uid: 'FrontShopBeautyShopByBrandsNavNode',
                  link: '/all-brands?nav=shop/beauty/shopallbrand',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Popular Brands',
                      uid: 'FrontShopBeautyBrandsPopularBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'DysonName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_dyson.png',
                            imageLink: '/c/DYSON?nav=/brands/dyson',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Dyson',
                          uid: 'FrontShopBeautyBrandsdysonPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LancomeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_lancome.png',
                            imageLink: '/c/LANCOME?nav=/brands/lancome',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Lancome',
                          uid: 'FrontShopBeautyBrandsLancomePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'REMName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.amazonaws.com/site-creative/2022/beauty-brand-tiles/menubrandtile_rembeauty.png',
                            imageLink: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                            __typename: 'NavPromoNode',
                          },
                          name: 'REM',
                          uid: 'FrontShopBeautyBrandsREMPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LaRochePosayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_laorocheposay.png',
                            imageLink: '/c/LA%2CROCHE%2CPOSAY?nav=/brands/larocheposay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'La Roche Posay',
                          uid: 'FrontShopBeautyBrandsLaRochePosayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'CeraVeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_cerave.png',
                            imageLink: '/c/CERAVE?nav=/brands/cerave',
                            __typename: 'NavPromoNode',
                          },
                          name: 'CeraVe',
                          uid: 'FrontShopBeautyBrandsCeraVePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'OlayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_olay.png',
                            imageLink: '/c/OLAY?nav=/brands/olay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Olay',
                          uid: 'FrontShopBeautyBrandsOlayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'QuoBeautyName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_quobeauty.png',
                            imageLink: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/quobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty',
                          uid: 'FrontShopBeautyBrandsQuoBeautyPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LOrealName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_loreal.png',
                            imageLink: '/c/L%27OREAL?nav=/brands/loreal',
                            __typename: 'NavPromoNode',
                          },
                          name: "L'Oreal",
                          uid: 'FrontShopBeautyBrandsLOrealPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Brands',
                      uid: 'FrontShopBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA%2CMERCIER?nav=/brands/lauramercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO%2CFACED?nav=/brands/toofaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=/brands/foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=/brands/nars',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Personal Care',
              uid: 'FrontShopPersonalCareNavNode',
              link: '/Soins-personnels?nav=/magasiner/soinspersonnels',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Bath & Body Care',
                  uid: 'FrontShopPersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Body Care',
                      uid: 'FrontShopPersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Butters',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Lotions',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Firming & Stretch Mark Creams',
                          uid: 'FrontShopPersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Oils',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopPersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Shower',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Wash & Shower Gels',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Soaks & Bubble Bath',
                          uid: 'FrontShopPersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Scrubs',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Accessories',
                          uid: 'FrontShopPersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hand & Foot Care',
                      uid: 'FrontShopPersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hand Soaps',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Creams & Lotions',
                          uid: 'FrontShopPersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Sanitizers',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balms',
                      uid: 'FrontShopPersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Deodorant & Antiperspirant',
                      uid: 'FrontShopPersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Deodorant',
                          uid: 'FrontShopPersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Powder',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopPersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopPersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopPersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bath & Body Gifts & Sets',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopPersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Bath & Body Care',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self-care Gifts',
                      uid: 'FrontShopPersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: '/c/PersonalCareHoliday?nav=/shop/Categories/Holiday/PersonalCareGifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices ',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Bath & Body Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_bathandbodycare/wk13_featurecollecctiontile_bath-body-care_enfr.png',
                            imageLink:
                              '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Bath & Body Care',
                          uid: 'FrontShopPersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Intimate Care',
                  uid: 'FrontShopPersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Pads & Panty Liners',
                      uid: 'FrontShopPersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Intimate Cleaning & Deodorants',
                      uid: 'FrontShopPersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopPersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cups',
                      uid: 'FrontShopPersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopPersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Intimate Care',
                          uid: 'FrontShopPersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopPersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Intimate Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_intimatecare/wk05_featurecollecctiontile_intimatecare_enfr.png',
                            imageLink:
                              '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Intimate Care',
                          uid: 'FrontShopPersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bladder Control & Incontinence',
                  uid: 'FrontShopPersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Incontinence Pads & Liners',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Protective Underwear & Briefs',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareBladderControlFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: ' New! Thinx Feminine Hygiene ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_thinx/wk25_featurecollecctiontile_thinx_enfr.png',
                            imageLink: null,
                            __typename: 'NavPromoNode',
                          },
                          name: ' New! Thinx Feminine Hygiene \t',
                          uid: 'FrontShopPersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                          link: '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollection/Thinx',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: ' New! Thinx Feminine Hygiene ',
                          uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                          link: '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollections/Thinx',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Oral Care',
                  uid: 'FrontShopPersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toothbrushes',
                      uid: 'FrontShopPersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric toothbrushes',
                          uid: 'FrontShopPersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothbrushes',
                          uid: 'FrontShopPersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Oral Care Products',
                      uid: 'FrontShopPersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mouthwash & Rinses',
                          uid: 'FrontShopPersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breath Fresheners',
                          uid: 'FrontShopPersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Care',
                          uid: 'FrontShopPersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopPersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothpaste',
                          uid: 'FrontShopPersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Teeth Whitening',
                          uid: 'FrontShopPersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Floss',
                          uid: 'FrontShopPersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopPersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Oral Care',
                          uid: 'FrontShopPersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopPersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Oral Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_oralcare/wk05_featurecollecctiontile_oralcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Oral Care',
                          uid: 'FrontShopPersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shaving & Hair Removal',
                  uid: 'FrontShopPersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving Creams & Gels',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Waxes & Removal Creams',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Electric Shavers',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Disposable Razors & Blades',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Removal Devices',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Grooming Accessories',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Shaving & Hair Removal',
                            imageUrl:
                              ' https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P6/wk21/front-shop/featurecollectiontile_shavinghairremoval/wk21_featurecollecctiontile_shavinghair_enfr.png',
                            imageLink:
                              '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Shaving & Hair Removal',
                          uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopPersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopPersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopPersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopPersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razors & Blades',
                          uid: 'FrontShopPersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopPersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Men's Self-care",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P6/wk21/front-shop/featurecollectiontile_menselfcare/wk21_featurecollecctiontile_menselfcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-M101?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/Mens/FeaturedCollections/MensSelfCare',
                            __typename: 'NavPromoNode',
                          },
                          name: "Men's Self-care\t",
                          uid: 'FrontShopPersonalCareMenSelfCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-M101?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Mens/ShavingForHim/FeaturedCollections/SelfCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopPersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving & Grooming Tools & Accessories ',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Removal Devices',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Wardrobe Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Jewellery',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bra Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hosiery & Tights',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Socks',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Winter Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Winter Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Travel Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weather Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareToolsAccessFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Travel Sized Items',
                  uid: 'FrontShopPersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareTravelSizedItemsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Insect & Pest Control',
                  uid: 'FrontShopPersonalCareInsectPestControlNavNode',
                  link: '/Shop/Categories/Personal-Care/Insect-%26-Pest-Control/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Health',
              uid: 'FrontShopHealthNavNode',
              link: '/Santé?nav=/magasiner/santé',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Medicine & Treatments',
                  uid: 'FrontShopHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Cough, Cold & Flu',
                      uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cough, Cold & Flu Medication',
                          uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care & Sleep Aids ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermometers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Pill Organization',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pain Relief',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Topical Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hot & Cold Treatment',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'First Aid',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandaging Supplies & Tape',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptics',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'First Aid Supplies',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Medical Supports & Garments',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allergy & Sinus',
                      uid: 'FrontShopHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistamines',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Digestive Health',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Digestive Intolerance',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sleep Aids',
                      uid: 'FrontShopHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diabetic Care',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDiabeticCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Diabetic Skincare',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabeticSkincareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Glucose Testing',
                          uid: 'FrontShopHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Personal Protective Equipment',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Personal Protective Equipment ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamins & Supplements',
                  uid: 'FrontShopHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Supplements',
                      uid: 'FrontShopHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Omega Fish Oils & Essential Fatty Acids',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair, Nails & Skin Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Melatonin',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Health Food Supplements',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homeopathy',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Joint Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Men's Health",
                          uid: 'FrontShopHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Women's Health",
                          uid: 'FrontShopHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Mineral Supplements',
                      uid: 'FrontShopHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Magnesium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Iron',
                          uid: 'FrontShopHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition & Weight Management',
                      uid: 'FrontShopHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Protein Bars & Snacks',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protein Liquid & Powder',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Vitamins',
                      uid: 'FrontShopHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Adults Multivitamins',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Webber Naturals Sleep Support',
                      uid: 'FrontShopHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: '/c/WEBBER-FS-HT-V209?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturalssleepsupport',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Vitalux Advanced Vitamins ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitalux Advanced Vitamin',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Sexual Wellness & Family Planning',
                  uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Sexual Wellness',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubricants & Intimate Massage Oils',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sex Toys',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptives',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Family Planning',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pregnancy Tests',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ovulation Kits & Tests',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sexual Wellness Gifts',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Sexual Wellness Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Sexual Wellness Gifts',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Eye, Ear & Foot Care',
                  uid: 'FrontShopHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Health Supplements',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Care Accessories',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contact Lens Solution',
                          uid: 'FrontShopHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeglasses',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Foot Care',
                      uid: 'FrontShopHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Odor & Wetness Control',
                          uid: 'FrontShopHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Inserts, Insoles & Cushions',
                          uid: 'FrontShopHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home Health Care & Fitness',
                  uid: 'FrontShopHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Compression Hosiery & Stockings',
                      uid: 'FrontShopHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Scales, Pulse Oximeter &  Pedometers',
                      uid: 'FrontShopHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Body Wellness & Massagers',
                      uid: 'FrontShopHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bathroom Safety',
                      uid: 'FrontShopHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Blood Pressure Monitors',
                      uid: 'FrontShopHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fitness Equipment & Accessories',
                      uid: 'FrontShopHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-&-Accessories/c/FS-HT-H700?nav=/shop/Categories/HomeHealthCare/FitnessEquipmentAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthHomeHealthCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Baby & Child',
              uid: 'FrontShopBabyAndChildNavNode',
              link: '/Bébé-et-enfant?nav=/magasiner/bébéetenfant',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Baby & Child Care',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Diapers & Wipes',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Diapers',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Training Pants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Rash Treatment',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Pails Refills',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Wipes',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Body Care',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Lotions',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bath & Shampoos',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotton Swabs',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Oil',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Powders',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Children's Health Care",
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Children's Cough Cold & Flu",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Childproofing & Safety',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Toys',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Clothing & Accessories',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Baby Gifts & Sets',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Feeding & Formula',
                  uid: 'FrontShopBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Baby Food & Formula',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formula',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Food & Toddler Snacks',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Cereal',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pediatric Nutrition',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nursing & Mealtime',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Toddler Feeding Accessories',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bottles & Nipples',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pacifier & Teething',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breastfeeding Essentials',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'New Infant Formula',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNewInfantFormulaNavNode',
                      link: 'c/FS-BC-F101?&sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/BabyAndChild/FeedingAndFormula/FeaturedCollections/NewInfantFormula',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'New Infant Formula',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNewInfantFormulaNavNode',
                      link: 'c/FS-BC-F101?&sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/BabyAndChild/FeedingAndFormula/FeaturedCollections/NewInfantFormula',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Toys',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Home & Electronics',
              uid: 'FrontShopHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/magasiner/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Electronics',
                  uid: 'FrontShopHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Video Games',
                      uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles & Gaming Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Games',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cameras & Phone Accessories',
                      uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cameras & Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Phones & Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Memory cards',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Computers & Smart Tech',
                      uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Connected Home',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Notebooks',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablets & eReaders',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Computer Accessories & Software',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Smart Watches & GPS',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-&-Smart-Tech/Smartwatches/c/FS-EL-505?nav=/shop/Categories/Electronics/SmartWatchesAndGPS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Apple Electronics',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P3/WK12/menu-featuretile/menufeaturetile_apple_enfr.jpg',
                            imageLink: '/c/APPLE?nav=/shop/electronicselectronicsapplefeaturedcollection',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Apple Electronics',
                          uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionAppleNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Home & Lifestyle',
                  uid: 'FrontShopHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Candles',
                      uid: 'FrontShopHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffusers',
                      uid: 'FrontShopHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: null,
                      uid: 'FrontShopHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Seasonal Shop',
                      uid: 'FrontShopHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Refreshing Scents',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Refreshing Scents',
                          uid: 'FrontShopHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Appliances',
                  uid: 'FrontShopHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Bedding & Mattresses',
                  uid: 'FrontShopHomeAndElectronicsBeddingNavNode',
                  link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mattresses',
                      uid: 'FrontShopHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Bedding/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pillows',
                      uid: 'FrontShopHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weighted Blankets & Covers',
                      uid: 'FrontShopHomeAndElectronicsWeightedBlanketsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Seasonal Shop',
                  uid: 'FrontShopHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Categories/Home-%26-Electronics/Home-%26-Lifestyle/Seasonal-Shop/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0&lang=en',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offers',
              uid: 'FrontShopOffersNavNode',
              link: '/c/FS-Offers?nav=/shop/offers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Sale',
                  uid: 'FrontShopOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance',
                  uid: 'FrontShopOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/clearance&q=:trending:promotions:Clearance:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase',
                  uid: 'FrontShopOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/GWP&q=:trending:promotions:Gift+with+Purchase:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'PC Optimum Offers',
                  uid: 'FrontShopOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Prescriptions',
          uid: 'FrontShopPrescriptionNavNode',
          link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Pharmacy Services',
          uid: 'FrontShopPharmacyServicesLocaledLink',
          link: 'https://www.pharmaprix.ca/en/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Health & Wellness',
          uid: 'FrontShopHealthAndWellnessLocaledLink',
          link: 'https://www.pharmaprix.ca/en/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Electronics',
          uid: 'FrontShopElectronicsNavNode',
          link: 'https://www1.pharmaprix.ca/en/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopPromotionsNavNode',
          link: 'https://magasiner.pharmaprix.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopPCOptimumNavNode',
          link: 'https://www1.pharmaprix.ca/en/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'More by Pharmaprix',
          uid: 'FrontShopMoreByShoppersNavNode',
          link: 'https://www1.pharmaprix.ca/en/more-by-pharmaprix',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
      footer: [
        {
          name: 'Shop by Popular Categories',
          link: null,
          uid: 'FrontShopFooterShopNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Beauty',
              link: '/Beauté',
              uid: 'FrontShopFooterShopBeautyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Personal Care',
              link: '/c/FS-PC?nav=%2Fshop%2Fpersonal&sort=trending&page=0',
              uid: 'FrontShopFooterShopPersonalCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Health',
              link: '/c/FS-HT?nav=%2Fshop%2Fhealth&sort=trending&page=0',
              uid: 'FrontShopFooterShopHealthNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Baby & Child',
              link: '/c/FS-BC?nav=%2Fshop%2Fbaby&sort=trending&page=0',
              uid: 'FrontShopFooterShopBabyAndChildNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Electronics',
              link: '/c/FS-EL?nav=%2Fshop%2Felectronics&sort=trending&page=0',
              uid: 'FrontShopFooterShopElectronicsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Offers',
              link: '/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0',
              uid: 'FrontShopFooterShopOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Makeup',
              link: '/shop/Categories/Makeup/c/FS-MakeUp',
              uid: 'FrontShopFooterShopMakeupNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'SkinCare',
              link: '/shop/Categories/Makeup/c/FS-SkinCare',
              uid: 'FrontShopFooterShopSkinCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'MOCK',
              link: '/shop/Categories/Makeup/c/FS-Mock',
              uid: 'FrontShopFooterShopMOCKNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Shop Customer Service',
          link: null,
          uid: 'FrontShopFooterCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Contact Us',
              link: '/contactus',
              uid: 'FrontShopFooterContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Returns & Exchanges',
              link: '/returns',
              uid: 'FrontShopFooterReturnsExchangesNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: '/faq',
              uid: 'FrontShopFooterFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shipping & Handling',
              link: '/shipping',
              uid: 'FrontShopFooterShippingHandlingNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Order History',
              link: '/my-account/orders',
              uid: 'FrontShopFooterOrderHistoryNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Offers',
          link: null,
          uid: 'FrontShopFooterOffersNavNode',
          hasChildren: true,
          child: [
            {
              name: 'View eflyer',
              link: 'https://www1.shoppersdrugmart.ca/en/pcoptimum/in-store-offers',
              uid: 'FrontShopFooterVieweflyerNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'View all in-store exclusive offers',
              link: 'https://www1.shoppersdrugmart.ca/en/flyer',
              uid: 'FrontShopFooterInstoreExclusiveOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'PC Optimum Program',
          link: null,
          uid: 'FrontShopFooterPCOptimumProgramNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Join',
              link: 'https://www.pcoptimum.ca/register?sid=home|missrewards|getstarted2',
              uid: 'FrontShopFooterJoinNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Sign In',
              link: 'https://accounts.pcid.ca/login',
              uid: 'FrontShopFooterSignInNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://loblaw.force.com/PCoptimumsupport/s/?language=en',
              uid: 'FrontShopFooterOptimumFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'View all PC Optimum Offers',
              link: 'https://www.pcoptimum.ca/',
              uid: 'FrontShopFooterViewOptimuOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'About Shoppers Drug Mart',
          link: null,
          uid: 'FrontShopFooterAboutShoppersDrugMartNavNode',
          hasChildren: true,
          child: [
            {
              name: 'News And Announcements',
              link: 'https://www1.shoppersdrugmart.ca/en/news',
              uid: 'FrontShopFooterNewsAndAnnouncementsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Corporate',
              link: 'https://corporate.shoppersdrugmart.ca/en-ca/Home.aspx',
              uid: 'FrontShopFooterCorporateNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Corporate News',
              link: 'https://media.loblaw.ca/English/media-centre/press-releases/default.aspx',
              uid: 'FrontShopFooterCorporateNewsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Social Responsibility',
              link: 'https://www1.shoppersdrugmart.ca/en/love-you',
              uid: 'FrontShopFooterSocialResponsibilityNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Careers',
              link: 'https://careers.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterCareersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Pharmacy Acquisition',
              link: 'http://corporate.shoppersdrugmart.ca/en-ca/pharmacy-acquisition',
              uid: 'FrontShopFooterPharmacyAcquisitionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Legal',
              link: 'http://corporate.shoppersdrugmart.ca/en-ca/legal',
              uid: 'FrontShopFooterLegalNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Privacy',
              link: 'https://www.loblaw.ca/en/privacy.html',
              uid: 'FrontShopFooterPrivacyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Customer Service',
          link: null,
          uid: 'FrontShopFooterSDMCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Product Recall',
              link: 'https://www1.shoppersdrugmart.ca/en/product-recall',
              uid: 'FrontShopFooterSDMProductRecallNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Contact Store Support',
              link: 'https://www1.shoppersdrugmart.ca/en/contact-us',
              uid: 'FrontShopFooterSDMContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Refunds',
              link: 'https://www1.shoppersdrugmart.ca/en/refunds',
              uid: 'FrontShopFooterSDMRefundsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Get Help',
              link: 'https://gethelp.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterSDMGetHelpNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'In Store',
          link: null,
          uid: 'FrontShopFooterVisitAStoreNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Renew Or Refill Prescription',
              link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
              uid: 'FrontShopFooterRenewOrRefillPrescriptionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Store Locator',
              link: 'https://stores.shoppersdrugmart.ca/en/',
              uid: 'FrontShopFooterStoreLocatorNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Photo',
              link: 'https://www.shoppersphoto.ca/?lang=en',
              uid: 'FrontShopFooterShoppersPhotoNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Home Health Care',
              link: 'https://www.shoppershomehealthcare.ca/',
              uid: 'FrontShopFooterShoppersHomeHealthCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Gift Cards',
              link: 'https://www1.pharmaprix.ca/en/food-and-home/gift-cards',
              uid: 'FrontShopFooterGiftCardNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
      ],
      navigationMobile: [
        {
          name: 'Prescriptions',
          uid: 'FrontShopMobilePrescriptionNavNode',
          link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Pharmacy Services',
          uid: 'FrontShopMobilePharmacyServicesNavNode',
          link: 'https://www.pharmaprix.ca/en/health-and-wellness/pharmacy-services',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Shop',
          uid: 'FrontShopMobileShopNavNode',
          link: '/?nav=home',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Holidays',
              uid: 'FrontShopMobileHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Explore Holidays',
                  uid: 'FrontShopMobileHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Our Picks',
                  uid: 'FrontShopMobileHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Online Exclusives',
                  uid: 'FrontShopMobileHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Gifts by Price",
                  uid: 'FrontShopMobileHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'under $25',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'under $50',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Beauty Gifts',
                  uid: 'FrontShopMobileHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Makeup',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrances',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tools & Accessories',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Quo Beauty Holiday',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Advent Calendars',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Discovery Collections',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Value Sets',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Personal Care Gifts',
                  uid: 'FrontShopMobileHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Electronic Gifts',
                  uid: 'FrontShopMobileHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio & Video Games',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Smart Tech',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Wellness Gifts',
                  uid: 'FrontShopMobileHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Men's shop",
                  uid: 'FrontShopMobileHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mens Fragrances',
                      uid: 'FrontShopMobileHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Mens Care',
                      uid: 'FrontShopMobileHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Kids Shop',
                  uid: 'FrontShopMobileHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gifts for Pets',
                  uid: 'FrontShopMobileHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Stocking Stuffers',
                  uid: 'FrontShopMobileHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Home & Seasonal Gifts',
                  uid: 'FrontShopMobileHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Thoughtful Choices',
                  uid: 'FrontShopMobileHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Greeting Cards',
                  uid: 'FrontShopMobileHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauty',
              uid: 'FrontShopMobileBeautyNavNode',
              link: '/Beaute?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Gift & Sets',
                  uid: 'FrontShopMobileBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Gifts & Sets',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Gifts & Sets',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyGiftAndSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Beauty Tools',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Natural Beauty',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNaturalBeautyNavNode',
                      link: '/c/NaturalBeauty?nav=beauty/giftsandsets/naturalbeauty',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home Gifts',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Gift By Price',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: '$25 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$50 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$100 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Over $100',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Value Gift Sets',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Value Gift Sets',
                          uid: 'FrontShopMobileBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advent Calendars',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advent Calendars',
                          uid: 'FrontShopMobileBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Makeup',
                  uid: 'FrontShopMobileBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face',
                      uid: 'FrontShopMobileBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Foundation',
                          uid: 'FrontShopMobileBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'BB & CC Creams',
                          uid: 'FrontShopMobileBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopMobileBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Concealer',
                          uid: 'FrontShopMobileBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Primer',
                          uid: 'FrontShopMobileBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Powder',
                          uid: 'FrontShopMobileBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blush',
                          uid: 'FrontShopMobileBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bronzer',
                          uid: 'FrontShopMobileBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contour',
                          uid: 'FrontShopMobileBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Highlighter',
                          uid: 'FrontShopMobileBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopMobileBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Setting Spray',
                          uid: 'FrontShopMobileBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopMobileBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eyes',
                      uid: 'FrontShopMobileBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascara',
                          uid: 'FrontShopMobileBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeshadow',
                          uid: 'FrontShopMobileBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeliner',
                          uid: 'FrontShopMobileBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Primer',
                          uid: 'FrontShopMobileBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopMobileBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brows',
                          uid: 'FrontShopMobileBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Treatments',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Eyelashes',
                          uid: 'FrontShopMobileBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Palettes',
                      uid: 'FrontShopMobileBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopMobileBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopMobileBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopMobileBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBruorshesAndAccessies/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopMobileBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopMobileBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nails',
                      uid: 'FrontShopMobileBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nail Colour',
                          uid: 'FrontShopMobileBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Top & Base Coats',
                          uid: 'FrontShopMobileBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopMobileBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopMobileBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopMobileBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Lips',
                      uid: 'FrontShopMobileBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lipstick',
                          uid: 'FrontShopMobileBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Gloss',
                          uid: 'FrontShopMobileBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Stain',
                          uid: 'FrontShopMobileBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Plumper',
                          uid: 'FrontShopMobileBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm & Treatment',
                          uid: 'FrontShopMobileBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Liner',
                          uid: 'FrontShopMobileBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Makeup',
                          uid: 'FrontShopMobileBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Makeup',
                          uid: 'FrontShopMobileBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Makeup',
                          uid: 'FrontShopMobileBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopMobileBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Makeup Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Makeup Gifts',
                          uid: 'FrontShopMobileBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Quo Beauty Holiday Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty Holiday Gifts',
                          uid: 'FrontShopMobileBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Skin Care',
                  uid: 'FrontShopMobileBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face Moisturizers',
                      uid: 'FrontShopMobileBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopMobileBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=/shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Night Cream',
                          uid: 'FrontShopMobileBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=/shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Oils',
                          uid: 'FrontShopMobileBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=/shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopMobileBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=/shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Mists',
                          uid: 'FrontShopMobileBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopMobileBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=/shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cleansers',
                      uid: 'FrontShopMobileBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Wash & Cleansers',
                          uid: 'FrontShopMobileBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Scrubs & Exfoliators',
                          uid: 'FrontShopMobileBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=/shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopMobileBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=/shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toners',
                          uid: 'FrontShopMobileBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Treatments',
                      uid: 'FrontShopMobileBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Serums',
                          uid: 'FrontShopMobileBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=/shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Anti-aging',
                          uid: 'FrontShopMobileBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=/shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brightening',
                          uid: 'FrontShopMobileBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=/shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Acne & Blemish Treatments',
                          uid: 'FrontShopMobileBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=/shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Peels',
                          uid: 'FrontShopMobileBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=/shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masks',
                      uid: 'FrontShopMobileBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Masks',
                          uid: 'FrontShopMobileBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=/shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sheet Masks',
                          uid: 'FrontShopMobileBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=/shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopMobileBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopMobileBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Creams & Treatment',
                          uid: 'FrontShopMobileBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopMobileBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balm & Treatment',
                      uid: 'FrontShopMobileBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobileBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Sunscreen',
                          uid: 'FrontShopMobileBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopMobileBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopMobileBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopMobileBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopMobileBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Body Skin Care',
                      uid: 'FrontShopMobileBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Skincare',
                          uid: 'FrontShopMobileBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Skincare',
                          uid: 'FrontShopMobileBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Skincare',
                          uid: 'FrontShopMobileBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Try Our Virtual Skin Analysis Tools',
                          uid: 'FrontShopMobileSkincareSkinAnalysisToolsFeaturedCollectionsNavNode',
                          link: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/tryourvirtualskinanalysistools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shop Skin Care by Ingredient',
                          uid: 'FrontShopMobileBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Skin Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Skin Care Gifts',
                          uid: 'FrontShopMobileBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Hair Care',
                  uid: 'FrontShopMobileBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampoos & Conditioners',
                      uid: 'FrontShopMobileBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampoo',
                          uid: 'FrontShopMobileBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Conditioner',
                          uid: 'FrontShopMobileBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dry Shampoo',
                          uid: 'FrontShopMobileBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Type',
                      uid: 'FrontShopMobileBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thin & Fine',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straight',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wavy & Curly',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coarse & Thick',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobileBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobileBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobileBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobileBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobileBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Concern',
                      uid: 'FrontShopMobileBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shine',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Damaged',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Frizz Control',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dryness & Dandruff',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volumizing',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Styling Products & Treatments',
                      uid: 'FrontShopMobileBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hair Treatments',
                          uid: 'FrontShopMobileBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Masks',
                          uid: 'FrontShopMobileBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Spray',
                          uid: 'FrontShopMobileBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Mousse',
                          uid: 'FrontShopMobileBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Wax & Gel',
                          uid: 'FrontShopMobileBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Loss & Regrowth Supplements',
                          uid: 'FrontShopMobileBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Colour',
                      uid: 'FrontShopMobileBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Permanent Hair Colour',
                          uid: 'FrontShopMobileBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Root Touch-Up',
                          uid: 'FrontShopMobileBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Temporary Hair Colour',
                          uid: 'FrontShopMobileBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobileBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-T500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopMobileBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobileBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopMobileBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Gifts & Sets',
                      uid: 'FrontShopMobileBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopMobileBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Hair Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Hair Care Gifts',
                          uid: 'FrontShopMobileBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Fragrance',
                  uid: 'FrontShopMobileBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Her',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for her',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Perfume',
                          uid: 'FrontShopMobileBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Fragrance Mists',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopMobileBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for him',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Home Scents & Candles',
                      uid: 'FrontShopMobileBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopMobileBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rollerballs & Travel size',
                      uid: 'FrontShopMobileBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Fragrance',
                          uid: 'FrontShopMobileBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fragrance Gifts & Sets',
                          uid: 'FrontShopMobileFragrancesGiftsAndSetsFeaturedCollectionsNavNode',
                          link: '/FS-G300?nav=shop/beauty/fragrances/featuredcollection/fragrancegiftsandsets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Gifts',
                          uid: 'FrontShopMobileBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Handbands & Head Wraps',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Tools & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Tools & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Salon-Level Hair Tools',
                          uid: 'FrontShopMobileToolsAndAccessoriesSalonLevelHairToolsFeaturedCollectionsNavNode',
                          link: '/c/FS-T400?nav=shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools & Accessories by Quo Beauty',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopMobileBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care for Him',
                      uid: 'FrontShopMobileBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopMobileBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cleansers & Accessories',
                          uid: 'FrontShopMobileBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Treatments',
                          uid: 'FrontShopMobileBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm',
                          uid: 'FrontShopMobileBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobileBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopMobileBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopMobileBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopMobileBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances',
                          uid: 'FrontShopMobileBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopMobileBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopMobileBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Shave',
                          uid: 'FrontShopMobileBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobileBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopMobileBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobileBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair for Him',
                      uid: 'FrontShopMobileBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopMobileBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Luxury Men's Care",
                          uid: 'FrontShopMobileBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Derm Men's Care",
                          uid: 'FrontShopMobileBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Thoughtful Choices Men's Care",
                          uid: 'FrontShopMobileBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Men's Gifts",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Men's Gifts",
                          uid: 'FrontShopMobileBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Brands',
                  uid: 'FrontShopMobileBeautyBrandsNavNode',
                  link: '/all-brands',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Popular Brands',
                      uid: 'FrontShopMobileBeautyBrandsPopularShopByBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dyson',
                          uid: 'FrontShopMobileBeautyBrandsDysonPopularNavNode',
                          link: '/c/DYSON?nav=shop/beauty/shopbybrand/Dyson',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lancome',
                          uid: 'FrontShopMobileBeautyBrandsLancomePopularNavNode',
                          link: '/c/LANCOME?nav=shop/beauty/shopbybrand/Lancome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'R.E.M. Beauty',
                          uid: 'FrontShopMobileBeautyBrandsREMBeautyPopularNavNode',
                          link: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'La Roche Posay',
                          uid: 'FrontShopMobileBeautyBrandsLaRochePosayPopularNavNode',
                          link: '/c/LA,ROCHE,POSAY?nav=shop/beauty/shopbybrand/LaRochePosay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'CeraVe',
                          uid: 'FrontShopMobileBeautyBrandsCeraVePopularNavNode',
                          link: '/c/CERAVE?nav=shop/beauty/shopbybrand/CeraVe',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Quo Beauty',
                          uid: 'FrontShopMobileBeautyBrandsQuoBeautyPopularNavNode',
                          link: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/QuoBeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Olay',
                          uid: 'FrontShopMobileBeautyBrandsOlayPopularNavNode',
                          link: '/c/OLAY?nav=shop/beauty/shopbybrand/Olay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'LOreal',
                          uid: 'FrontShopMobileBeautyBrandsLOrealPopularNavNode',
                          link: "/c/L'OREAL?nav=shop/beauty/shopbybrand/LOreal",
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Brands',
                      uid: 'FrontShopMobileBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopMobileBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA,MERCIER?nav=shop/beauty/shopbybrand/LauraMercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopMobileBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopMobileBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=shop/beauty/shopbybrand/Versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopMobileBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopMobileBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO,FACED?nav=shop/beauty/shopbybrand/TooFaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopMobileBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=shop/beauty/shopbybrand/Foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopMobileBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=shop/beauty/shopbybrand/NARS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopMobileBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopMobileBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Personal Care',
              uid: 'FrontShopMobilePersonalCareNavNode',
              link: '/Shop/Catégories/PersonalCare/c/FS-PC?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Bath & Body Care',
                  uid: 'FrontShopMobilePersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Body Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Butters',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Lotions',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Firming & Stretch Mark Creams',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Oils',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Shower',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Wash & Shower Gels',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Soaks & Bubble Bath',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Scrubs',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Accessories',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hand & Foot Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hand Soaps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Sanitizers',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Creams & Lotions',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balms',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Deodorant & Antiperspirant',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Deodorant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Powder',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bath & Body Gifts & Sets',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Bath & Body Care',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath & Body Care',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Intimate Care',
                  uid: 'FrontShopMobilePersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Pads & Panty Liners',
                      uid: 'FrontShopMobilePersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Intimate Cleaning & Deodorants',
                      uid: 'FrontShopMobilePersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopMobilePersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cups',
                      uid: 'FrontShopMobilePersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Intimate Care',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intimate Care',
                          uid: 'FrontShopMobilePersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bladder Control & Incontinence',
                  uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Incontinence Pads & Liners',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Protective Underwear & Briefs',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Oral Care',
                  uid: 'FrontShopMobilePersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toothbrushes',
                      uid: 'FrontShopMobilePersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric toothbrushes',
                          uid: 'FrontShopMobilePersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothbrushes',
                          uid: 'FrontShopMobilePersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Oral Care Products',
                      uid: 'FrontShopMobilePersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dental Care',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopMobilePersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothpaste',
                          uid: 'FrontShopMobilePersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Teeth Whitening',
                          uid: 'FrontShopMobilePersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breath Fresheners',
                          uid: 'FrontShopMobilePersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mouthwash & Rinses',
                          uid: 'FrontShopMobilePersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Floss',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Oral Care',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Care',
                          uid: 'FrontShopMobilePersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shaving & Hair Removal',
                  uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving Creams & Gels',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Waxes & Removal Creams',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Electric Shavers',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Disposable Razors & Blades',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Removal Devices',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Grooming Accessories',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopMobilePersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopMobilePersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopMobilePersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobilePersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razors & Blades',
                          uid: 'FrontShopMobilePersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobilePersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopMobilePersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving & Grooming Tools & Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Removal Devices',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Wardrobe Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Jewellery',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bra Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hosiery & Tights',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Socks',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Travel Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weather Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Travel Sized Items',
                  uid: 'FrontShopMobilePersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Insect & Pest Control',
                  uid: 'FrontShopMobilePersonalCareInsectPestControlNavNode',
                  link: '/Shop/Categories/Personal-Care/Insect-%26-Pest-Control/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Health',
              uid: 'FrontShopMobileHealthNavNode',
              link: '/Shop/Catégories/Health/c/FS-HT?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Medicine & Treatments',
                  uid: 'FrontShopMobileHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Cough, Cold & Flu',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cough, Cold & Flu Medication',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care & Sleep Aids',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermometers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Pain Relief',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Oral Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hot & Cold Treatment',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topical Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Digestive Health',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Digestive Intolerance',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'First Aid',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandaging Supplies & Tape',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptics',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'First Aid Supplies',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Medical Supports & Garments',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allergy & Sinus',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistamines',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Diabetes Care',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Glucose Testing',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sleep Aids',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pill Organization',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Personal Protective Equipment ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Personal Protective Equipment',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Advil Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAdvilPainReliefFeaturedCollectionNavNode',
                          link: '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/medicineandtreatments/featuredcollections/advilpainrelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamins & Supplements',
                  uid: 'FrontShopMobileHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamins',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Adults Multivitamins',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Supplements',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Omega Fish Oils & Essential Fatty Acids',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Joint Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair, Nails & Skin Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Melatonin',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Health Food Supplements',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homeopathy',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Men's Health",
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Women's Health",
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Mineral Supplements',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Iron',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnesium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition & Weight Management',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Protein Bars & Snacks',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protein Liquid & Powder',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Webber Naturals for Sleep & Stress Relief',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_webbernaturals/wk09_featurecollectiontile_webber_enfr.png',
                            imageLink:
                              '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Webber Naturals For Sleep & Stress Relief',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWebberNaturalsFeaturedCollectionNavNode',
                          link: '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Vitalux Advanced Vitamins ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitalux Advanced Vitamins ',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Sexual Wellness & Familly Planning',
                  uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Sexual Wellness',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubricants & Intimate Massage Oils',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Adult Toys',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptives',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Family Planning',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pregnancy Tests',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ovulation Kits & Tests',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sexual Wellness Gifts',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Eye, Ear & Foot Care',
                  uid: 'FrontShopMobileHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Care Accessories',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health Supplements',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeglasses',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contact Lens Solution',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Foot Care',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Inserts, Insoles & Cushions',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Odor & Wetness Control',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Swim Accessories',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home Health Care & Fitness',
                  uid: 'FrontShopMobileHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Compression Hosiery & Stockings',
                      uid: 'FrontShopMobileHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Scales, Pulse Oximeter &  Pedometers',
                      uid: 'FrontShopMobileHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Body Wellness & Massagers',
                      uid: 'FrontShopMobileHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bathroom Safety',
                      uid: 'FrontShopMobileHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Blood Pressure Monitors',
                      uid: 'FrontShopMobileHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cane & Crutches',
                      uid: 'FrontShopHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fitness Equipment & Accessories',
                      uid: 'FrontShopMobileHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-%26-Accessories/c/FS-HT-H700',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Baby & Child',
              uid: 'FrontShopMobileBabyAndChildNavNode',
              link: '/Shop/Catégories/BabyAndChild/c/FS-BC?nav=/shop/baby',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Baby & Child Care',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Diapers & Wipes',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Diapers',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Training Pants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Rash Treatment',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Pails Refills',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Wipes',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Body Care',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Lotions',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bath & Shampoos',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotton Swabs',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Oil',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Powders',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Children's Health Care",
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Children's Cough Cold & Flu",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Childproofing & Safety',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Toys',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Clothing & Accessories',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Baby Gifts & Sets',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Feeding & Formula',
                  uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Baby Food & Formula',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formula',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Food & Toddler Snacks',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Cereal',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pediatric Nutrition',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nursing & Mealtime',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Breastfeeding Essentials',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toddler Feeding Accessories',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bottles & Nipples',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pacifier & Teething',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Toys',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Home & Electronics',
              uid: 'FrontShopMobileHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/magasiner/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Electronics',
                  uid: 'FrontShopMobileHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/HomeAndElectronics/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headphones & Earbuds',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Speakers',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Batteries',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Specialty Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alkaline Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hearing Aid Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cameras & Phone Accessories',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cameras & Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Phones & Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Memory cards',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Computers & Smart Tech',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Connected Home',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Notebooks',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablets & eReaders',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Computer Accessories & Software',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Smart Watches & GPS',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-%26-Smart-Tech/Smartwatches/c/FS-EL-505',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Video Games',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles & Gaming Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Games',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home & Lifestyle',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Candles',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffusers',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Greeting Cards',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareGreetingsCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Seasonal Shop',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Refreshing Scents',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Refreshing Scents',
                          uid: 'FrontShopMobileHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Appliances',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Bedding & Mattresses',
                  uid: 'FrontShopMobileHomeAndElectronicsBeddingNavNode',
                  link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mattresses',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingMattressesNavNode',
                      link: ' https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Bedding/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pillows',
                      uid: 'FrontShopMobileHomeAndElectronicsPillowsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weighted Blankets & Covers',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Seasonal Shop',
                  uid: 'FrontShopMobileHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Categories/Home-%26-Electronics/Home-%26-Lifestyle/Seasonal-Shop/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0&lang=en',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Electronics',
              uid: 'FrontShopMobileElectronicsNavNode',
              link: '/Shop/Catégories/Electronics/c/FS-EL?nav=/shop/electronics',
              hasChildren: false,
              __typename: 'CmsNode',
              child: null,
            },
            {
              name: 'Offers',
              uid: 'FrontShopMobileOffersNavNode',
              link: '/Shop/Catégories/Offers/c/FS-Offers?nav=/shop/offers',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Sale',
                  uid: 'FrontShopMobileOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance',
                  uid: 'FrontShopMobileOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AClearance%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase',
                  uid: 'FrontShopMobileOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AGift%2Bwith%2BPurchase%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'PC Optimum Offers',
                  uid: 'FrontShopMobileOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Health & Wellness',
          uid: 'FrontShopMobileHealthAndWellnessNavNode',
          link: 'https://www.pharmaprix.ca/en/health-and-wellness',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Electronics',
          uid: 'FrontShopMobileElectronicsNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopMobilePromotionsNavNode',
          link: 'https://magasiner.pharmaprix.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopMobilePCOptimumNavNode',
          link: 'https://www1.pharmaprix.ca/en/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
    },
    fr: {
      navigation: [
        {
          name: 'Magasiner',
          uid: 'FrontShopShopNavNode',
          link: 'https://magasiner.pharmaprix.ca/?lang=fr&_ga=2.193804901.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Temps des Fêtes',
              uid: 'FrontShopHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Découvrir les Fêtes',
                  uid: 'FrontShopHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Nos choix',
                  uid: 'FrontShopHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Exclusivités en ligne',
                  uid: 'FrontShopHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Cadeaux par prix",
                  uid: 'FrontShopHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Moins de 25 $',
                      uid: 'FrontShopHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Moins de 50 $',
                      uid: 'FrontShopHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Beauté',
                  uid: 'FrontShopHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Maquillage',
                      uid: 'FrontShopHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Produits de soin de la peau',
                      uid: 'FrontShopHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums',
                      uid: 'FrontShopHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins capillaires',
                      uid: 'FrontShopHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires',
                      uid: 'FrontShopHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et Maison',
                      uid: 'FrontShopHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Les Fêtes Quo Beauty',
                      uid: 'FrontShopHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Calendriers de l’Avent',
                      uid: 'FrontShopHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections Découverte',
                      uid: 'FrontShopHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coffrets économiques',
                      uid: 'FrontShopHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Soins personnels',
                  uid: 'FrontShopHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux Techno',
                  uid: 'FrontShopHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Jeux audio et vidéo',
                      uid: 'FrontShopHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Maison intelligente',
                      uid: 'FrontShopHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Bien-être',
                  uid: 'FrontShopHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Boutique pour hommes',
                  uid: 'FrontShopHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Parfums pour hommes',
                      uid: 'FrontShopHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Boutique pour hommes',
                      uid: 'FrontShopHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique pour enfants',
                  uid: 'FrontShopHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux pour animaux de compagnie',
                  uid: 'FrontShopHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Pour le bas de Noël',
                  uid: 'FrontShopHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux saisonniers et pour la maison',
                  uid: 'FrontShopHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Des choix bien réfléchis',
                  uid: 'FrontShopHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cartes de souhaits',
                  uid: 'FrontShopHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauté',
              uid: 'FrontShopBeautyNavNode',
              link: '/Beaute?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Cadeaux et ensembles',
                  uid: 'FrontShopBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins capillaires',
                      uid: 'FrontShopBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles de luxe',
                          uid: 'FrontShopBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles dermato',
                          uid: 'FrontShopBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de Beauté',
                      uid: 'FrontShopBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et cadeaux pour la maison',
                      uid: 'FrontShopBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux Par Prix',
                      uid: 'FrontShopBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sous 25$',
                          uid: 'FrontShopBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 50$',
                          uid: 'FrontShopBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 100$',
                          uid: 'FrontShopBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sur 100$',
                          uid: 'FrontShopBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Coffrets-cadeaux rapport prix',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Coffrets-cadeaux rapport prix',
                          uid: 'FrontShopBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "Calendriers de l'Avent",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Calendriers de l'Avent",
                          uid: 'FrontShopBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles de luxe',
                          uid: 'FrontShopBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles dermato',
                          uid: 'FrontShopBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Maquillage',
                  uid: 'FrontShopBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers?nav=/shop/Categories/Makeup/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Visage',
                      uid: 'FrontShopBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fonds de teint',
                          uid: 'FrontShopBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes BB et CC',
                          uid: 'FrontShopBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Correcteurs',
                          uid: 'FrontShopBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases',
                          uid: 'FrontShopBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres',
                          uid: 'FrontShopBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à joues',
                          uid: 'FrontShopBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits bronzants',
                          uid: 'FrontShopBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contouring',
                          uid: 'FrontShopBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Illuminateurs',
                          uid: 'FrontShopBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fixateurs de maquillage',
                          uid: 'FrontShopBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Yeux',
                      uid: 'FrontShopBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascaras',
                          uid: 'FrontShopBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à paupières',
                          uid: 'FrontShopBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traceurs',
                          uid: 'FrontShopBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases pour les yeux',
                          uid: 'FrontShopBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sourcils',
                          uid: 'FrontShopBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Faux cils',
                          uid: 'FrontShopBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lèvres',
                      uid: 'FrontShopBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rouges à lèvres',
                          uid: 'FrontShopBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brillants à lèvres',
                          uid: 'FrontShopBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Encres à lèvres',
                          uid: 'FrontShopBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Repulpeurs à lèvres',
                          uid: 'FrontShopBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baumes et traitements pour les lèvres',
                          uid: 'FrontShopBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crayons contour des lèvres',
                          uid: 'FrontShopBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Palettes de maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ongles',
                      uid: 'FrontShopBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Vernis à ongles',
                          uid: 'FrontShopBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Couches de base et de finition',
                          uid: 'FrontShopBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maquillage de Luxe',
                          uid: 'FrontShopBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Maquillage dermato',
                          uid: 'FrontShopBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Maquillage',
                          uid: 'FrontShopBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de maquillage',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de maquillage',
                          uid: 'FrontShopBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux des Fêtes Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux des Fêtes Quo Beauty',
                          uid: 'FrontShopBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins de la peau',
                  uid: 'FrontShopBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers?nav=/shop/Categories/SkinCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hydratants pour le visage',
                      uid: 'FrontShopBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes de nuit',
                          uid: 'FrontShopBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brumes pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nettoyants',
                      uid: 'FrontShopBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/c/FS-S201?nav=shop/Catrgories/SkinCare/Cleansers/FaceWashAndCleansers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants et gommages pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toniques',
                          uid: 'FrontShopBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Traitements',
                      uid: 'FrontShopBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sérums',
                          uid: 'FrontShopBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins anti-âge',
                          uid: 'FrontShopBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins éclaircissants',
                          uid: 'FrontShopBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Traitements contre l'acné",
                          uid: 'FrontShopBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masques',
                      uid: 'FrontShopBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Masques pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques en feuille',
                          uid: 'FrontShopBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins contour des yeux',
                      uid: 'FrontShopBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes et traitements pour les lèvres',
                      uid: 'FrontShopBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le corps',
                          uid: 'FrontShopBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins de la peau pour le corps',
                      uid: 'FrontShopBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soin de la peau de luxe',
                          uid: 'FrontShopBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin de la peau dermato',
                          uid: 'FrontShopBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins de la peau',
                          uid: 'FrontShopBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Outil d'analyse",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P1/WK02/CollectionTile/FR/wk02_featuredcollectiontile_skintool_b1_fr.png',
                            imageLink: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/skindiagnostic',
                            __typename: 'NavPromoNode',
                          },
                          name: "Outil d'analyse",
                          uid: 'FrontShopBeautySkinCareSkinDiagnosticFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Magasiner les soins de la peau selon les ingrédients',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_p3clinical_skincare/wk09_featurecollecctiontile_p3clinicalskincare_enfr.png',
                            imageLink:
                              '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Magasiner les soins de la peau selon les ingrédients',
                          uid: 'FrontShopBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins de la peau',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins de la peau',
                          uid: 'FrontShopBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins capillaires',
                  uid: 'FrontShopBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers?nav=/shop/Categories/HairCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampooings et revitalisants',
                      uid: 'FrontShopBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampooing',
                          uid: 'FrontShopBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Revitalisant',
                          uid: 'FrontShopBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shampooing sec',
                          uid: 'FrontShopBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Type de cheveux',
                      uid: 'FrontShopBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fins et plats',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Raides',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ondulés et frisés',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rêches et épais',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Préoccupation capillaire',
                      uid: 'FrontShopBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brillance',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Abîmé',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des frisottis',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sécheresse et pellicules',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volume',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits coiffants et traitements',
                      uid: 'FrontShopBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Traitements capillaires',
                          uid: 'FrontShopBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques capillaires',
                          uid: 'FrontShopBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateur pour cheveux',
                          uid: 'FrontShopBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mousse capillaire',
                          uid: 'FrontShopBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cire et gel pour cheveux',
                          uid: 'FrontShopBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour perte et croissance des cheveux',
                          uid: 'FrontShopBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Colorants capillaires',
                      uid: 'FrontShopBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Colorants capillaires permanents',
                          uid: 'FrontShopBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Retouche des racines',
                          uid: 'FrontShopBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Colorants capillaires temporaires',
                          uid: 'FrontShopBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-T500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles pour les cheveux',
                      uid: 'FrontShopBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins capilaires de luxe',
                          uid: 'FrontShopBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins capilaires dermato',
                          uid: 'FrontShopBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins capillaires',
                          uid: 'FrontShopBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins capillaire',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins capillaire',
                          uid: 'FrontShopBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Parfums',
                  uid: 'FrontShopBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers?nav=/shop/Categories/Fragrance/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour elles',
                      uid: 'FrontShopBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs et brumes parfumées pour le corps',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour elle',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour lui',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Bougies et parfums d'ambiance",
                      uid: 'FrontShopBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums à bille et en format de voyage',
                      uid: 'FrontShopBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums de luxe',
                          uid: 'FrontShopBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de parfums',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-fragrance-gifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de parfums',
                          uid: 'FrontShopBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers?nav=/shop/Categories/ToolsAndAccessories/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour les cheveux',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et bandanas',
                          uid: 'FrontShopBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de luxe',
                          uid: 'FrontShopBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires dermato',
                          uid: 'FrontShopBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Outils de coiffage pros',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2020/evergreen/collection-tiles/menufeaturedtile_toolsaccessories_b1_fr.jpg',
                            imageLink:
                              '/c/FS-T400?nav=/shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Outils de coiffage pros',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Outils et accessoires de Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/Evergreen/collection-tiles-nav/quo/wk16_featurecollectiontile_quo-tools-accessories_enfr.png',
                            imageLink:
                              '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Outils et accessoires de Quo Beauty',
                          uid: 'FrontShopBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Boutique masculine',
                  uid: 'FrontShopBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers?nav=/shop/Categories/Mens/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins de la peau pour lui',
                      uid: 'FrontShopBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nettoyants et accessoires',
                          uid: 'FrontShopBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements',
                          uid: 'FrontShopBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baume à lèvres',
                          uid: 'FrontShopBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité',
                          uid: 'FrontShopBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et produits de rasage',
                          uid: 'FrontShopBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-rasage',
                          uid: 'FrontShopBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins capillaires pour lui',
                      uid: 'FrontShopBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins masculins de luxe',
                          uid: 'FrontShopBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins masculins dermato',
                          uid: 'FrontShopBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins pour hommes',
                          uid: 'FrontShopBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux pour hommes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux pour hommes',
                          uid: 'FrontShopBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Magasiner par Marques',
                  uid: 'FrontShopBeautyShopByBrandsNavNode',
                  link: '/all-brands?nav=shop/beauty/shopallbrand',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Marques Populaires',
                      uid: 'FrontShopBeautyBrandsPopularBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'DysonName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_dyson.png',
                            imageLink: '/c/DYSON?nav=/brands/dyson',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Dyson',
                          uid: 'FrontShopBeautyBrandsdysonPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LancomeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_lancome.png',
                            imageLink: '/c/LANCOME?nav=/brands/lancome',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Lancome',
                          uid: 'FrontShopBeautyBrandsLancomePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'REMName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.amazonaws.com/site-creative/2022/beauty-brand-tiles/menubrandtile_rembeauty.png',
                            imageLink: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                            __typename: 'NavPromoNode',
                          },
                          name: 'REM',
                          uid: 'FrontShopBeautyBrandsREMPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LaRochePosayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_laorocheposay.png',
                            imageLink: '/c/LA%2CROCHE%2CPOSAY?nav=/brands/larocheposay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'La Roche Posay',
                          uid: 'FrontShopBeautyBrandsLaRochePosayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'CeraVeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_cerave.png',
                            imageLink: '/c/CERAVE?nav=/brands/cerave',
                            __typename: 'NavPromoNode',
                          },
                          name: 'CeraVe',
                          uid: 'FrontShopBeautyBrandsCeraVePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'OlayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_olay.png',
                            imageLink: '/c/OLAY?nav=/brands/olay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Olay',
                          uid: 'FrontShopBeautyBrandsOlayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'QuoBeautyName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_quobeauty.png',
                            imageLink: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/quobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty',
                          uid: 'FrontShopBeautyBrandsQuoBeautyPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LOrealName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_loreal.png',
                            imageLink: '/c/L%27OREAL?nav=/brands/loreal',
                            __typename: 'NavPromoNode',
                          },
                          name: "L'Oreal",
                          uid: 'FrontShopBeautyBrandsLOrealPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Marques en vedette',
                      uid: 'FrontShopBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA%2CMERCIER?nav=/brands/lauramercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO%2CFACED?nav=/brands/toofaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=/brands/foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=/brands/nars',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Soins personnels',
              uid: 'FrontShopPersonalCareNavNode',
              link: '/Soins-personnels?nav=/magasiner/soinspersonnels',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Produits pour le corps et le bain',
                  uid: 'FrontShopPersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soins corporels',
                      uid: 'FrontShopPersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et beurres pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes raffermissantes et pour les vergetures',
                          uid: 'FrontShopPersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopPersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bain et douche',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le corps et gels de douche',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sels de bains et bain moussant',
                          uid: 'FrontShopPersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants corporels',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de bain',
                          uid: 'FrontShopPersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des mains et des pieds',
                      uid: 'FrontShopPersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Savons à main',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions et crèmes pour les mains',
                          uid: 'FrontShopPersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils de soins des pieds',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Désinfectants pour les mains',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et masques pour les pieds',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes pour les lèvres',
                      uid: 'FrontShopPersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Déodorant et antisudorifique',
                      uid: 'FrontShopPersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Déodorant',
                          uid: 'FrontShopPersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eau parfumante et poudre pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Protection solaire',
                      uid: 'FrontShopPersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écran solaire pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopPersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopPersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour le bain et le corps',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits pour le bain et le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux de soins personnels ',
                      uid: 'FrontShopPersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: '/c/PersonalCareHoliday?nav=/shop/Categories/Holiday/PersonalCareGifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins pour le corps et le bain',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_bathandbodycare/wk13_featurecollecctiontile_bath-body-care_enfr.png',
                            imageLink:
                              '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins pour le corps et le bain',
                          uid: 'FrontShopPersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins intimes',
                  uid: 'FrontShopPersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Serviettes hygiéniques et protège-dessous',
                      uid: 'FrontShopPersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Nettoyants et désodorisants pour hygiène intime',
                      uid: 'FrontShopPersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopPersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coupe menstruelle',
                      uid: 'FrontShopPersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits soins intimes ',
                          uid: 'FrontShopPersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins intimes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_intimatecare/wk05_featurecollecctiontile_intimatecare_enfr.png',
                            imageLink:
                              '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins intimes',
                          uid: 'FrontShopPersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Contrôle de la vessie & incontinence',
                  uid: 'FrontShopPersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Doublures et serviettes pour incontinence',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sous-vêtements protecteurs',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareBladderControlFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: ' Nouveau! Hygiène féminine Thinx ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_thinx/wk25_featurecollecctiontile_thinx_enfr.png',
                            imageLink:
                              '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollections/Thinx',
                            __typename: 'NavPromoNode',
                          },
                          name: ' New! Thinx Feminine Hygiene \t Nouveau! Hygiène féminine Thinx ',
                          uid: 'FrontShopPersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                          link: '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollection/Thinx',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: ' Nouveau! Hygiène féminine Thinx ',
                          uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                          link: '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollections/Thinx',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins dentaires',
                  uid: 'FrontShopPersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Brosses à dents',
                      uid: 'FrontShopPersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brosses à dents électriques',
                          uid: 'FrontShopPersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses à dents',
                          uid: 'FrontShopPersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits de soins dentaires',
                      uid: 'FrontShopPersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rince-bouches',
                          uid: 'FrontShopPersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rafraîchisseurs d’haleine',
                          uid: 'FrontShopPersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins dentaires',
                          uid: 'FrontShopPersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopPersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dentifrice',
                          uid: 'FrontShopPersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blanchissement des dents',
                          uid: 'FrontShopPersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soie dentaire',
                          uid: 'FrontShopPersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins buccodentaires',
                          uid: 'FrontShopPersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins buccaux',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_oralcare/wk05_featurecollecctiontile_oralcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins buccaux',
                          uid: 'FrontShopPersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Rasage et épilation',
                  uid: 'FrontShopPersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Crèmes et gels de rasage',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cires et crèmes dépilatoires',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoir électrique',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoirs et lames jetables',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Appareils dépilatoires',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires de toilette',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Rasage et épilation',
                            imageUrl:
                              ' https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P6/wk21/front-shop/featurecollectiontile_shavinghairremoval/wk21_featurecollecctiontile_shavinghair_enfr.png',
                            imageLink:
                              '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Rasage et épilation',
                          uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Pour hommes',
                  uid: 'FrontShopPersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopPersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes & gels de rasage',
                          uid: 'FrontShopPersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopPersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopPersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopPersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Soins personnels pour hommes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P6/wk21/front-shop/featurecollectiontile_menselfcare/wk21_featurecollecctiontile_menselfcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-M101?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/Mens/FeaturedCollections/MensSelfCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins personnels pour hommes',
                          uid: 'FrontShopPersonalCareMenSelfCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-M101?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Mens/ShavingForHim/FeaturedCollections/SelfCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopPersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles à cheveux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de rasage et accessoires de toilette',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rasoirs électriques',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils dépilatoires',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de garde-robe',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bijoux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soutiens-gorge accessoires',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bas et collants',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Chaussettes',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’hiver',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’hiver',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de voyage',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires météorologiques',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareToolsAccessFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Articles format voyage',
                  uid: 'FrontShopPersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareTravelSizedItemsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Lutte contre les insectes et animaux nuisibles',
                  uid: 'FrontShopPersonalCareInsectPestControlNavNode',
                  link: '/Shop/Catégories/Soins-personnels/Lutte-contre-les-insectes-et-animaux-nuisiblesLutte-contre-les-insectes-et-animaux-nuisibles/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Santé',
              uid: 'FrontShopHealthNavNode',
              link: '/Santé?nav=/magasiner/santé',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Médicaments et traitements',
                  uid: 'FrontShopHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toux, rhume et grippe',
                      uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe',
                          uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins nasaux et aides-sommeil',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermomètres',
                          uid: 'FrontShopHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Organisation des médicaments',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soulagement de la douleur',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Topiques pour le soulagement de la douleur',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement chaud et froid',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement contre la douleur buccale',
                          uid: 'FrontShopHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Premiers soins',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fournitures pour pansements et ruban',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fournitures de premiers soins',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Articles de contention et vêtements médicaux',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la peau',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sinus et allergies',
                      uid: 'FrontShopHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistaminiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé digestive',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intolérance digestive',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Aides au sommeil',
                      uid: 'FrontShopHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins pour les diabétiques',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDiabeticCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins de la peau pour diabétiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabeticSkincareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Test de glycémie',
                          uid: 'FrontShopHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Équipement de protection individuelle ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Équipement de protection individuelle ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamines et suppléments',
                  uid: 'FrontShopHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Suppléments',
                      uid: 'FrontShopHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Huiles de poisson riches en oméga',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des yeux',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins des cheveux, des ongles et de la peau',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mélatonine',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments alimentaires naturels',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé du cœur',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homéopathie',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des articulations',
                          uid: 'FrontShopHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des hommes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des femmes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments de minéraux',
                      uid: 'FrontShopHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Magnésium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fer',
                          uid: 'FrontShopHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition et gestion du poids',
                      uid: 'FrontShopHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Barres protéinées et collations',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protéines liquides et en poudre',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Vitamines',
                      uid: 'FrontShopHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Multivitamines pour adultes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soutien du sommeil Webber Naturals',
                      uid: 'FrontShopHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: '/c/WEBBER-FS-HT-V209?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturalssleepsupport',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Vitamines Vitalux Advanced ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitamines Vitalux Advanced ',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bien-être sexuel et planification familiale',
                  uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bien-être sexuel',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubrifiants et huile pour massage intime',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jouets sexuels',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptifs',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Planification familiale',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Tests de grossesse',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses et tests d’ovulation',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux de bien-être sexuel ',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de bien-être sexuel ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de bien-être sexuel ',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins des yeux, des oreilles et des pieds',
                  uid: 'FrontShopHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soin des yeux',
                      uid: 'FrontShopHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Suppléments pour la santé oculaire',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour entretien des verres de contact',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Solution pour verres de contact',
                          uid: 'FrontShopHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lunettes',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Articles de soins des pieds',
                      uid: 'FrontShopHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Contrôle des odeurs et de l’humidité',
                          uid: 'FrontShopHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins des pieds',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coussinets et semelles intérieures',
                          uid: 'FrontShopHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins de santé à domicile et conditionnement physique',
                  uid: 'FrontShopHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bas et chaussettes de compression',
                      uid: 'FrontShopHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Balances, saturomètre et podomètres',
                      uid: 'FrontShopHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bien-être et appareils de massage',
                      uid: 'FrontShopHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sécurité pour la salle de bain',
                      uid: 'FrontShopHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tensiomètres',
                      uid: 'FrontShopHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Équipements et accessoires de conditionnement physique',
                      uid: 'FrontShopHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-&-Accessories/c/FS-HT-H700?nav=/shop/Categories/HomeHealthCare/FitnessEquipmentAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthHomeHealthCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Bébé et enfant',
              uid: 'FrontShopBabyAndChildNavNode',
              link: '/Bébé-et-enfant?nav=/magasiner/bébéetenfant',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Soins pour bébés et enfants',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Couches et lingettes',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Couches',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Culottes d'entraînement",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre l’érythème fessier',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Recharges pour poubelles à couches ',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lingettes pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour le corps et le bain',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et lotions pour le corps',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits pour le bain et shampooings',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotons-tiges',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huile pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé des enfants',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe pour enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sécurité et protection des enfants',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Jouets',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Vêtements et accessoires',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour bébés',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Alimentation et préparations',
                  uid: 'FrontShopBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Aliments et préparations pour bébés',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formule',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Aliments pour bébés et collations pour tout-petits',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Céréales pour bébés',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alimentation pédiatrique',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allaitement et heure du repas',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’alimentation des tout-petits',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Biberons et tétines',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suces et jouets de dentition',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Essentiels pour l’allaitement',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: ' Nouvelle préparation pour nourrissons',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNewInfantFormulaNavNode',
                      link: 'c/FS-BC-F101?&sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/BabyAndChild/FeedingAndFormula/FeaturedCollections/NewInfantFormula',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Nouvelle préparation pour nourrissons',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNewInfantFormulaNavNode',
                      link: 'c/FS-BC-F101?&sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/BabyAndChild/FeedingAndFormula/FeaturedCollections/NewInfantFormula',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Jouets',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Maison et électronique',
              uid: 'FrontShopHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/magasiner/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Électronique',
                  uid: 'FrontShopHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Jeux vidéo',
                      uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles et accessoires de jeux',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jeux',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Accessoires de téléphone et d'appareil photo",
                      uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Appareils photos et accessoires',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Téléphones et accessoires',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cartes mémoire',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ordinateurs Et Technologies Connectées',
                      uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maison connectée',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Carnets',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablettes et lecteurs électroniques',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour ordinateurs et logiciels',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Montres intelligentes et GPS',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-&-Smart-Tech/Smartwatches/c/FS-EL-505?nav=/shop/Categories/Electronics/SmartWatchesAndGPS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Produits électroniques Apple',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P3/WK12/menu-featuretile/menufeaturetile_apple_enfr.jpg',
                            imageLink: '/c/APPLE?nav=/shop/electronicselectronicsapplefeaturedcollection',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Produits électroniques Apple',
                          uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionAppleNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Maison et style de vie',
                  uid: 'FrontShopHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bougies ',
                      uid: 'FrontShopHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffuseurs',
                      uid: 'FrontShopHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: null,
                      uid: 'FrontShopHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Saisonnier',
                      uid: 'FrontShopHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Parfums rafraîchissants',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Parfums rafraîchissants',
                          uid: 'FrontShopHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Électroménagers',
                  uid: 'FrontShopHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Linge de lit et matelas',
                  uid: 'FrontShopHomeAndElectronicsBeddingNavNode',
                  link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Matelas',
                      uid: 'FrontShopHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Bedding/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Oreillers',
                      uid: 'FrontShopHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Couvertures lestées et housses de couette',
                      uid: 'FrontShopHomeAndElectronicsWeightedBlanketsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique saisonnière',
                  uid: 'FrontShopHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Cat%C3%A9gories/Maison-et-%C3%A9lectronique/Maison-et-style-de-vie/Saisonnier/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offres',
              uid: 'FrontShopOffersNavNode',
              link: '/c/FS-Offers?nav=/shop/offers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Solde',
                  uid: 'FrontShopOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Liquidation',
                  uid: 'FrontShopOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/clearance&q=:trending:promotions:Clearance:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeau avec achat',
                  uid: 'FrontShopOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/GWP&q=:trending:promotions:Gift+with+Purchase:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Offres PC Optimum',
                  uid: 'FrontShopOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Ordonnances',
          uid: 'FrontShopPrescriptionNavNode',
          link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Services pharmaceutiques',
          uid: 'FrontShopPharmacyServicesLocaledLink',
          link: 'https://www.pharmaprix.ca/fr/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Santé et bien-être',
          uid: 'FrontShopHealthAndWellnessLocaledLink',
          link: 'https://www.pharmaprix.ca/fr/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Électroniques',
          uid: 'FrontShopElectronicsNavNode',
          link: 'https://www1.pharmaprix.ca/fr/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopPromotionsNavNode',
          link: 'https://magasiner.pharmaprix.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopPCOptimumNavNode',
          link: 'https://www1.pharmaprix.ca/fr/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Autres services de Pharmaprix',
          uid: 'FrontShopMoreByShoppersNavNode',
          link: 'https://www1.pharmaprix.ca/fr/more-by-pharmaprix',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
      footer: [
        {
          name: 'Magasiner par catégorie populaire',
          link: null,
          uid: 'FrontShopFooterShopNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Beauté',
              link: '/Beauté',
              uid: 'FrontShopFooterShopBeautyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Soins Personnels',
              link: '/c/FS-PC?nav=%2Fshop%2Fpersonal&sort=trending&page=0',
              uid: 'FrontShopFooterShopPersonalCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Santé',
              link: '/c/FS-HT?nav=%2Fshop%2Fhealth&sort=trending&page=0',
              uid: 'FrontShopFooterShopHealthNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Bébé et enfant',
              link: '/c/FS-BC?nav=%2Fshop%2Fbaby&sort=trending&page=0',
              uid: 'FrontShopFooterShopBabyAndChildNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Électronique',
              link: '/c/FS-EL?nav=%2Fshop%2Felectronics&sort=trending&page=0',
              uid: 'FrontShopFooterShopElectronicsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Offres',
              link: '/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0',
              uid: 'FrontShopFooterShopOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Maquillage',
              link: '/shop/Categories/Makeup/c/FS-MakeUp',
              uid: 'FrontShopFooterShopMakeupNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Soins de la peau',
              link: '/shop/Categories/Makeup/c/FS-SkinCare',
              uid: 'FrontShopFooterShopSkinCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'MOCKE',
              link: '/shop/Categories/Makeup/c/FS-Mock',
              uid: 'FrontShopFooterShopMOCKNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Service à la clientèle',
          link: null,
          uid: 'FrontShopFooterCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Contactez nous',
              link: '/contactus',
              uid: 'FrontShopFooterContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Retours et échanges',
              link: '/returns',
              uid: 'FrontShopFooterReturnsExchangesNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: '/faq',
              uid: 'FrontShopFooterFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Livraison et gestion des commandes',
              link: '/shipping',
              uid: 'FrontShopFooterShippingHandlingNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Historique des commandes',
              link: '/my-account/orders',
              uid: 'FrontShopFooterOrderHistoryNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Des offres',
          link: null,
          uid: 'FrontShopFooterOffersNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Voir la circulaire',
              link: 'https://www1.shoppersdrugmart.ca/fr/pcoptimum/in-store-offers',
              uid: 'FrontShopFooterVieweflyerNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Voir toutes les offres exclusives en magasin',
              link: 'https://www1.shoppersdrugmart.ca/fr/flyer',
              uid: 'FrontShopFooterInstoreExclusiveOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Programme PC Optimum',
          link: null,
          uid: 'FrontShopFooterPCOptimumProgramNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Inscrivez-vous',
              link: 'https://www.pcoptimum.ca/register?sid=home|missrewards|getstarted2',
              uid: 'FrontShopFooterJoinNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Ouvrir une session',
              link: 'https://accounts.pcid.ca/login',
              uid: 'FrontShopFooterSignInNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://loblaw.force.com/PCoptimumsupport/s/?language=fr',
              uid: 'FrontShopFooterOptimumFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Voir toutes les offres PC Optimum',
              link: 'https://www.pcoptimum.ca/',
              uid: 'FrontShopFooterViewOptimuOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'À propos de Shoppers Drug Mart',
          link: null,
          uid: 'FrontShopFooterAboutShoppersDrugMartNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Nouvelles et annonces',
              link: 'https://www1.shoppersdrugmart.ca/fr/news',
              uid: 'FrontShopFooterNewsAndAnnouncementsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Notre entreprise',
              link: 'https://corporate.shoppersdrugmart.ca/fr-ca/Home.aspx',
              uid: 'FrontShopFooterCorporateNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: "Nouvelles de l'entreprise",
              link: 'https://media.loblaw.ca/French/centre-media/communiques-de-presse/default.aspx',
              uid: 'FrontShopFooterCorporateNewsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Responsabilité sociale',
              link: 'https://www1.shoppersdrugmart.ca/fr/love-you',
              uid: 'FrontShopFooterSocialResponsibilityNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Carrières',
              link: 'https://carrieres.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterCareersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Acquisition de pharmacie',
              link: 'http://corporate.shoppersdrugmart.ca/fr-ca/pharmacy-acquisition',
              uid: 'FrontShopFooterPharmacyAcquisitionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Information juridique',
              link: 'http://corporate.shoppersdrugmart.ca/fr-ca/legal',
              uid: 'FrontShopFooterLegalNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Confidentialité',
              link: 'https://www.loblaw.ca/fr/privacy.html',
              uid: 'FrontShopFooterPrivacyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Service Clients',
          link: null,
          uid: 'FrontShopFooterSDMCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Rappel de produit',
              link: 'https://www1.shoppersdrugmart.ca/fr/product-recall',
              uid: 'FrontShopFooterSDMProductRecallNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Contacter le support du magasin',
              link: 'https://www1.shoppersdrugmart.ca/fr/contact-us',
              uid: 'FrontShopFooterSDMContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Remboursements',
              link: 'https://www1.shoppersdrugmart.ca/fr/refunds',
              uid: 'FrontShopFooterSDMRefundsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: "Obtenir de l'aide",
              link: 'https://gethelp.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterSDMGetHelpNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'En magasin',
          link: null,
          uid: 'FrontShopFooterVisitAStoreNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Renouveler une ordonnance',
              link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
              uid: 'FrontShopFooterRenewOrRefillPrescriptionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Localisateur de magasin',
              link: 'https://stores.shoppersdrugmart.ca/fr/',
              uid: 'FrontShopFooterStoreLocatorNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Photo',
              link: 'https://www.shoppersphoto.ca/?lang=fr',
              uid: 'FrontShopFooterShoppersPhotoNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Maison et Santé',
              link: 'https://www.shoppershomehealthcare.ca/',
              uid: 'FrontShopFooterShoppersHomeHealthCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Cartes-cadeaux',
              link: 'https://www1.pharmaprix.ca/fr/food-and-home/gift-cards',
              uid: 'FrontShopFooterGiftCardNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
      ],
      navigationMobile: [
        {
          name: 'Ordonnances',
          uid: 'FrontShopMobilePrescriptionNavNode',
          link: 'https://access.eforms.pharmaprix.ca/photoordonnance/',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Services pharmaceutiques',
          uid: 'FrontShopMobilePharmacyServicesNavNode',
          link: 'https://www.pharmaprix.ca/fr/health-and-wellness/pharmacy-services',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Magasiner',
          uid: 'FrontShopMobileShopNavNode',
          link: '/?nav=home',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Temps des Fêtes',
              uid: 'FrontShopMobileHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Découvrir les Fêtes',
                  uid: 'FrontShopMobileHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Nos choix',
                  uid: 'FrontShopMobileHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Exclusivités en ligne',
                  uid: 'FrontShopMobileHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Cadeaux par prix",
                  uid: 'FrontShopMobileHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Moins de 25 $',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Moins de 50 $',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Beauté',
                  uid: 'FrontShopMobileHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Maquillage',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Produits de soin de la peau',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins capillaires',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et Maison',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Les Fêtes Quo Beauty',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Calendriers de l’Avent',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections Découverte',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coffrets économiques',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Soins personnels',
                  uid: 'FrontShopMobileHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux Techno',
                  uid: 'FrontShopMobileHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Jeux audio et vidéo',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Maison intelligente',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Bien-être',
                  uid: 'FrontShopMobileHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Boutique pour hommes',
                  uid: 'FrontShopMobileHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Parfums pour hommes',
                      uid: 'FrontShopMobileHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Boutique pour hommes',
                      uid: 'FrontShopMobileHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique pour enfants',
                  uid: 'FrontShopMobileHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux pour animaux de compagnie',
                  uid: 'FrontShopMobileHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Pour le bas de Noël',
                  uid: 'FrontShopMobileHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux saisonniers et pour la maison',
                  uid: 'FrontShopMobileHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Des choix bien réfléchis',
                  uid: 'FrontShopMobileHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cartes de souhaits',
                  uid: 'FrontShopMobileHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauté',
              uid: 'FrontShopMobileBeautyNavNode',
              link: '/Beaute?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Cadeaux et ensembles',
                  uid: 'FrontShopMobileBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins capillaires',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles de luxe',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles dermato',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyGiftAndSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils de Beauté',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Beauté naturelle',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNaturalBeautyNavNode',
                      link: '/c/NaturalBeauty?nav=beauty/giftsandsets/naturalbeauty',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et cadeaux pour la maison',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux Par Prix',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sous 25$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 50$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 100$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sur 100$',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Coffrets-cadeaux rapport prix',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Coffrets-cadeaux rapport prix',
                          uid: 'FrontShopMobileBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "Calendriers de l'Avent",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Calendriers de l'Avent",
                          uid: 'FrontShopMobileBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Maquillage',
                  uid: 'FrontShopMobileBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Visage',
                      uid: 'FrontShopMobileBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fonds de teint',
                          uid: 'FrontShopMobileBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes BB et CC',
                          uid: 'FrontShopMobileBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopMobileBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Correcteurs',
                          uid: 'FrontShopMobileBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases',
                          uid: 'FrontShopMobileBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres',
                          uid: 'FrontShopMobileBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à joues',
                          uid: 'FrontShopMobileBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits bronzants',
                          uid: 'FrontShopMobileBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contouring',
                          uid: 'FrontShopMobileBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Illuminateurs',
                          uid: 'FrontShopMobileBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopMobileBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fixateurs de maquillage',
                          uid: 'FrontShopMobileBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopMobileBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Yeux',
                      uid: 'FrontShopMobileBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascaras',
                          uid: 'FrontShopMobileBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à paupières',
                          uid: 'FrontShopMobileBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traceurs',
                          uid: 'FrontShopMobileBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sourcils',
                          uid: 'FrontShopMobileBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Faux cils',
                          uid: 'FrontShopMobileBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Palettes de maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopMobileBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBruorshesAndAccessies/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopMobileBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ongles',
                      uid: 'FrontShopMobileBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Vernis à ongles',
                          uid: 'FrontShopMobileBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Couches de base et de finition',
                          uid: 'FrontShopMobileBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopMobileBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopMobileBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Lèvres',
                      uid: 'FrontShopMobileBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rouges à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brillants à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Encres à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Repulpeurs à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baumes et traitements pour les lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crayons contour des lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maquillage de Luxe',
                          uid: 'FrontShopMobileBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Maquillage dermato',
                          uid: 'FrontShopMobileBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Maquillage',
                          uid: 'FrontShopMobileBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopMobileBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de maquillage',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux des Fêtes Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux des Fêtes Quo Beauty',
                          uid: 'FrontShopMobileBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins de la peau',
                  uid: 'FrontShopMobileBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hydratants pour le visage',
                      uid: 'FrontShopMobileBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopMobileBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=/shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes de nuit',
                          uid: 'FrontShopMobileBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=/shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=/shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopMobileBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=/shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brumes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopMobileBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=/shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nettoyants',
                      uid: 'FrontShopMobileBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants et gommages pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=/shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopMobileBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=/shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toniques',
                          uid: 'FrontShopMobileBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Traitements',
                      uid: 'FrontShopMobileBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sérums',
                          uid: 'FrontShopMobileBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=/shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins anti-âge',
                          uid: 'FrontShopMobileBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=/shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins éclaircissants',
                          uid: 'FrontShopMobileBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=/shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Traitements contre l'acné",
                          uid: 'FrontShopMobileBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=/shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=/shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masques',
                      uid: 'FrontShopMobileBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Masques pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=/shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques en feuille',
                          uid: 'FrontShopMobileBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=/shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins contour des yeux',
                      uid: 'FrontShopMobileBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes et traitements pour les lèvres',
                      uid: 'FrontShopMobileBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopMobileBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le corps',
                          uid: 'FrontShopMobileBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopMobileBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopMobileBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins de la peau pour le corps',
                      uid: 'FrontShopMobileBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soin de la peau de luxe',
                          uid: 'FrontShopMobileBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin de la peau dermato',
                          uid: 'FrontShopMobileBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Outil D'analyse",
                          uid: 'FrontShopMobileSkincareSkinAnalysisToolsFeaturedCollectionsNavNode',
                          link: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/tryourvirtualskinanalysistools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magasiner les soins de la peau selon les ingrédients',
                          uid: 'FrontShopMobileBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins de la peau',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins capillaires',
                  uid: 'FrontShopMobileBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampooings et revitalisants',
                      uid: 'FrontShopMobileBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampooing',
                          uid: 'FrontShopMobileBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Revitalisant',
                          uid: 'FrontShopMobileBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shampooing sec',
                          uid: 'FrontShopMobileBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Type de cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fins et plats',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Raides',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ondulés et frisés',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rêches et épais',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobileBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobileBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobileBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobileBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobileBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Préoccupation capillaire',
                      uid: 'FrontShopMobileBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brillance',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Abîmé',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des frisottis',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sécheresse et pellicules',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volume',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits coiffants et traitements',
                      uid: 'FrontShopMobileBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Traitements capillaires',
                          uid: 'FrontShopMobileBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques capillaires',
                          uid: 'FrontShopMobileBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateur pour cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mousse capillaire',
                          uid: 'FrontShopMobileBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cire et gel pour cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour perte et croissance des cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Colorants capillaires',
                      uid: 'FrontShopMobileBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Colorants capillaires permanents',
                          uid: 'FrontShopMobileBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Retouche des racines',
                          uid: 'FrontShopMobileBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Colorants capillaires temporaires',
                          uid: 'FrontShopMobileBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-T500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopMobileBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobileBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopMobileBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles pour les cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins capilaires de luxe',
                          uid: 'FrontShopMobileBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins capilaires dermato',
                          uid: 'FrontShopMobileBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins capillaires',
                          uid: 'FrontShopMobileBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopMobileBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins capillaire',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins capillaire',
                          uid: 'FrontShopMobileBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Parfums',
                  uid: 'FrontShopMobileBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour elles',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour elle',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs et brumes parfumées pour le corps',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour lui',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Bougies et parfums d'ambiance",
                      uid: 'FrontShopMobileBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopMobileBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums à bille et en format de voyage',
                      uid: 'FrontShopMobileBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums de luxe',
                          uid: 'FrontShopMobileBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles',
                          uid: 'FrontShopMobileFragrancesGiftsAndSetsFeaturedCollectionsNavNode',
                          link: '/FS-G300?nav=shop/beauty/fragrances/featuredcollection/fragrancegiftsandsets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux de parfums',
                          uid: 'FrontShopMobileBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour les cheveux',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et bandanas',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de luxe',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires dermato',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode en vedette',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils de coiffure',
                          uid: 'FrontShopMobileToolsAndAccessoriesSalonLevelHairToolsFeaturedCollectionsNavNode',
                          link: '/c/FS-T400?nav=shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de Quo Beauty',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Boutique masculine',
                  uid: 'FrontShopMobileBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins de la peau pour lui',
                      uid: 'FrontShopMobileBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopMobileBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nettoyants et accessoires',
                          uid: 'FrontShopMobileBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements',
                          uid: 'FrontShopMobileBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baume à lèvres',
                          uid: 'FrontShopMobileBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopMobileBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopMobileBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopMobileBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité',
                          uid: 'FrontShopMobileBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopMobileBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et produits de rasage',
                          uid: 'FrontShopMobileBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-rasage',
                          uid: 'FrontShopMobileBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopMobileBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobileBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobileBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins capillaires pour lui',
                      uid: 'FrontShopMobileBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopMobileBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins masculins de luxe',
                          uid: 'FrontShopMobileBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins masculins dermato',
                          uid: 'FrontShopMobileBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins pour hommes',
                          uid: 'FrontShopMobileBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux pour hommes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux pour hommes',
                          uid: 'FrontShopMobileBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Marques',
                  uid: 'FrontShopMobileBeautyBrandsNavNode',
                  link: '/all-brands',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Marques Populaires',
                      uid: 'FrontShopMobileBeautyBrandsPopularShopByBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dyson',
                          uid: 'FrontShopMobileBeautyBrandsDysonPopularNavNode',
                          link: '/c/DYSON?nav=shop/beauty/shopbybrand/Dyson',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lancome',
                          uid: 'FrontShopMobileBeautyBrandsLancomePopularNavNode',
                          link: '/c/LANCOME?nav=shop/beauty/shopbybrand/Lancome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'R.E.M. Beauty',
                          uid: 'FrontShopMobileBeautyBrandsREMBeautyPopularNavNode',
                          link: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'La Roche Posay',
                          uid: 'FrontShopMobileBeautyBrandsLaRochePosayPopularNavNode',
                          link: '/c/LA,ROCHE,POSAY?nav=shop/beauty/shopbybrand/LaRochePosay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'CeraVe',
                          uid: 'FrontShopMobileBeautyBrandsCeraVePopularNavNode',
                          link: '/c/CERAVE?nav=shop/beauty/shopbybrand/CeraVe',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Quo Beauty',
                          uid: 'FrontShopMobileBeautyBrandsQuoBeautyPopularNavNode',
                          link: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/QuoBeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Olay',
                          uid: 'FrontShopMobileBeautyBrandsOlayPopularNavNode',
                          link: '/c/OLAY?nav=shop/beauty/shopbybrand/Olay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'LOreal',
                          uid: 'FrontShopMobileBeautyBrandsLOrealPopularNavNode',
                          link: "/c/L'OREAL?nav=shop/beauty/shopbybrand/LOreal",
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Marques en vedette',
                      uid: 'FrontShopMobileBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopMobileBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA,MERCIER?nav=shop/beauty/shopbybrand/LauraMercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopMobileBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopMobileBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=shop/beauty/shopbybrand/Versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopMobileBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopMobileBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO,FACED?nav=shop/beauty/shopbybrand/TooFaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopMobileBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=shop/beauty/shopbybrand/Foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopMobileBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=shop/beauty/shopbybrand/NARS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopMobileBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopMobileBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Soins personnels',
              uid: 'FrontShopMobilePersonalCareNavNode',
              link: '/Shop/Catégories/PersonalCare/c/FS-PC?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Produits pour le corps et le bain',
                  uid: 'FrontShopMobilePersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soins corporels',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et beurres pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes raffermissantes et pour les vergetures',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bain et douche',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le corps et gels de douche',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sels de bains et bain moussant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants corporels',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de bain',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des mains et des pieds',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Savons à main',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Désinfectants pour les mains',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions et crèmes pour les mains',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et masques pour les pieds',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils de soins des pieds',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes pour les lèvres',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Déodorant et antisudorifique',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Déodorant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eau parfumante et poudre pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Protection solaire',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écran solaire pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour le bain et le corps',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits pour le bain et le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins pour le corps et le bain',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins intimes ',
                  uid: 'FrontShopMobilePersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Serviettes hygiéniques et protège-dessous',
                      uid: 'FrontShopMobilePersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Nettoyants et désodorisants pour hygiène intime',
                      uid: 'FrontShopMobilePersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopMobilePersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coupe menstruelle',
                      uid: 'FrontShopMobilePersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits soins intimes',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins intimes',
                          uid: 'FrontShopMobilePersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Contrôle de la vessie & incontinence',
                  uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Doublures et serviettes pour incontinence',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sous-vêtements protecteurs',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins dentaires',
                  uid: 'FrontShopMobilePersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Brosses à dents',
                      uid: 'FrontShopMobilePersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brosses à dents électriques',
                          uid: 'FrontShopMobilePersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses à dents',
                          uid: 'FrontShopMobilePersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits de soins dentaires',
                      uid: 'FrontShopMobilePersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins dentaires',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopMobilePersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dentifrice',
                          uid: 'FrontShopMobilePersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blanchissement des dents',
                          uid: 'FrontShopMobilePersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rafraîchisseurs d’haleine',
                          uid: 'FrontShopMobilePersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rince-bouches',
                          uid: 'FrontShopMobilePersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soie dentaire',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins buccodentaires',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins buccaux',
                          uid: 'FrontShopMobilePersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Rasage et épilation',
                  uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Crèmes et gels de rasage',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cires et crèmes dépilatoires',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoir électrique',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoirs et lames jetables',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Appareils dépilatoires',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires de toilette',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Pour hommes',
                  uid: 'FrontShopMobilePersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopMobilePersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes & gels de rasage',
                          uid: 'FrontShopMobilePersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopMobilePersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobilePersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobilePersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopMobilePersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles à cheveux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de rasage et accessoires de toilette',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rasoirs électriques',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils dépilatoires',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de garde-robe',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bijoux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soutiens-gorge accessoires',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bas et collants',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Chaussettes',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de voyage',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires météorologiques',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Articles format voyage',
                  uid: 'FrontShopMobilePersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Lutte contre les insectes et animaux nuisibles',
                  uid: 'FrontShopMobilePersonalCareInsectPestControlNavNode',
                  link: '/Shop/Catégories/Soins-personnels/Lutte-contre-les-insectes-et-animaux-nuisiblesLutte-contre-les-insectes-et-animaux-nuisibles/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Santé',
              uid: 'FrontShopMobileHealthNavNode',
              link: '/Shop/Catégories/Health/c/FS-HT?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Médicaments et traitements',
                  uid: 'FrontShopMobileHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toux, rhume et grippe',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins nasaux et aides-sommeil',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermomètres',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soulagement de la douleur',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soulagement contre la douleur buccale',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement chaud et froid',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topiques pour le soulagement de la douleur',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé digestive',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intolérance digestive',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Premiers soins',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fournitures pour pansements et ruban',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la peau',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fournitures de premiers soins',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Articles de contention et vêtements médicaux',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sinus et allergies',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistaminiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour les diabétiques',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Test de glycémie',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Aides au sommeil',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Organisation des médicaments',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Équipement de protection individuelle ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Équipement de protection individuelle ',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Advil pour le soulagement de la douleur',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAdvilPainReliefFeaturedCollectionNavNode',
                          link: '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/medicineandtreatments/featuredcollections/advilpainrelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamines et suppléments',
                  uid: 'FrontShopMobileHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamines',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Multivitamines pour adultes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Huiles de poisson riches en oméga',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des articulations',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des yeux',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins des cheveux, des ongles et de la peau',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mélatonine',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments alimentaires naturels',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé du cœur',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homéopathie',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des hommes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des femmes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments de minéraux',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fer',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnésium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition et gestion du poids',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Barres protéinées et collations',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protéines liquides et en poudre',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Webber Naturals pour le sommeil et le soulagement du stress',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_webbernaturals/wk09_featurecollectiontile_webber_enfr.png',
                            imageLink:
                              '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Webber Naturals Pour Le Sommeil Et Le Soulagement Du Stress',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWebberNaturalsFeaturedCollectionNavNode',
                          link: '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Vitamines Vitalux Advanced ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitamines Vitalux Advanced ',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bien-être sexuel et planification familiale',
                  uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bien-être sexuel',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubrifiants et huile pour massage intime',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jouets pour adultes',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptifs',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Planification familiale',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Tests de grossesse',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses et tests d’ovulation',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux de bien-être sexuel ',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins des yeux, des oreilles et des pieds',
                  uid: 'FrontShopMobileHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soin des yeux',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Accessoires pour entretien des verres de contact',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour la santé oculaire',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lunettes',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Solution pour verres de contact',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Articles de soins des pieds',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Coussinets et semelles intérieures',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des odeurs et de l’humidité',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins des pieds',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour la natation',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins de santé à domicile et conditionnement physique',
                  uid: 'FrontShopMobileHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bas et chaussettes de compression',
                      uid: 'FrontShopMobileHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Balances, saturomètre et podomètres',
                      uid: 'FrontShopMobileHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bien-être et appareils de massage',
                      uid: 'FrontShopMobileHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sécurité pour la salle de bain',
                      uid: 'FrontShopMobileHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tensiomètres',
                      uid: 'FrontShopMobileHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cannes et béquilles',
                      uid: 'FrontShopHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Équipements et accessoires de conditionnement physique',
                      uid: 'FrontShopMobileHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-%26-Accessories/c/FS-HT-H700',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Bébé et enfant',
              uid: 'FrontShopMobileBabyAndChildNavNode',
              link: '/Shop/Catégories/BabyAndChild/c/FS-BC?nav=/shop/baby',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Soins pour bébés et enfants',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Couches et lingettes',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Couches',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Culottes d'entraînement",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre l’érythème fessier',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Recharges pour poubelles à couches',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lingettes pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour le corps et le bain',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et lotions pour le corps',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits pour le bain et shampooings',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotons-tiges',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huile pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé des enfants',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe pour enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sécurité et protection des enfants',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Jouets',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Vêtements et accessoires',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour bébés',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Alimentation et préparations',
                  uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Aliments et préparations pour bébés',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formule',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Aliments pour bébés et collations pour tout-petits',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Céréales pour bébés',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alimentation pédiatrique',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allaitement et heure du repas',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Essentiels pour l’allaitement',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’alimentation des tout-petits',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Biberons et tétines',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suces et jouets de dentition',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Jouets',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Maison et électronique',
              uid: 'FrontShopMobileHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/magasiner/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Électronique',
                  uid: 'FrontShopMobileHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/HomeAndElectronics/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Systèmes audios',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écouteurs',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Haut-parleurs',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Piles',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Piles spécialisées',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles alcalines',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles pour appareil auditif',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Accessoires de téléphone et d'appareil photo",
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Appareils photos et accessoires',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Téléphones et accessoires',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cartes mémoire',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ordinateurs Et Technologies Connectées',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maison connectée',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Carnets',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablettes et lecteurs électroniques',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour ordinateurs et logiciels',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Montres intelligentes et GPS',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-%26-Smart-Tech/Smartwatches/c/FS-EL-505',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Jeux vidéo',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles et accessoires de jeux',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jeux',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Maison et style de vie',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bougies ',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffuseurs',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cartes de souhaits',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareGreetingsCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Saisonnier',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Parfums rafraîchissants',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Parfums rafraîchissants',
                          uid: 'FrontShopMobileHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Électroménagers',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Linge de lit et matelas',
                  uid: 'FrontShopMobileHomeAndElectronicsBeddingNavNode',
                  link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Matelas',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingMattressesNavNode',
                      link: ' https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Bedding/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Oreillers ',
                      uid: 'FrontShopMobileHomeAndElectronicsPillowsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Couvertures lestées et housses de couette',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://magasiner.pharmaprix.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique saisonnière',
                  uid: 'FrontShopMobileHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Cat%C3%A9gories/Maison-et-%C3%A9lectronique/Maison-et-style-de-vie/Saisonnier/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'électronique',
              uid: 'FrontShopMobileElectronicsNavNode',
              link: '/Shop/Catégories/Electronics/c/FS-EL?nav=/shop/electronics',
              hasChildren: false,
              __typename: 'CmsNode',
              child: null,
            },
            {
              name: 'Offres',
              uid: 'FrontShopMobileOffersNavNode',
              link: '/Shop/Catégories/Offers/c/FS-Offers?nav=/shop/offers',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Solde',
                  uid: 'FrontShopMobileOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance Fr',
                  uid: 'FrontShopMobileOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AClearance%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase Fr',
                  uid: 'FrontShopMobileOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AGift%2Bwith%2BPurchase%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Offres PC Optimum',
                  uid: 'FrontShopMobileOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Santé et bien-être',
          uid: 'FrontShopMobileHealthAndWellnessNavNode',
          link: 'https://www.pharmaprix.ca/fr/health-and-wellness',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Électroniques',
          uid: 'FrontShopMobileElectronicsNavNode',
          link: 'https://www1.pharmaprix.ca/fr/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopMobilePromotionsNavNode',
          link: 'https://magasiner.pharmaprix.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopMobilePCOptimumNavNode',
          link: 'https://www1.pharmaprix.ca/fr/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
    },
  },
  shoppersdrugmart: {
    en: {
      navigation: [
        {
          name: 'Shop',
          uid: 'FrontShopShopNavNode',
          link: 'https://shop.shoppersdrugmart.ca/?lang=en&_ga=2.202117593.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Holidays',
              uid: 'FrontShopHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Explore Holidays',
                  uid: 'FrontShopHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Our Picks',
                  uid: 'FrontShopHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Online Exclusives',
                  uid: 'FrontShopHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Gifts by Price",
                  uid: 'FrontShopHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'under $25',
                      uid: 'FrontShopHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'under $50',
                      uid: 'FrontShopHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Beauty Gifts',
                  uid: 'FrontShopHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Makeup',
                      uid: 'FrontShopHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care',
                      uid: 'FrontShopHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrances',
                      uid: 'FrontShopHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care',
                      uid: 'FrontShopHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tools & Accessories',
                      uid: 'FrontShopHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home',
                      uid: 'FrontShopHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Quo Beauty Holiday',
                      uid: 'FrontShopHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Advent Calendars',
                      uid: 'FrontShopHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Discovery Collections',
                      uid: 'FrontShopHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Value Sets',
                      uid: 'FrontShopHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Personal Care Gifts',
                  uid: 'FrontShopHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Electronic Gifts',
                  uid: 'FrontShopHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio & Video Games',
                      uid: 'FrontShopHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Smart Tech',
                      uid: 'FrontShopHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Wellness Gifts',
                  uid: 'FrontShopHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Men's shop",
                  uid: 'FrontShopHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mens Fragrances',
                      uid: 'FrontShopHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Mens Care',
                      uid: 'FrontShopHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Kids Shop',
                  uid: 'FrontShopHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gifts for Pets',
                  uid: 'FrontShopHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Stocking Stuffers',
                  uid: 'FrontShopHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Home & Seasonal Gifts',
                  uid: 'FrontShopHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Thoughtful Choices',
                  uid: 'FrontShopHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Greeting Cards',
                  uid: 'FrontShopHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauty',
              uid: 'FrontShopBeautyNavNode',
              link: '/Beauty?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Gift & Sets',
                  uid: 'FrontShopBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Beauty Tools',
                      uid: 'FrontShopBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home Gifts',
                      uid: 'FrontShopBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Gift By Price',
                      uid: 'FrontShopBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: '$25 or less',
                          uid: 'FrontShopBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$50 or less',
                          uid: 'FrontShopBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$100 or less',
                          uid: 'FrontShopBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Over $100',
                          uid: 'FrontShopBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Value Gift Sets',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Value Gift Sets',
                          uid: 'FrontShopBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advent Calendars',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advent Calendars',
                          uid: 'FrontShopBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Gifts & Sets',
                          uid: 'FrontShopBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Gifts & Sets',
                          uid: 'FrontShopBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Makeup',
                  uid: 'FrontShopBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers?nav=/shop/Categories/Makeup/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face',
                      uid: 'FrontShopBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Foundation',
                          uid: 'FrontShopBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'BB & CC Creams',
                          uid: 'FrontShopBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Concealer',
                          uid: 'FrontShopBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Primer',
                          uid: 'FrontShopBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Powder',
                          uid: 'FrontShopBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blush',
                          uid: 'FrontShopBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bronzer',
                          uid: 'FrontShopBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contour',
                          uid: 'FrontShopBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Highlighter',
                          uid: 'FrontShopBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Setting Spray',
                          uid: 'FrontShopBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eyes',
                      uid: 'FrontShopBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascara',
                          uid: 'FrontShopBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeshadow',
                          uid: 'FrontShopBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeliner',
                          uid: 'FrontShopBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Primer',
                          uid: 'FrontShopBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brows',
                          uid: 'FrontShopBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Treatments',
                          uid: 'FrontShopBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Eyelashes',
                          uid: 'FrontShopBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lips',
                      uid: 'FrontShopBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lipstick',
                          uid: 'FrontShopBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Gloss',
                          uid: 'FrontShopBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Stain',
                          uid: 'FrontShopBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Plumper',
                          uid: 'FrontShopBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm & Treatment',
                          uid: 'FrontShopBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Liner',
                          uid: 'FrontShopBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Palettes',
                      uid: 'FrontShopBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nails',
                      uid: 'FrontShopBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nail Colour',
                          uid: 'FrontShopBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Top & Base Coats',
                          uid: 'FrontShopBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Makeup',
                          uid: 'FrontShopBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Makeup',
                          uid: 'FrontShopBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Makeup',
                          uid: 'FrontShopBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Makeup Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Makeup Gifts',
                          uid: 'FrontShopBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Quo Beauty Holiday Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty Holiday Gifts',
                          uid: 'FrontShopBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Skin Care',
                  uid: 'FrontShopBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers?nav=/shop/Categories/SkinCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face Moisturizers',
                      uid: 'FrontShopBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Night Cream',
                          uid: 'FrontShopBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Oils',
                          uid: 'FrontShopBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Mists',
                          uid: 'FrontShopBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cleansers',
                      uid: 'FrontShopBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Wash & Cleansers',
                          uid: 'FrontShopBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=shop/Categories/SkinCare/FaceWashAndCleansers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Scrubs & Exfoliators',
                          uid: 'FrontShopBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toners',
                          uid: 'FrontShopBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Treatments',
                      uid: 'FrontShopBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Serums',
                          uid: 'FrontShopBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Anti-aging',
                          uid: 'FrontShopBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brightening',
                          uid: 'FrontShopBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Acne & Blemish Treatments',
                          uid: 'FrontShopBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Peels',
                          uid: 'FrontShopBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masks',
                      uid: 'FrontShopBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Masks',
                          uid: 'FrontShopBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sheet Masks',
                          uid: 'FrontShopBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Creams & Treatment',
                          uid: 'FrontShopBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balm & Treatment',
                      uid: 'FrontShopBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Sunscreen',
                          uid: 'FrontShopBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Body Skin Care',
                      uid: 'FrontShopBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Skincare',
                          uid: 'FrontShopBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Skincare',
                          uid: 'FrontShopBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Skincare',
                          uid: 'FrontShopBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Try our virtual skin analysis tool',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P1/WK02/CollectionTile/EN/wk02_featuredcollectiontile_skintool_b1_en.png',
                            imageLink: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/skindiagnostic',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Try our virtual skin analysis tool',
                          uid: 'FrontShopBeautySkinCareSkinDiagnosticFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Shop Skin Care by Ingredient',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_p3clinical_skincare/wk09_featurecollecctiontile_p3clinicalskincare_enfr.png',
                            imageLink:
                              '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Shop Skin Care by Ingredient',
                          uid: 'FrontShopBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Skin Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Skin Care Gifts',
                          uid: 'FrontShopBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Hair Care',
                  uid: 'FrontShopBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers?nav=/shop/Categories/HairCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampoos & Conditioners',
                      uid: 'FrontShopBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampoo',
                          uid: 'FrontShopBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Conditioner',
                          uid: 'FrontShopBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dry Shampoo',
                          uid: 'FrontShopBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Type',
                      uid: 'FrontShopBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thin & Fine',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straight',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wavy & Curly',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coarse & Thick',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Concern',
                      uid: 'FrontShopBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shine',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Damaged',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Frizz Control',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dryness & Dandruff',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volumizing',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Styling Products & Treatments',
                      uid: 'FrontShopBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hair Treatments',
                          uid: 'FrontShopBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Masks',
                          uid: 'FrontShopBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Spray',
                          uid: 'FrontShopBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Mousse',
                          uid: 'FrontShopBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Wax & Gel',
                          uid: 'FrontShopBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Loss & Regrowth Supplements',
                          uid: 'FrontShopBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Colour',
                      uid: 'FrontShopBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Permanent Hair Colour',
                          uid: 'FrontShopBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Root Touch-Up',
                          uid: 'FrontShopBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Temporary Hair Colour',
                          uid: 'FrontShopBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-H500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Gifts & Sets',
                      uid: 'FrontShopBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Hair Care',
                          uid: 'FrontShopBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Hair Care',
                          uid: 'FrontShopBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Hair Care',
                          uid: 'FrontShopBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Hair Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Hair Care Gifts',
                          uid: 'FrontShopBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Fragrance',
                  uid: 'FrontShopBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers?nav=/shop/Categories/Fragrance/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Her',
                      uid: 'FrontShopBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Sprays & Fragrance Mists',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for her',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Perfume',
                          uid: 'FrontShopBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for him',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Home Scents & Candles',
                      uid: 'FrontShopBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Fragrance',
                          uid: 'FrontShopBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Fragrance Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-fragrance-gifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Fragrance Gifts',
                          uid: 'FrontShopBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers?nav=/shop/Categories/ToolsAndAccessories/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopBeautyToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Tools & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Tools & Accessories',
                          uid: 'FrontShopBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Salon-level hair tools',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2020/evergreen/collection-tiles/menufeaturedtile_toolsaccessories_b1_en.jpg',
                            imageLink:
                              '/c/FS-T400?nav=/shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Salon-level hair tools',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tools & Accessories by Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/Evergreen/collection-tiles-nav/quo/wk16_featurecollectiontile_quo-tools-accessories_enfr.png',
                            imageLink:
                              '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tools & Accessories by Quo Beauty',
                          uid: 'FrontShopBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers?nav=/shop/Categories/Mens/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care for Him',
                      uid: 'FrontShopBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cleansers & Accessories',
                          uid: 'FrontShopBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Treatments',
                          uid: 'FrontShopBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm',
                          uid: 'FrontShopBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances',
                          uid: 'FrontShopBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Shave',
                          uid: 'FrontShopBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair for Him',
                      uid: 'FrontShopBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Luxury Men's Care",
                          uid: 'FrontShopBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Derm Men's Care",
                          uid: 'FrontShopBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Thoughtful Choices Men's Care",
                          uid: 'FrontShopBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Men's Gifts",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Men's Gifts",
                          uid: 'FrontShopBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shop by Brand',
                  uid: 'FrontShopBeautyShopByBrandsNavNode',
                  link: '/all-brands?nav=shop/beauty/shopallbrand',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Popular Brands',
                      uid: 'FrontShopBeautyBrandsPopularBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'DysonName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_dyson.png',
                            imageLink: '/c/DYSON?nav=/brands/dyson',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Dyson',
                          uid: 'FrontShopBeautyBrandsdysonPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LancomeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_lancome.png',
                            imageLink: '/c/LANCOME?nav=/brands/lancome',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Lancome',
                          uid: 'FrontShopBeautyBrandsLancomePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'REMName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.amazonaws.com/site-creative/2022/beauty-brand-tiles/menubrandtile_rembeauty.png',
                            imageLink: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                            __typename: 'NavPromoNode',
                          },
                          name: 'REM',
                          uid: 'FrontShopBeautyBrandsREMPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LaRochePosayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_laorocheposay.png',
                            imageLink: '/c/LA%2CROCHE%2CPOSAY?nav=/brands/larocheposay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'La Roche Posay',
                          uid: 'FrontShopBeautyBrandsLaRochePosayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'CeraVeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_cerave.png',
                            imageLink: '/c/CERAVE?nav=/brands/cerave',
                            __typename: 'NavPromoNode',
                          },
                          name: 'CeraVe',
                          uid: 'FrontShopBeautyBrandsCeraVePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'QuoBeautyName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_quobeauty.png',
                            imageLink: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/quobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty',
                          uid: 'FrontShopBeautyBrandsQuoBeautyPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "L'OrealName",
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_loreal.png',
                            imageLink: '/c/L%27OREAL',
                            __typename: 'NavPromoNode',
                          },
                          name: "L'Oreal",
                          uid: 'FrontShopBeautyBrandsLOrealPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'OlayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_olay.png',
                            imageLink: '/c/OLAY?nav=/brands/olay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Olay',
                          uid: 'FrontShopBeautyBrandsOlayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Brands',
                      uid: 'FrontShopBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA%2CMERCIER?nav=/brands/lauramercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=/brands/versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO%2CFACED?nav=/brands/toofaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=/brands/foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=/brands/nars',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Personal Care',
              uid: 'FrontShopPersonalCareNavNode',
              link: '/Personal-care?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Bath & Body Care',
                  uid: 'FrontShopPersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Body Care',
                      uid: 'FrontShopPersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Butters',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Lotions',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Firming & Stretch Mark Creams',
                          uid: 'FrontShopPersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Oils',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopPersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Shower',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Wash & Shower Gels',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Soaks & Bubble Bath',
                          uid: 'FrontShopPersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Scrubs',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Accessories',
                          uid: 'FrontShopPersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hand & Foot Care',
                      uid: 'FrontShopPersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hand Soaps',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Creams & Lotions',
                          uid: 'FrontShopPersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Sanitizers',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balms',
                      uid: 'FrontShopPersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Deodorant & Antiperspirant',
                      uid: 'FrontShopPersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Deodorant',
                          uid: 'FrontShopPersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Powder',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopPersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopPersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopPersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bath & Body Gifts & Sets',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopPersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Bath & Body Care',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Bath & Body Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_bathandbodycare/wk13_featurecollecctiontile_bath-body-care_enfr.png',
                            imageLink:
                              '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Bath & Body Care',
                          uid: 'FrontShopPersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Intimate Care',
                  uid: 'FrontShopPersonalCareFeminineCareNavNode',
                  link: '/c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Pads & Panty Liners',
                      uid: 'FrontShopPersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Intimate Cleaning & Deodorants',
                      uid: 'FrontShopPersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopPersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Yeast Infection Treatments',
                      uid: 'FrontShopPersonalCareFeminineCareYeastInfectionTreatmentsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/YeastInfectionTreatments/c/FS-PC-F400?nav=/shop/Categories/FeminineCare/YeastInfectionTreatments',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cups',
                      uid: 'FrontShopPersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopPersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Intimate Care',
                          uid: 'FrontShopPersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopPersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Intimate Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_intimatecare/wk05_featurecollecctiontile_intimatecare_enfr.png',
                            imageLink:
                              '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Intimate Care',
                          uid: 'FrontShopPersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bladder Control & Incontinence',
                  uid: 'FrontShopPersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Incontinence Pads & Liners',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Protective Underwear & Briefs',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareBladderControlFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Oral Care',
                  uid: 'FrontShopPersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toothbrushes',
                      uid: 'FrontShopPersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric toothbrushes',
                          uid: 'FrontShopPersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothbrushes',
                          uid: 'FrontShopPersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Oral Care Products',
                      uid: 'FrontShopPersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Toothpaste',
                          uid: 'FrontShopPersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Teeth Whitening',
                          uid: 'FrontShopPersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mouthwash & Rinses',
                          uid: 'FrontShopPersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breath Fresheners',
                          uid: 'FrontShopPersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Care',
                          uid: 'FrontShopPersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopPersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Floss',
                          uid: 'FrontShopPersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By: ',
                      uid: 'FrontShopPersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Oral Care',
                          uid: 'FrontShopPersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopPersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Oral Care',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_oralcare/wk05_featurecollecctiontile_oralcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Oral Care',
                          uid: 'FrontShopPersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shaving & Hair Removal',
                  uid: 'FrontShopPersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving Creams & Gels',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Waxes & Removal Creams',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Electric Shavers',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Disposable Razors & Blades',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Removal Devices',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Grooming Accessories',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Shaving & Hair Removal',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_shavinghair/wk17_featurecollecctiontile_shavinghairremoval_enfr.png',
                            imageLink:
                              '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Shaving & Hair Removal',
                          uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopPersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopPersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopPersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopPersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razors & Blades',
                          uid: 'FrontShopPersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopPersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopPersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving & Grooming Tools & Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Removal Devices',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Wardrobe Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Jewellery',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bra Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hosiery & Tights',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Socks',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Winter Accessories',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Travel Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weather Accessories',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareToolsAccessFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Travel Sized Items',
                  uid: 'FrontShopPersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopPersonalCareTravelSizedItemsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Insect & Pest Control',
                  uid: 'FrontShopPersonalCareInsectPestControlNavNode',
                  link: '/Shop/Categories/Personal-Care/Insect-%26-Pest-Control/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Health',
              uid: 'FrontShopHealthNavNode',
              link: '/Health?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Medicine & Treatments',
                  uid: 'FrontShopHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Cough, Cold & Flu',
                      uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cough, Cold & Flu Medication',
                          uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care & Sleep Aids',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topical Rub',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalRubNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicalRub/c/FS-MT-107?nav=/shop/Categories/MedicineAndTreatments/TopicalRub',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermometers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Quit Smoking',
                      uid: 'FrontShopHealthMedicineAndTreatmentsQuitSmokingNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/QuitSmoking/c/FS-HT-M700?nav=/shop/Categories/MedicineAndTreatments/QuitSmoking',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sleep Aids',
                      uid: 'FrontShopHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pill Organization',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pain Relief',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Muscle, Back & Joint Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMuscleBackAndJointPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief/c/FS-HT-M202?nav=/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topical Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hemorrhoid Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHemorrhoidReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HemorrhoidRelief/c/FS-HT-M206?nav=/shop/Categories/MedicineAndTreatments/HemorrhoidRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hot & Cold Treatment',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Pain & Fever Relief",
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief/c/FS-HT-M204?nav=/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headache & Fever Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHeadacheAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief/c/FS-HT-M201?nav=/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health Treatment',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHeartHealthTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose/c/FS-HT-M205?nav=/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Menstrual Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMenstrualPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MenstrualPainRelief/c/FS-HT-M208?nav=/shop/Categories/MedicineAndTreatments/MenstrualPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'First Aid',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandaging Supplies & Tape',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptics',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'First Aid Supplies',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lice Care',
                          uid: 'FrontShopHealthMedicineAndTreatmentsLiceCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/LiceCare/c/FS-HT-M406?nav=/shop/Categories/MedicineAndTreatments/LiceCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Medical Supports & Garments',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Burn & Wound Care',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBurnAndWoundCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BurnAndWoundCare/c/FS-HT-M404?nav=/shop/Categories/MedicineAndTreatments/BurnAndWoundCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allergy & Sinus',
                      uid: 'FrontShopHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistamines',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M503?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Digestive Health',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Acid Reflux',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAcidRefluxNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/AcidReflux/c/FS-HT-M301?nav=/shop/Categories/MedicineAndTreatments/AcidReflux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fibres & Laxatives',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFibresAndLaxativesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FibresAndLaxatives/c/FS-HT-M303?nav=/shop/Categories/MedicineAndTreatments/FibresAndLaxatives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Motion Sickness & Nausea',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMotionSicknessAndNauseaNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea/c/FS-HT-M305?nav=/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Digestive Intolerance',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Enemas',
                          uid: 'FrontShopHealthMedicineAndTreatmentsEnemasNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Enemas/c/FS-HT-M307?nav=/shop/Categories/MedicineAndTreatments/Enemas',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diarrhea Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiarrheaReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiarrheaRelief/c/FS-HT-M304?nav=/shop/Categories/MedicineAndTreatments/DiarrheaRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Diabetes Care',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Glucose Testing',
                          uid: 'FrontShopHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Insulin Adminstration',
                          uid: 'FrontShopHealthMedicineAndTreatmentsInsulinAdminstrationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/InsulinAdminstration/c/FS-HT-M602?nav=/shop/Categories/MedicineAndTreatments/InsulinAdminstration',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetes Supplements',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesSupplementsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSupplements/c/FS-HT-M603?nav=/shop/Categories/MedicineAndTreatments/DiabeticSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetes Skin Care ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesSkinCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sweeteners',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSweetenersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Sweeteners/c/FS-HT-M606?nav=/shop/Categories/MedicineAndTreatments/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Personal Protective Equipment',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Personal Protective Equipment ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tylenol Extra Strength Pain Relief',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_tylenol/wk17_featurecollecctiontile_tylenol_enfr.png',
                            imageLink:
                              '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tylenol Extra Strength Pain Relief',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTylenolPainReliefFeaturedCollectionNavNode',
                          link: '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamins & Supplements',
                  uid: 'FrontShopHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamins',
                      uid: 'FrontShopHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Adults Multivitamins',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Multivitamins & Vitamins",
                          uid: 'FrontShopHealthVitaminsAndSupplementsChildrensMultivitaminsAndVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins/c/FS-HT-V102?nav=/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin A',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminANavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminA/c/FS-HT-V104?nav=/shop/Categories/VitaminsAndSupplements/VitaminA',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin B',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminBNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminB/c/FS-HT-V105?nav=/shop/Categories/VitaminsAndSupplements/VitaminB',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin C',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminCNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminC/c/FS-HT-V106?nav=/shop/Categories/VitaminsAndSupplements/VitaminC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin D',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminDNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminD/c/FS-HT-V107?nav=/shop/Categories/VitaminsAndSupplements/VitaminD',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin E',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminENavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminE/c/FS-HT-V108?nav=/shop/Categories/VitaminsAndSupplements/VitaminE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Prenatal Vitamins',
                          uid: 'FrontShopHealthVitaminsAndSupplementsPrenatalVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/PrenatalVitamins/c/FS-HT-V103?nav=/shop/Categories/VitaminsAndSupplements/PrenatalVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Supplements',
                      uid: 'FrontShopHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Omega Fish Oils & Essential Fatty Acids',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Joint Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair, Nails & Skin Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Melatonin',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Health Food Supplements',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homeopathy',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Caffeine',
                          uid: 'FrontShopHealthVitaminsAndSupplementsCaffeineNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Caffeine/c/FS-HT-V212?nav=/shop/Categories/VitaminsAndSupplements/Caffeine',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Women's Health",
                          uid: 'FrontShopHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Men's Health",
                          uid: 'FrontShopHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Mineral Supplements',
                      uid: 'FrontShopHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Calcium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsCalciumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Calcium/c/FS-HT-V301?nav=/shop/Categories/VitaminsAndSupplements/Calcium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Iron',
                          uid: 'FrontShopHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnesium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Potassium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsPotassiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Potassium/c/FS-HT-V304?nav=/shop/Categories/VitaminsAndSupplements/Potassium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Zinc',
                          uid: 'FrontShopHealthVitaminsAndSupplementsZincNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Zinc/c/FS-HT-V305?nav=/shop/Categories/VitaminsAndSupplements/Zinc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Other Minerals',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOtherMineralsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OtherMinerals/c/FS-HT-V306?nav=/shop/Categories/VitaminsAndSupplements/OtherMinerals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition & Weight Management',
                      uid: 'FrontShopHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Protein Bars & Snacks',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sweeteners',
                          uid: 'FrontShopHealthVitaminsAndSupplementsSweetenersNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Sweeteners/c/FS-HT-V402?nav=/shop/Categories/VitaminsAndSupplements/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protein Liquid & Powder',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Meal Replacements',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMealReplacementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MealReplacements/c/FS-HT-V404?nav=/shop/Categories/VitaminsAndSupplements/MealReplacements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appetite Control',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAppetiteControlNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AppetiteControl/c/FS-HT-V405?nav=/shop/Categories/VitaminsAndSupplements/AppetiteControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Bausch + Lomb Lumify Redness Reliever Eye Drops',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_bleyedrops/wk17_featurecollecctiontile_bauschlomb_enfr.png',
                            imageLink:
                              '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Bausch + Lomb Lumify Redness Reliever Eye Drops',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeDropsFeaturedCollectionNavNode',
                          link: '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Sexual Wellness & Family Planning',
                  uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Sexual Wellness',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubricants & Intimate Massage Oils',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sex Toys',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptives',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Family Planning',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Ovulation Kits & Tests',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pregnancy Tests',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Sexual Wellness Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Sexual Wellness Gifts',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Eye, Ear & Foot Care',
                  uid: 'FrontShopHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Drops & Lubricants',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeDropsAndLubricantsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants/c/FS-HT-E102?nav=/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Care Accessories',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health Supplements',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contact Lens Solution',
                          uid: 'FrontShopHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeglasses',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ear Care',
                      uid: 'FrontShopHealthEyeEarAndFootCareEarCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EarCare/c/FS-HT-E200?nav=/shop/Categories/EyeEarAndFootCare/EarCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Ear Drops',
                          uid: 'FrontShopHealthEyeEarAndFootCareEarDropsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarDrops/c/FS-HT-E201?nav=/shop/Categories/EyeEarAndFootCare/EarDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ear Plugs',
                          uid: 'FrontShopHealthEyeEarAndFootCareEarPlugsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarPlugs/c/FS-HT-E202?nav=/shop/Categories/EyeEarAndFootCare/EarPlugs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Foot Care',
                      uid: 'FrontShopHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Compression Socks',
                          uid: 'FrontShopHealthEyeEarAndFootCareCompressionSocksNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/CompressionSocks/c/FS-HT-E301?nav=/shop/Categories/EyeEarAndFootCare/CompressionSocks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Inserts, Insoles & Cushions',
                          uid: 'FrontShopHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Athlete's Foot & Antifungal",
                          uid: 'FrontShopHealthEyeEarAndFootCareAthletesFootAndAntifungalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal/c/FS-HT-E303?nav=/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wart Removal',
                          uid: 'FrontShopHealthEyeEarAndFootCareWartRemovalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/WartRemoval/c/FS-HT-E304?nav=/shop/Categories/EyeEarAndFootCare/WartRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments/c/FS-HT-E305?nav=/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Odor & Wetness Control',
                          uid: 'FrontShopHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetes Care',
                          uid: 'FrontShopHealthEyeEarAndFootCareDiabetesCareNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/DiabeticCare/c/FS-HT-E308?nav=/shop/Categories/EyeEarAndFootCare/DiabeticCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Swim Accessories',
                      uid: 'FrontShopHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home Health Care & Fitness',
                  uid: 'FrontShopHealthHomeHealthAndFitnessCareNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Compression Hosiery & Stockings',
                      uid: 'FrontShopHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Scales, Pulse Oximeter &  Pedometers',
                      uid: 'FrontShopHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Body Wellness & Massagers',
                      uid: 'FrontShopHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bathroom Safety',
                      uid: 'FrontShopHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Blood Pressure Monitors',
                      uid: 'FrontShopHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cane & Crutches',
                      uid: 'FrontShopHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fitness Equipment & Accessories',
                      uid: 'FrontShopHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-&-Accessories/c/FS-HT-H700?nav=/shop/Categories/HomeHealthCare/FitnessEquipmentAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHealthHomeHealthCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Baby & Child',
              uid: 'FrontShopBabyAndChildNavNode',
              link: '/Baby-and-child?nav=/shop/babyandchild',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Baby & Child Care',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Diapers & Wipes',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Diapers',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Training Pants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Rash Treatment',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Pails Refills',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Wipes',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Body Care',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Lotions',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bath & Shampoos',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotton Swabs',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Oil',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Powders',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Children's Health Care",
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Children's Cough Cold & Flu",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Pain & Fever Relief",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief/c/FS-BC-B301?nav=/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Multivitamins & Vitamins",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyAndChildrensSupplementsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements/c/FS-BC-B304?nav=/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Childproofing & Safety',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Toys',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Clothing & Accessories',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Baby Gifts & Sets',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Feeding & Formula',
                  uid: 'FrontShopBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Baby Food & Formula',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formula',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Food & Toddler Snacks',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Cereal',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pediatric Nutrition',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nursing & Mealtime',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Breastfeeding Essentials',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toddler Feeding Accessories',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bottles & Nipples',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pacifier & Teething',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Toys',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Home & Electronics',
              uid: 'FrontShopHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/shop/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Electronics',
                  uid: 'FrontShopHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio',
                      uid: 'FrontShopHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headphones & Earbuds',
                          uid: 'FrontShopHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Speakers',
                          uid: 'FrontShopHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Batteries',
                      uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Specialty Batteries',
                          uid: 'FrontShopHomeElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alkaline Batteries',
                          uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hearing Aid Batteries',
                          uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cameras & Phone Accessories',
                      uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cameras & Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Phones & Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Memory cards',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Computers & Smart Tech',
                      uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Connected Home',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Notebooks',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablets & eReaders',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndEReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Computer Accessories & Software',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Smart Watches & GPS',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-&-Smart-Tech/Smartwatches/c/FS-EL-505?nav=/shop/Categories/Electronics/SmartWatchesAndGPS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Video Games',
                      uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles & Gaming Accessories',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Games',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Apple Electronics',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P3/WK12/menu-featuretile/menufeaturetile_apple_enfr.jpg',
                            imageLink: '/c/APPLE?nav=/shop/electronicselectronicsapplefeaturedcollection',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Apple Electronics',
                          uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionAppleNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Home & Lifestyle',
                  uid: 'FrontShopHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Candles',
                      uid: 'FrontShopHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffusers',
                      uid: 'FrontShopHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Greeting Cards',
                      uid: 'FrontShopHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingsCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Seasonal Shop',
                      uid: 'FrontShopHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Refreshing Scents',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Refreshing Scents',
                          uid: 'FrontShopHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Appliances',
                  uid: 'FrontShopHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Bedding & Mattresses',
                  uid: 'FrontShopHomeAndElectronicsBeddingNavNode',
                  link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mattresses',
                      uid: 'FrontShopHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pillows',
                      uid: 'FrontShopHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weighted Blankets & Covers',
                      uid: 'FrontShopHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Seasonal Shop',
                  uid: 'FrontShopHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Categories/Home-%26-Electronics/Home-%26-Lifestyle/Seasonal-Shop/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0&lang=en',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offers',
              uid: 'FrontShopOffersNavNode',
              link: '/c/FS-Offers?nav=/shop/offers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Sale',
                  uid: 'FrontShopOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance',
                  uid: 'FrontShopOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/clearance&q=:trending:promotions:Clearance:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase',
                  uid: 'FrontShopOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/GWP&q=:trending:promotions:Gift+with+Purchase:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'PC Optimum Offers',
                  uid: 'FrontShopOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Prescriptions',
          uid: 'FrontShopPrescriptionNavNode',
          link: 'https://mypharmacy.shoppersdrugmart.ca/en',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Pharmacy Services',
          uid: 'FrontShopPharmacyServicesLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/en/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Health & Wellness',
          uid: 'FrontShopHealthAndWellnessLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/en/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Electronics',
          uid: 'FrontShopElectronicsNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopPromotionsNavNode',
          link: 'https://shop.shoppersdrugmart.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopPCOptimumNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'More by Shoppers',
          uid: 'FrontShopMoreByShoppersNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/more-by-shoppers',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
      footer: [
        {
          name: 'Shop by Popular Categories',
          link: null,
          uid: 'FrontShopFooterShopNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Beauty',
              link: '/Beauty',
              uid: 'FrontShopFooterShopBeautyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Personal Care',
              link: '/c/FS-PC?nav=%2Fshop%2Fpersonal&sort=trending&page=0',
              uid: 'FrontShopFooterShopPersonalCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Health',
              link: '/c/FS-HT?nav=%2Fshop%2Fhealth&sort=trending&page=0',
              uid: 'FrontShopFooterShopHealthNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Baby & Child',
              link: '/c/FS-BC?nav=%2Fshop%2Fbaby&sort=trending&page=0',
              uid: 'FrontShopFooterShopBabyAndChildNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Electronics',
              link: '/c/FS-EL?nav=%2Fshop%2Felectronics&sort=trending&page=0',
              uid: 'FrontShopFooterShopElectronicsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Offers',
              link: '/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0',
              uid: 'FrontShopFooterShopOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Online Shop Customer Service',
          link: null,
          uid: 'FrontShopFooterCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Contact Us',
              link: '/contactus',
              uid: 'FrontShopFooterContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Returns & Exchanges',
              link: 'https://shop.shoppersdrugmart.ca/editorials/returns',
              uid: 'FrontShopFooterReturnsExchangesNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://shop.shoppersdrugmart.ca/editorials/faq',
              uid: 'FrontShopFooterFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shipping & Handling',
              link: 'https://shop.shoppersdrugmart.ca/editorials/shipping',
              uid: 'FrontShopFooterShippingHandlingNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Order History',
              link: '/my-account/orders',
              uid: 'FrontShopFooterOrderHistoryNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Offers',
          link: null,
          uid: 'FrontShopFooterOffersNavNode',
          hasChildren: true,
          child: [
            {
              name: 'View all in-store exclusive offers',
              link: 'https://www1.shoppersdrugmart.ca/en/flyer',
              uid: 'FrontShopFooterInstoreExclusiveOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'View eflyer',
              link: 'https://www1.shoppersdrugmart.ca/en/pcoptimum/in-store-offers',
              uid: 'FrontShopFooterVieweflyerNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'PC Optimum Program',
          link: null,
          uid: 'FrontShopFooterPCOptimumProgramNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Sign In',
              link: 'https://accounts.pcid.ca/login',
              uid: 'FrontShopFooterSignInNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'View all PC Optimum Offers',
              link: 'https://www.pcoptimum.ca/',
              uid: 'FrontShopFooterViewOptimuOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Join',
              link: 'https://www.pcoptimum.ca/register?sid=home|missrewards|getstarted2',
              uid: 'FrontShopFooterJoinNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://loblaw.force.com/PCoptimumsupport/s/?language=en',
              uid: 'FrontShopFooterOptimumFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'About Shoppers Drug Mart',
          link: null,
          uid: 'FrontShopFooterAboutShoppersDrugMartNavNode',
          hasChildren: true,
          child: [
            {
              name: 'News And Announcements',
              link: 'https://www1.shoppersdrugmart.ca/en/news',
              uid: 'FrontShopFooterNewsAndAnnouncementsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Corporate',
              link: 'https://corporate.shoppersdrugmart.ca/en-ca/Home.aspx',
              uid: 'FrontShopFooterCorporateNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Corporate News',
              link: 'https://media.loblaw.ca/English/media-centre/press-releases/default.aspx',
              uid: 'FrontShopFooterCorporateNewsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Social Responsibility',
              link: 'https://www1.shoppersdrugmart.ca/en/love-you',
              uid: 'FrontShopFooterSocialResponsibilityNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Careers',
              link: 'https://careers.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterCareersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Pharmacy Acquisition',
              link: 'http://corporate.shoppersdrugmart.ca/en-ca/pharmacy-acquisition',
              uid: 'FrontShopFooterPharmacyAcquisitionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Legal',
              link: 'http://corporate.shoppersdrugmart.ca/en-ca/legal',
              uid: 'FrontShopFooterLegalNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Privacy',
              link: 'https://www.loblaw.ca/en/privacy.html',
              uid: 'FrontShopFooterPrivacyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Customer Service',
          link: null,
          uid: 'FrontShopFooterSDMCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Product Recall',
              link: 'https://www1.shoppersdrugmart.ca/en/product-recall',
              uid: 'FrontShopFooterSDMProductRecallNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Contact Store Support',
              link: 'https://www1.shoppersdrugmart.ca/en/contact-us',
              uid: 'FrontShopFooterSDMContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Get Help',
              link: 'https://gethelp.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterSDMGetHelpNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Refunds',
              link: 'https://www1.shoppersdrugmart.ca/en/refunds',
              uid: 'FrontShopFooterSDMRefundsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'In Store',
          link: null,
          uid: 'FrontShopFooterVisitAStoreNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Renew Or Refill Prescription',
              link: 'https://mypharmacy.shoppersdrugmart.ca/en',
              uid: 'FrontShopFooterRenewOrRefillPrescriptionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Store Locator',
              link: 'https://stores.shoppersdrugmart.ca/en/',
              uid: 'FrontShopFooterStoreLocatorNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Photo',
              link: 'https://www.shoppersphoto.ca/?lang=en',
              uid: 'FrontShopFooterShoppersPhotoNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Home Health Care',
              link: 'https://www.shoppershomehealthcare.ca/',
              uid: 'FrontShopFooterShoppersHomeHealthCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Gift Cards',
              link: 'https://www1.shoppersdrugmart.ca/en/food-and-home/gift-cards',
              uid: 'FrontShopFooterGiftCardNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
      ],
      navigationMobile: [
        {
          name: 'Shop',
          uid: 'FrontShopMobileShopNavNode',
          link: 'https://shop.shoppersdrugmart.ca/?lang=en&_ga=2.202117593.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Holidays',
              uid: 'FrontShopMobileHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Explore Holidays',
                  uid: 'FrontShopMobileHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Our Picks',
                  uid: 'FrontShopMobileHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Online Exclusives',
                  uid: 'FrontShopMobileHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Gifts by Price",
                  uid: 'FrontShopMobileHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'under $25',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'under $50',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Beauty Gifts',
                  uid: 'FrontShopMobileHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Makeup',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrances',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tools & Accessories',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Quo Beauty Holiday',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Advent Calendars',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Discovery Collections',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Value Sets',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Luxury Gifts ($100+)',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Personal Care Gifts',
                  uid: 'FrontShopMobileHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Electronic Gifts',
                  uid: 'FrontShopMobileHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio & Video Games',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Smart Tech',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Wellness Gifts',
                  uid: 'FrontShopMobileHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Men's shop",
                  uid: 'FrontShopMobileHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mens Fragrances',
                      uid: 'FrontShopMobileHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Mens Care',
                      uid: 'FrontShopMobileHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Kids Shop',
                  uid: 'FrontShopMobileHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gifts for Pets',
                  uid: 'FrontShopMobileHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Stocking Stuffers',
                  uid: 'FrontShopMobileHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Home & Seasonal Gifts',
                  uid: 'FrontShopMobileHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Thoughtful Choices',
                  uid: 'FrontShopMobileHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Greeting Cards',
                  uid: 'FrontShopMobileHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauty',
              uid: 'FrontShopMobileBeautyNavNode',
              link: '/Beauty?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Gift & Sets',
                  uid: 'FrontShopMobileBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Gifts & Sets',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Gifts & Sets',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyGiftAndSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Beauty Tools',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Natural Beauty',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNaturalBeautyNavNode',
                      link: '/c/NaturalBeauty?nav=beauty/giftsandsets/naturalbeauty',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Candles & Home Gifts',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Gift By Price',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: '$25 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$50 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: '$100 or less',
                          uid: 'FrontShopMobileBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Over $100',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Value Gift Sets',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Value Gift Sets',
                          uid: 'FrontShopMobileBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advent Calendars',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advent Calendars',
                          uid: 'FrontShopMobileBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Makeup',
                  uid: 'FrontShopMobileBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face',
                      uid: 'FrontShopMobileBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Foundation',
                          uid: 'FrontShopMobileBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'BB & CC Creams',
                          uid: 'FrontShopMobileBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopMobileBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Concealer',
                          uid: 'FrontShopMobileBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Primer',
                          uid: 'FrontShopMobileBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Powder',
                          uid: 'FrontShopMobileBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blush',
                          uid: 'FrontShopMobileBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bronzer',
                          uid: 'FrontShopMobileBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contour',
                          uid: 'FrontShopMobileBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Highlighter',
                          uid: 'FrontShopMobileBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopMobileBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Setting Spray',
                          uid: 'FrontShopMobileBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopMobileBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eyes',
                      uid: 'FrontShopMobileBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascara',
                          uid: 'FrontShopMobileBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeshadow',
                          uid: 'FrontShopMobileBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeliner',
                          uid: 'FrontShopMobileBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Primer',
                          uid: 'FrontShopMobileBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopMobileBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brows',
                          uid: 'FrontShopMobileBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Treatments',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Eyelashes',
                          uid: 'FrontShopMobileBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lips',
                      uid: 'FrontShopMobileBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lipstick',
                          uid: 'FrontShopMobileBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Gloss',
                          uid: 'FrontShopMobileBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Stain',
                          uid: 'FrontShopMobileBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Plumper',
                          uid: 'FrontShopMobileBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm & Treatment',
                          uid: 'FrontShopMobileBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Liner',
                          uid: 'FrontShopMobileBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopMobileBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-A400?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-A402?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopMobileBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-A403?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-A404?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopMobileBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-A405?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-A401?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Palettes',
                      uid: 'FrontShopMobileBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Palettes',
                          uid: 'FrontShopMobileBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face & Cheek Palettes',
                          uid: 'FrontShopMobileBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nails',
                      uid: 'FrontShopMobileBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nail Colour',
                          uid: 'FrontShopMobileBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Top & Base Coats',
                          uid: 'FrontShopMobileBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopMobileBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopMobileBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-D500?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Makeup Gifts & Sets',
                      uid: 'FrontShopMobileBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-H900?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Makeup',
                          uid: 'FrontShopMobileBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Makeup',
                          uid: 'FrontShopMobileBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Makeup',
                          uid: 'FrontShopMobileBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopMobileBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Makeup Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Makeup Gifts',
                          uid: 'FrontShopMobileBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Quo Beauty Holiday Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty Holiday Gifts',
                          uid: 'FrontShopMobileBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Skin Care',
                  uid: 'FrontShopMobileBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Face Moisturizers',
                      uid: 'FrontShopMobileBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopMobileBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=/shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Night Cream',
                          uid: 'FrontShopMobileBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=/shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Oils',
                          uid: 'FrontShopMobileBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=/shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopMobileBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=/shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Mists',
                          uid: 'FrontShopMobileBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tinted Moisturizer',
                          uid: 'FrontShopMobileBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=/shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cleansers',
                      uid: 'FrontShopMobileBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Wash & Cleansers',
                          uid: 'FrontShopMobileBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Face Scrubs & Exfoliators',
                          uid: 'FrontShopMobileBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=/shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Remover',
                          uid: 'FrontShopMobileBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=/shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toners',
                          uid: 'FrontShopMobileBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Treatments',
                      uid: 'FrontShopMobileBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Serums',
                          uid: 'FrontShopMobileBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=/shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Anti-aging',
                          uid: 'FrontShopMobileBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=/shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brightening',
                          uid: 'FrontShopMobileBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=/shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Acne & Blemish Treatments',
                          uid: 'FrontShopMobileBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=/shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Peels',
                          uid: 'FrontShopMobileBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=/shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masks',
                      uid: 'FrontShopMobileBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Masks',
                          uid: 'FrontShopMobileBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=/shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sheet Masks',
                          uid: 'FrontShopMobileBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=/shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopMobileBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopMobileBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Creams & Treatment',
                          uid: 'FrontShopMobileBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Masks',
                          uid: 'FrontShopMobileBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balm & Treatment',
                      uid: 'FrontShopMobileBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobileBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Face Sunscreen',
                          uid: 'FrontShopMobileBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopMobileBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopMobileBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopMobileBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-S800?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S801?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopMobileBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-S803?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Body Skin Care',
                      uid: 'FrontShopMobileBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care Gifts & Sets',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Skincare',
                          uid: 'FrontShopMobileBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Skincare',
                          uid: 'FrontShopMobileBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Skincare',
                          uid: 'FrontShopMobileBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Try Our Virtual Skin Analysis Tools',
                          uid: 'FrontShopMobileSkincareSkinAnalysisToolsFeaturedCollectionsNavNode',
                          link: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/tryourvirtualskinanalysistools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shop Skin Care by Ingredient',
                          uid: 'FrontShopMobileBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Skin Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Skin Care Gifts',
                          uid: 'FrontShopMobileBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Hair Care',
                  uid: 'FrontShopMobileBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampoos & Conditioners',
                      uid: 'FrontShopMobileBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampoo',
                          uid: 'FrontShopMobileBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Conditioner',
                          uid: 'FrontShopMobileBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dry Shampoo',
                          uid: 'FrontShopMobileBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Type',
                      uid: 'FrontShopMobileBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thin & Fine',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straight',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wavy & Curly',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coarse & Thick',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobileBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-H200?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobileBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-H201?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobileBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-H202?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobileBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-H203?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobileBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-H204?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Concern',
                      uid: 'FrontShopMobileBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shine',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Damaged',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Frizz Control',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dryness & Dandruff',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volumizing',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Styling Products & Treatments',
                      uid: 'FrontShopMobileBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hair Treatments',
                          uid: 'FrontShopMobileBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Masks',
                          uid: 'FrontShopMobileBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Spray',
                          uid: 'FrontShopMobileBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Mousse',
                          uid: 'FrontShopMobileBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Wax & Gel',
                          uid: 'FrontShopMobileBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Loss & Regrowth Supplements',
                          uid: 'FrontShopMobileBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Colour',
                      uid: 'FrontShopMobileBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Permanent Hair Colour',
                          uid: 'FrontShopMobileBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Root Touch-Up',
                          uid: 'FrontShopMobileBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Temporary Hair Colour',
                          uid: 'FrontShopMobileBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobileBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-H500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopMobileBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-H501?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobileBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-H502?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Gifts & Sets',
                      uid: 'FrontShopMobileBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-H600?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Hair Care',
                          uid: 'FrontShopMobileBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices™',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices™',
                          uid: 'FrontShopMobileBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Hair Care Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Hair Care Gifts',
                          uid: 'FrontShopMobileBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Fragrance',
                  uid: 'FrontShopMobileBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Her',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Perfume',
                          uid: 'FrontShopMobileBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Fragrance Mists',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for her',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopMobileBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances for him',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Home Scents & Candles',
                      uid: 'FrontShopMobileBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance Gifts & Sets',
                      uid: 'FrontShopMobileBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-F400?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rollerballs & Travel size',
                      uid: 'FrontShopMobileBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Fragrance',
                          uid: 'FrontShopMobileBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Fragrance Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-fragrance-gifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Fragrance Gifts',
                          uid: 'FrontShopMobileBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Makeup Brushes & Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brow & Lash Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Bags & Cases',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nail Care & Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sponges',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Makeup Brushes',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Skin Care Tools & Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Facial Cleansing Tools',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Facial Wipes & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Care Treatment Devices',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Handbands & Head Wraps',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Salon-Level Hair Tools',
                          uid: 'FrontShopMobileToolsAndAccessoriesSalonLevelHairToolsFeaturedCollectionsNavNode',
                          link: '/c/FS-T400?nav=shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tools & Accessories by Quo Beauty',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Luxury Tools & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Derm Tools & Accessories',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopMobileBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'New Arrivals',
                      uid: 'FrontShopMobileBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Best Sellers',
                      uid: 'FrontShopMobileBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Skin Care for Him',
                      uid: 'FrontShopMobileBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Moisturizers',
                          uid: 'FrontShopMobileBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cleansers & Accessories',
                          uid: 'FrontShopMobileBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Treatments',
                          uid: 'FrontShopMobileBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lip Balm',
                          uid: 'FrontShopMobileBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobileBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fragrance for Him',
                      uid: 'FrontShopMobileBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cologne',
                          uid: 'FrontShopMobileBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Deodorant',
                          uid: 'FrontShopMobileBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Celebrity Fragrances',
                          uid: 'FrontShopMobileBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fragrance Bath & Body',
                          uid: 'FrontShopMobileBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopMobileBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopMobileBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Shave',
                          uid: 'FrontShopMobileBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobileBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopMobileBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobileBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair for Him',
                      uid: 'FrontShopMobileBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: "Men's Gifts & Sets",
                      uid: 'FrontShopMobileBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-M600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobileBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Luxury Men's Care",
                          uid: 'FrontShopMobileBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Derm Men's Care",
                          uid: 'FrontShopMobileBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Thoughtful Choices Men's Care",
                          uid: 'FrontShopMobileBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Men's Gifts",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Men's Gifts",
                          uid: 'FrontShopMobileBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Brands',
                  uid: 'FrontShopMobileBeautyBrandsNavNode',
                  link: '/all-brands',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Popular Brands',
                      uid: 'FrontShopMobileBeautyBrandsPopularShopByBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dyson',
                          uid: 'FrontShopMobileBeautyBrandsDysonPopularNavNode',
                          link: '/c/DYSON?nav=shop/beauty/shopbybrand/Dyson',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lancome',
                          uid: 'FrontShopMobileBeautyBrandsLancomePopularNavNode',
                          link: '/c/LANCOME?nav=shop/beauty/shopbybrand/Lancome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'R.E.M. Beauty',
                          uid: 'FrontShopMobileBeautyBrandsREMBeautyPopularNavNode',
                          link: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'La Roche Posay',
                          uid: 'FrontShopMobileBeautyBrandsLaRochePosayPopularNavNode',
                          link: '/c/LA,ROCHE,POSAY?nav=shop/beauty/shopbybrand/LaRochePosay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'CeraVe',
                          uid: 'FrontShopMobileBeautyBrandsCeraVePopularNavNode',
                          link: '/c/CERAVE?nav=shop/beauty/shopbybrand/CeraVe',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Quo Beauty',
                          uid: 'FrontShopMobileBeautyBrandsQuoBeautyPopularNavNode',
                          link: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/QuoBeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "L'Oreal",
                          uid: 'FrontShopMobileBeautyBrandsLOrealPopularNavNode',
                          link: "/c/L'OREAL?nav=shop/beauty/shopbybrand/LOreal",
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Olay',
                          uid: 'FrontShopMobileBeautyBrandsOlayPopularNavNode',
                          link: '/c/OLAY?nav=shop/beauty/shopbybrand/Olay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Brands',
                      uid: 'FrontShopMobileBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopMobileBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopMobileBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA,MERCIER?nav=shop/beauty/shopbybrand/LauraMercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopMobileBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=shop/beauty/shopbybrand/Versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopMobileBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopMobileBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO,FACED?nav=shop/beauty/shopbybrand/TooFaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopMobileBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=shop/beauty/shopbybrand/NARS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopMobileBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=shop/beauty/shopbybrand/Foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopMobileBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopMobileBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Personal Care',
              uid: 'FrontShopMobilePersonalCareNavNode',
              link: '/Personal-care?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Bath & Body Care',
                  uid: 'FrontShopMobilePersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Body Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Butters',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Lotions',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Firming & Stretch Mark Creams',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Oils',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Neck & Décolleté',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Shower',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Wash & Shower Gels',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Soaks & Bubble Bath',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Scrubs',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath Accessories',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hand & Foot Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hand Soaps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Sanitizers',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hand Creams & Lotions',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lip Balms',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Deodorant & Antiperspirant',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Deodorant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Body Sprays & Powder',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sun Care',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Sunscreen',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'After Sun',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Self Tanners',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bath & Body Gifts & Sets',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Bath & Body Care',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bath & Body Care',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bladder Control & Incontinence',
                  uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Incontinence Pads & Liners',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Protective Underwear & Briefs',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: ' New! Thinx Feminine Hygiene ',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                      link: '/c/THINX?sort=newest&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/BladderControlAndIncontinence/FeaturedCollections/Thinx',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Intimate Care',
                  uid: 'FrontShopMobilePersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Pads & Panty Liners',
                      uid: 'FrontShopMobilePersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Yeast Infection Treatments',
                      uid: 'FrontShopMobilePersonalCareFeminineCareYeastInfectionTreatmentsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/YeastInfectionTreatments/c/FS-PC-F400?nav=/shop/Categories/FeminineCare/YeastInfectionTreatments',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Intimate Cleaning & Deodorants',
                      uid: 'FrontShopMobilePersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopMobilePersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cups',
                      uid: 'FrontShopMobilePersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Intimate Care',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices ',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intimate Care',
                          uid: 'FrontShopMobilePersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Vagisil Feminine Wash ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vagisil/wk25_featurecollecctiontile_vagisil_enfr.png',
                            imageLink:
                              '/c/VAGISIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/FeminineCare/FeaturedCollections/Vagisil',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vagisil Feminine Wash ',
                          uid: 'FrontShopMobilePersonalCareFeminineCareVagisilFeaturedCollectionNavNode',
                          link: '/c/VAGISIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/FeminineCare/FeaturedCollections/Vagisil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Oral Care',
                  uid: 'FrontShopMobilePersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toothbrushes',
                      uid: 'FrontShopMobilePersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric toothbrushes',
                          uid: 'FrontShopMobilePersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toothbrushes',
                          uid: 'FrontShopMobilePersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Oral Care Products',
                      uid: 'FrontShopMobilePersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Toothpaste',
                          uid: 'FrontShopMobilePersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Teeth Whitening',
                          uid: 'FrontShopMobilePersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mouthwash & Rinses',
                          uid: 'FrontShopMobilePersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breath Fresheners',
                          uid: 'FrontShopMobilePersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Care',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopMobilePersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dental Floss',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shop By:',
                      uid: 'FrontShopMobilePersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Thoughtful Choices Oral Care',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Thoughtful Choices',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Thoughtful Choices',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Care',
                          uid: 'FrontShopMobilePersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Shaving & Hair Removal',
                  uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving Creams & Gels',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Waxes & Removal Creams',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Electric Shavers',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Disposable Razor & Blades',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hair Removal Devices',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Grooming Accessories',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving & Hair Removal',
                          uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Men's",
                  uid: 'FrontShopMobilePersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Shaving for Him',
                      uid: 'FrontShopMobilePersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shaving Creams & Gels',
                          uid: 'FrontShopMobilePersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobilePersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopMobilePersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobilePersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobilePersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Tools & Accessories',
                  uid: 'FrontShopMobilePersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Hair Styling Tools',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Curling Irons',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blow Dryers',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Straighteners & Flat Irons',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brushes & Combs',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Hair Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Clips & Pins',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Headbands & Head Wraps',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Elastics',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Shaving & Grooming Tools & Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Electric Shavers',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Disposable Razor & Blades',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair Removal Devices',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Grooming Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Wardrobe Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Jewellery',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bra Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hosiery & Tights',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Socks',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Winter Accessories',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Travel Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weather Accessories',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Travel Sized Items',
                  uid: 'FrontShopMobilePersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Insect & Pest Control',
                  uid: 'FrontShopMobilePersonalCareInsectPestControlNavNode',
                  link: '/Shop/Categories/Personal-Care/Insect-%26-Pest-Control/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Health',
              uid: 'FrontShopMobileHealthNavNode',
              link: '/Health?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Medicine & Treatments',
                  uid: 'FrontShopMobileHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Cough, Cold & Flu',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cough, Cold & Flu Medication',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Medication",
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluChildrensMedicationNavNode',
                          link: '/Shop/Children%27s-Medication/c/FS-HT-M102?nav=/shop/Categories/Health/MedicineandTreatments/CoughColdandFlu/ChildrensMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care & Sleep Aids',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topical Rub',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalRubNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicalRub/c/FS-MT-107?nav=/shop/Categories/MedicineAndTreatments/TopicalRub',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermometers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Pain Relief',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headache & Fever Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHeadacheAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief/c/FS-HT-M201?nav=/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Muscle, Back & Joint Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMuscleBackAndJointPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief/c/FS-HT-M202?nav=/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topical Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hemorrhoid Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHemorrhoidReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HemorrhoidRelief/c/FS-HT-M206?nav=/shop/Categories/MedicineAndTreatments/HemorrhoidRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hot & Cold Treatment',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health Treatment',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHeartHealthTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose/c/FS-HT-M205?nav=/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Pain & Fever Relief",
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief/c/FS-HT-M204?nav=/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Menstrual Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMenstrualPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MenstrualPainRelief/c/FS-HT-M208?nav=/shop/Categories/MedicineAndTreatments/MenstrualPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Digestive Health',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Acid Reflux',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAcidRefluxNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/AcidReflux/c/FS-HT-M301?nav=/shop/Categories/MedicineAndTreatments/AcidReflux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fibres & Laxatives',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFibresAndLaxativesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FibresAndLaxatives/c/FS-HT-M303?nav=/shop/Categories/MedicineAndTreatments/FibresAndLaxatives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Motion Sickness & Nausea',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMotionSicknessAndNauseaNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea/c/FS-HT-M305?nav=/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Digestive Intolerance',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diarrhea Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiarrheaReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiarrheaRelief/c/FS-HT-M304?nav=/shop/Categories/MedicineAndTreatments/DiarrheaRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Enemas',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsEnemasNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Enemas/c/FS-HT-M307?nav=/shop/Categories/MedicineAndTreatments/Enemas',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'First Aid',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandaging Supplies & Tape',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptics',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Skin Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'First Aid Supplies',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lice Care',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsLiceCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/LiceCare/c/FS-HT-M406?nav=/shop/Categories/MedicineAndTreatments/LiceCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Medical Supports & Garments',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Burn & Wound Care',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBurnAndWoundCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BurnAndWoundCare/c/FS-HT-M404?nav=/shop/Categories/MedicineAndTreatments/BurnAndWoundCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allergy & Sinus',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistamines',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nasal Care',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M503?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Diabetes Care',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Glucose Testing',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Insulin Adminstration',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsInsulinAdminstrationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/InsulinAdminstration/c/FS-HT-M602?nav=/shop/Categories/MedicineAndTreatments/InsulinAdminstration',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetes Supplements',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesSupplementsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSupplements/c/FS-HT-M603?nav=/shop/Categories/MedicineAndTreatments/DiabeticSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetes Skin Care',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesSkinCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sweeteners',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSweetenersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Sweeteners/c/FS-HT-M606?nav=/shop/Categories/MedicineAndTreatments/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Quit Smoking',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsQuitSmokingNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/QuitSmoking/c/FS-HT-M700?nav=/shop/Categories/MedicineAndTreatments/QuitSmoking',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sleep Aids',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pill Organization',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Personal Protective Equipment ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Personal Protective Equipment',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advil Fast Pain Relief',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_advil/wk13_featurecollecctiontile_advil_enfr.png',
                            imageLink:
                              '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/Advil',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advil Fast Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAdvilFeaturedCollectionNavNode',
                          link: '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/Advil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tylenol Extra Strength Pain Relief',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_tylenol/wk17_featurecollecctiontile_tylenol_enfr.png',
                            imageLink:
                              '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tylenol Extra Strength Pain Relief',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTylenolPainReliefFeaturedCollectionNavNode',
                          link: '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Voltaren Effective Relief from Pain',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsVoltarenFeaturedCollectionNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamins & Supplements',
                  uid: 'FrontShopMobileHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamins',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Children's Multivitamins & Vitamins",
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsChildrensMultivitaminsAndVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins/c/FS-HT-V102?nav=/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin A',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminANavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminA/c/FS-HT-V104?nav=/shop/Categories/VitaminsAndSupplements/VitaminA',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin B',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminBNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminB/c/FS-HT-V105?nav=/shop/Categories/VitaminsAndSupplements/VitaminB',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin C',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminCNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminC/c/FS-HT-V106?nav=/shop/Categories/VitaminsAndSupplements/VitaminC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin D',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminDNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminD/c/FS-HT-V107?nav=/shop/Categories/VitaminsAndSupplements/VitaminD',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamin E',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminENavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminE/c/FS-HT-V108?nav=/shop/Categories/VitaminsAndSupplements/VitaminE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Adults Multivitamins',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Prenatal Vitamins',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsPrenatalVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/PrenatalVitamins/c/FS-HT-V103?nav=/shop/Categories/VitaminsAndSupplements/PrenatalVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Supplements',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Omega Fish Oils & Essential Fatty Acids',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotics',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Joint Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hair, Nails & Skin Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Melatonin',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Health Food Supplements',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homeopathy',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Caffeine',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsCaffeineNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Caffeine/c/FS-HT-V212?nav=/shop/Categories/VitaminsAndSupplements/Caffeine',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Heart Health',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Women's Health",
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Men's Health",
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Mineral Supplements',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Calcium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsCalciumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Calcium/c/FS-HT-V301?nav=/shop/Categories/VitaminsAndSupplements/Calcium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Iron',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnesium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Potassium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsPotassiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Potassium/c/FS-HT-V304?nav=/shop/Categories/VitaminsAndSupplements/Potassium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Zinc',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsZincNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Zinc/c/FS-HT-V305?nav=/shop/Categories/VitaminsAndSupplements/Zinc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Other Minerals',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOtherMineralsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OtherMinerals/c/FS-HT-V306?nav=/shop/Categories/VitaminsAndSupplements/OtherMinerals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition & Weight Management',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Protein Bars & Snacks',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protein Liquid & Powder',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Meal Replacements',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMealReplacementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MealReplacements/c/FS-HT-V404?nav=/shop/Categories/VitaminsAndSupplements/MealReplacements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appetite Control',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAppetiteControlNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AppetiteControl/c/FS-HT-V405?nav=/shop/Categories/VitaminsAndSupplements/AppetiteControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sweeteners',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsSweetenersNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Sweeteners/c/FS-HT-V402?nav=/shop/Categories/VitaminsAndSupplements/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Webber Naturals for Sleep & Stress Relief',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_webber/wk13_featurecollecctiontile_webber_enfr.png',
                            imageLink:
                              '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Webber Naturals Vitamins',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWebberNaturalsFeaturedCollectionNavNode',
                          link: '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Bausch + Lomb Lumify Redness Reliever Eye Drops',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_bleyedrops/wk17_featurecollecctiontile_bauschlomb_enfr.png',
                            imageLink:
                              '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Bausch + Lomb Lumify Redness Reliever Eye Drops',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeDropsFeaturedCollectionNavNode',
                          link: '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Olly Multivitamins Gummies ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_ollygummyvitamins/wk25_featurecollecctiontile_ollygummy_enfr.png',
                            imageLink:
                              '/c/OLLY?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollection/Olly',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Olly Multivitamins Gummies ',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOllyFeaturedCollectionNavNode',
                          link: '/c/OLLY?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollection/Olly',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Vitalux Advanced Vitamins ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitalux Advanced Vitamins ',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Sexual Wellness & Family Planning',
                  uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Sexual Wellness',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubricants & Intimate Massage Oils',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Adult Toys',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptives',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Family Planning',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pregnancy Tests',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ovulation Kits & Tests',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sexual Wellness Gifts',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Sexual Wellness Gifts',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Sexual Wellness Gifts',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Eye, Ear & Foot Care',
                  uid: 'FrontShopMobileHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Eye Care',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Eye Drops & Lubricants',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeDropsAndLubricantsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants/c/FS-HT-E102?nav=/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Care Accessories',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eye Health Supplements',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eyeglasses',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contact Lens Solution',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ear Care',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEarCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EarCare/c/FS-HT-E200?nav=/shop/Categories/EyeEarAndFootCare/EarCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Ear Drops',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEarDropsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarDrops/c/FS-HT-E201?nav=/shop/Categories/EyeEarAndFootCare/EarDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ear Plugs',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEarPlugsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarPlugs/c/FS-HT-E202?nav=/shop/Categories/EyeEarAndFootCare/EarPlugs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Foot Care',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Compression Socks',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareCompressionSocksNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/CompressionSocks/c/FS-HT-E301?nav=/shop/Categories/EyeEarAndFootCare/CompressionSocks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Inserts, Insoles & Cushions',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Athlete's Foot & Antifungal",
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareAthletesFootAndAntifungalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal/c/FS-HT-E303?nav=/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Wart Removal',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareWartRemovalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/WartRemoval/c/FS-HT-E304?nav=/shop/Categories/EyeEarAndFootCare/WartRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Creams & Treatments',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments/c/FS-HT-E305?nav=/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Odor & Wetness Control',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diabetic Care',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareDiabetesCareNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/DiabeticCare/c/FS-HT-E308?nav=/shop/Categories/EyeEarAndFootCare/DiabeticCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foot Care Tools',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Swim Accessories',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home Health Care & Fitness',
                  uid: 'FrontShopMobileHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Compression Hosiery & Stockings',
                      uid: 'FrontShopMobileHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Scales, Pulse Oximeter &  Pedometers',
                      uid: 'FrontShopMobileHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Body Wellness & Massagers',
                      uid: 'FrontShopMobileHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bathroom Safety',
                      uid: 'FrontShopMobileHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Blood Pressure Monitors',
                      uid: 'FrontShopMobileHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cane & Crutches',
                      uid: 'FrontShopMobileHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Fitness Equipment & Accessories',
                      uid: 'FrontShopMobileHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-%26-Accessories/c/FS-HT-H700',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Baby & Child',
              uid: 'FrontShopMobileBabyAndChildNavNode',
              link: '/Baby-and-child?nav=/shop/babyandchild',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Baby & Child Care',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Diapers & Wipes',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Diapers',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Training Pants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Rash Treatment',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Diaper Pails Refills',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Wipes',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bath & Body Care',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Body Creams & Lotions',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Bath & Shampoos',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotton Swabs',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Oil',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Powders',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Children's Health Care",
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Children's Cough Cold & Flu",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Antihistamines",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Pain & Fever Relief",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief/c/FS-BC-B301?nav=/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Multivitamins & Vitamins",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyAndChildrensSupplementsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements/c/FS-BC-B304?nav=/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Childproofing & Safety',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Toys',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Clothing & Accessories',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Baby Gifts & Sets',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Feeding & Formula',
                  uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Baby Food & Formula',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formula',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Food & Toddler Snacks',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baby Cereal',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pediatric Nutrition',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nursing & Mealtime',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Baby Bottles & Nipples',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pacifier & Teething',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toddler Feeding Accessories',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Breastfeeding Essentials',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Toys',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Home & Electronics',
              uid: 'FrontShopMobileHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/shop/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Electronics',
                  uid: 'FrontShopMobileHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/mobile/shop/Categories/HomeAndElectronics/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Audio',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Headphones & Earbuds',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Speakers',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Batteries',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Specialty Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alkaline Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hearing Aid Batteries',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cameras & Phone Accessories',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cameras & Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Phones & Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Memory cards',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Computers & Smart Tech',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Connected Home',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Notebooks',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablets & eReaders',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Computer Accessories & Software',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Smart Watches & GPS',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-%26-Smart-Tech/Smartwatches/c/FS-EL-505',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Video Games',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles & Gaming Accessories',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Games',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Home & Lifestyle',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareNavNode',
                  link: '/c/FS-EL-Homeware?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Candles',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffusers',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Greeting Cards',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Seasonal Shop',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Featured Collections',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Refreshing Scents',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Refreshing Scents',
                          uid: 'FrontShopMobileHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Appliances',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Bedding & Mattresses',
                  uid: 'FrontShopMobileHomeAndElectronicsBeddingNavNode',
                  link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Mattresses',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Pillows',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Weighted Blankets & Covers',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Seasonal Shop',
                  uid: 'FrontShopMobileHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Categories/Home-%26-Electronics/Home-%26-Lifestyle/Seasonal-Shop/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0&lang=en',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offers',
              uid: 'FrontShopMobileOffersNavNode',
              link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Sale',
                  uid: 'FrontShopMobileOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance',
                  uid: 'FrontShopMobileOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AClearance%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase',
                  uid: 'FrontShopMobileOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AGift%2Bwith%2BPurchase%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'PC Optimum Offers',
                  uid: 'FrontShopMobileOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Prescriptions',
          uid: 'FrontShopMobilePrescriptionNavNode',
          link: 'https://mypharmacy.shoppersdrugmart.ca/en',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Pharmacy Services',
          uid: 'FrontShopMobilePharmacyServicesLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/en/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Health & Wellness',
          uid: 'FrontShopMobileHealthAndWellnessLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/en/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Electronics',
          uid: 'FrontShopMobileElectronicsNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopMobilePromotionsNavNode',
          link: 'https://shop.shoppersdrugmart.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopMobilePCOptimumNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'More by Shoppers',
          uid: 'FrontShopMobileMoreByShoppersNavNode',
          link: 'https://www1.shoppersdrugmart.ca/en/more-by-shoppers',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
    },
    fr: {
      navigation: [
        {
          name: 'Magasiner',
          uid: 'FrontShopShopNavNode',
          link: 'https://shop.shoppersdrugmart.ca/?lang=fr&_ga=2.29103732.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Temps des Fêtes',
              uid: 'FrontShopHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Découvrir les Fêtes',
                  uid: 'FrontShopHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Nos choix',
                  uid: 'FrontShopHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Exclusivités en ligne',
                  uid: 'FrontShopHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Cadeaux par prix",
                  uid: 'FrontShopHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Moins de 25 $',
                      uid: 'FrontShopHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Moins de 50 $',
                      uid: 'FrontShopHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Beauté',
                  uid: 'FrontShopHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Maquillage',
                      uid: 'FrontShopHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Produits de soin de la peau',
                      uid: 'FrontShopHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums',
                      uid: 'FrontShopHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins capillaires',
                      uid: 'FrontShopHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires',
                      uid: 'FrontShopHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et Maison',
                      uid: 'FrontShopHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Les Fêtes Quo Beauty',
                      uid: 'FrontShopHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Calendriers de l’Avent',
                      uid: 'FrontShopHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections Découverte',
                      uid: 'FrontShopHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coffrets économiques',
                      uid: 'FrontShopHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Soins personnels',
                  uid: 'FrontShopHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux Techno',
                  uid: 'FrontShopHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Jeux audio et vidéo',
                      uid: 'FrontShopHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Maison intelligente',
                      uid: 'FrontShopHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Bien-être',
                  uid: 'FrontShopHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Boutique pour hommes',
                  uid: 'FrontShopHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Parfums pour hommes',
                      uid: 'FrontShopHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Boutique pour hommes',
                      uid: 'FrontShopHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique pour enfants',
                  uid: 'FrontShopHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux pour animaux de compagnie',
                  uid: 'FrontShopHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Pour le bas de Noël',
                  uid: 'FrontShopHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux saisonniers et pour la maison',
                  uid: 'FrontShopHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Des choix bien réfléchis',
                  uid: 'FrontShopHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cartes de souhaits',
                  uid: 'FrontShopHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauté',
              uid: 'FrontShopBeautyNavNode',
              link: '/Beauty?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Cadeaux et ensembles',
                  uid: 'FrontShopBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins capillaires',
                      uid: 'FrontShopBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils de Beauté',
                      uid: 'FrontShopBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et cadeaux pour la maison',
                      uid: 'FrontShopBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux Par Prix',
                      uid: 'FrontShopBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sous 25$',
                          uid: 'FrontShopBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 50$',
                          uid: 'FrontShopBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 100$',
                          uid: 'FrontShopBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sur 100$',
                          uid: 'FrontShopBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Coffrets-cadeaux rapport prix',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Coffrets-cadeaux rapport prix',
                          uid: 'FrontShopBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "Calendriers de l'Avent",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Calendriers de l'Avent",
                          uid: 'FrontShopBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles de luxe',
                          uid: 'FrontShopBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles dermato',
                          uid: 'FrontShopBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Maquillage',
                  uid: 'FrontShopBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers?nav=/shop/Categories/Makeup/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Visage',
                      uid: 'FrontShopBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fonds de teint',
                          uid: 'FrontShopBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes BB et CC',
                          uid: 'FrontShopBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Correcteurs',
                          uid: 'FrontShopBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases',
                          uid: 'FrontShopBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres',
                          uid: 'FrontShopBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à joues',
                          uid: 'FrontShopBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits bronzants',
                          uid: 'FrontShopBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contouring',
                          uid: 'FrontShopBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Illuminateurs',
                          uid: 'FrontShopBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fixateurs de maquillage',
                          uid: 'FrontShopBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Yeux',
                      uid: 'FrontShopBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascaras',
                          uid: 'FrontShopBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à paupières',
                          uid: 'FrontShopBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traceurs',
                          uid: 'FrontShopBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases pour les yeux',
                          uid: 'FrontShopBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sourcils',
                          uid: 'FrontShopBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Faux cils',
                          uid: 'FrontShopBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lèvres',
                      uid: 'FrontShopBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rouges à lèvres',
                          uid: 'FrontShopBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brillants à lèvres',
                          uid: 'FrontShopBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Encres à lèvres',
                          uid: 'FrontShopBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Repulpeurs à lèvres',
                          uid: 'FrontShopBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baumes et traitements pour les lèvres',
                          uid: 'FrontShopBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crayons contour des lèvres',
                          uid: 'FrontShopBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Palettes de maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-T101?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-T102?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-T103?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-T104?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ongles',
                      uid: 'FrontShopBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Vernis à ongles',
                          uid: 'FrontShopBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Couches de base et de finition',
                          uid: 'FrontShopBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-T106?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maquillage de Luxe',
                          uid: 'FrontShopBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Maquillage dermato',
                          uid: 'FrontShopBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Maquillage',
                          uid: 'FrontShopBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de maquillage',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de maquillage',
                          uid: 'FrontShopBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux des Fêtes Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux des Fêtes Quo Beauty',
                          uid: 'FrontShopBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins de la peau',
                  uid: 'FrontShopBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers?nav=/shop/Categories/SkinCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hydratants pour le visage',
                      uid: 'FrontShopBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes de nuit',
                          uid: 'FrontShopBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brumes pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nettoyants',
                      uid: 'FrontShopBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=shop/Categories/SkinCare/FaceWashAndCleansers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants et gommages pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toniques',
                          uid: 'FrontShopBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Traitements',
                      uid: 'FrontShopBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sérums',
                          uid: 'FrontShopBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins anti-âge',
                          uid: 'FrontShopBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins éclaircissants',
                          uid: 'FrontShopBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Traitements contre l'acné",
                          uid: 'FrontShopBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masques',
                      uid: 'FrontShopBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Masques pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques en feuille',
                          uid: 'FrontShopBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins contour des yeux',
                      uid: 'FrontShopBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes et traitements pour les lèvres',
                      uid: 'FrontShopBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le visage',
                          uid: 'FrontShopBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le corps',
                          uid: 'FrontShopBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-T201?nav=shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-T203?nav=shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins de la peau pour le corps',
                      uid: 'FrontShopBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soin de la peau de luxe',
                          uid: 'FrontShopBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin de la peau dermato',
                          uid: 'FrontShopBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins de la peau',
                          uid: 'FrontShopBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: "Outil d'analyse",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P1/WK02/CollectionTile/FR/wk02_featuredcollectiontile_skintool_b1_fr.png',
                            imageLink: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/skindiagnostic',
                            __typename: 'NavPromoNode',
                          },
                          name: "Outil d'analyse",
                          uid: 'FrontShopBeautySkinCareSkinDiagnosticFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Magasiner les soins de la peau selon les ingrédients',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P3/wk09/feature-collection/featuredcollectiontile_p3clinical_skincare/wk09_featurecollecctiontile_p3clinicalskincare_enfr.png',
                            imageLink:
                              '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Magasiner les soins de la peau selon les ingrédients',
                          uid: 'FrontShopBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins de la peau',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins de la peau',
                          uid: 'FrontShopBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins capillaires',
                  uid: 'FrontShopBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers?nav=/shop/Categories/HairCare/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampooings et revitalisants',
                      uid: 'FrontShopBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampooing',
                          uid: 'FrontShopBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Revitalisant',
                          uid: 'FrontShopBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shampooing sec',
                          uid: 'FrontShopBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Type de cheveux',
                      uid: 'FrontShopBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fins et plats',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Raides',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ondulés et frisés',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rêches et épais',
                          uid: 'FrontShopBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-T400?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-T401?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-T403?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Préoccupation capillaire',
                      uid: 'FrontShopBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brillance',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Abîmé',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des frisottis',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sécheresse et pellicules',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volume',
                          uid: 'FrontShopBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits coiffants et traitements',
                      uid: 'FrontShopBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Traitements capillaires',
                          uid: 'FrontShopBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques capillaires',
                          uid: 'FrontShopBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateur pour cheveux',
                          uid: 'FrontShopBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mousse capillaire',
                          uid: 'FrontShopBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cire et gel pour cheveux',
                          uid: 'FrontShopBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour perte et croissance des cheveux',
                          uid: 'FrontShopBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Colorants capillaires',
                      uid: 'FrontShopBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Colorants capillaires permanents',
                          uid: 'FrontShopBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Retouche des racines',
                          uid: 'FrontShopBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Colorants capillaires temporaires',
                          uid: 'FrontShopBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-H500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-T503?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopBeautyHairCareClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/HairCare/HairAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles pour les cheveux',
                      uid: 'FrontShopBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-G400?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins capilaires de luxe',
                          uid: 'FrontShopBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins capilaires dermato',
                          uid: 'FrontShopBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins capillaires',
                          uid: 'FrontShopBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins capillaire',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins capillaire',
                          uid: 'FrontShopBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Parfums',
                  uid: 'FrontShopBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers?nav=/shop/Categories/Fragrance/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour elles',
                      uid: 'FrontShopBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Vaporisateurs et brumes parfumées pour le corps',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour elle',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour lui',
                          uid: 'FrontShopBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Bougies et parfums d'ambiance",
                      uid: 'FrontShopBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums de luxe',
                          uid: 'FrontShopBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de parfums',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-fragrance-gifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de parfums',
                          uid: 'FrontShopBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers?nav=/shop/Categories/ToolsAndAccessories/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour les cheveux',
                      uid: 'FrontShopBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et bandanas',
                          uid: 'FrontShopBeautyToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de luxe',
                          uid: 'FrontShopBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires dermato',
                          uid: 'FrontShopBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Outils de coiffage pros',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2020/evergreen/collection-tiles/menufeaturedtile_toolsaccessories_b1_fr.jpg',
                            imageLink:
                              '/c/FS-T400?nav=/shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Outils de coiffage pros',
                          uid: 'FrontShopBeautyToolsAndAccessoriesCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Outils et accessoires de Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/Evergreen/collection-tiles-nav/quo/wk16_featurecollectiontile_quo-tools-accessories_enfr.png',
                            imageLink:
                              '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Outils et accessoires de Quo Beauty',
                          uid: 'FrontShopBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Boutique masculine',
                  uid: 'FrontShopBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers?nav=/shop/Categories/Mens/BestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins de la peau pour lui',
                      uid: 'FrontShopBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nettoyants et accessoires',
                          uid: 'FrontShopBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements',
                          uid: 'FrontShopBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baume à lèvres',
                          uid: 'FrontShopBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité',
                          uid: 'FrontShopBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et produits de rasage',
                          uid: 'FrontShopBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-rasage',
                          uid: 'FrontShopBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins capillaires pour lui',
                      uid: 'FrontShopBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins masculins de luxe',
                          uid: 'FrontShopBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins masculins dermato',
                          uid: 'FrontShopBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins pour hommes',
                          uid: 'FrontShopBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux pour hommes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux pour hommes',
                          uid: 'FrontShopBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Magasiner par Marques',
                  uid: 'FrontShopBeautyShopByBrandsNavNode',
                  link: '/all-brands?nav=shop/beauty/shopallbrand',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Marques Populaires',
                      uid: 'FrontShopBeautyBrandsPopularBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'DysonName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_dyson.png',
                            imageLink: '/c/DYSON',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Dyson',
                          uid: 'FrontShopBeautyBrandsdysonPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LancomeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_lancome.png',
                            imageLink: '/c/LANCOME?nav=/brands/lancome',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Lancome',
                          uid: 'FrontShopBeautyBrandsLancomePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'REMName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.amazonaws.com/site-creative/2022/beauty-brand-tiles/menubrandtile_rembeauty.png',
                            imageLink: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                            __typename: 'NavPromoNode',
                          },
                          name: 'REM',
                          uid: 'FrontShopBeautyBrandsREMPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'LaRochePosayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_laorocheposay.png',
                            imageLink: '/c/LA%2CROCHE%2CPOSAY?nav=/brands/larocheposay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'La Roche Posay',
                          uid: 'FrontShopBeautyBrandsLaRochePosayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'CeraVeName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_cerave.png',
                            imageLink: '/c/CERAVE?nav=/brands/cerave',
                            __typename: 'NavPromoNode',
                          },
                          name: 'CeraVe',
                          uid: 'FrontShopBeautyBrandsCeraVePopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'QuoBeautyName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_quobeauty.png',
                            imageLink: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/quobeauty',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Quo Beauty',
                          uid: 'FrontShopBeautyBrandsQuoBeautyPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "L'OrealName",
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_loreal.png',
                            imageLink: '/c/L%27OREAL',
                            __typename: 'NavPromoNode',
                          },
                          name: "L'Oreal",
                          uid: 'FrontShopBeautyBrandsLOrealPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'OlayName',
                            imageUrl:
                              'https://bb-prod-marketing-image.s3.us-east-1.amazonaws.com/site-creative/2020/P11/WK41/nav-brand-logos/menubrandtile_olay.png',
                            imageLink: '/c/OLAY?nav=/brands/olay',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Olay',
                          uid: 'FrontShopBeautyBrandsOlayPopularNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Marques en vedette',
                      uid: 'FrontShopBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA%2CMERCIER?nav=/brands/lauramercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=/brands/versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO%2CFACED?nav=/brands/toofaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=/brands/foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=/brands/nars',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Soins personnels',
              uid: 'FrontShopPersonalCareNavNode',
              link: '/Personal-care?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Produits pour le corps et le bain',
                  uid: 'FrontShopPersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soins corporels',
                      uid: 'FrontShopPersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et beurres pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes raffermissantes et pour les vergetures',
                          uid: 'FrontShopPersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopPersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bain et douche',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le corps et gels de douche',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sels de bains et bain moussant',
                          uid: 'FrontShopPersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants corporels',
                          uid: 'FrontShopPersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de bain',
                          uid: 'FrontShopPersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des mains et des pieds',
                      uid: 'FrontShopPersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Savons à main',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions et crèmes pour les mains',
                          uid: 'FrontShopPersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et masques pour les pieds',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils de soins des pieds',
                          uid: 'FrontShopPersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Désinfectants pour les mains',
                          uid: 'FrontShopPersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes pour les lèvres',
                      uid: 'FrontShopPersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Déodorant et antisudorifique',
                      uid: 'FrontShopPersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Déodorant',
                          uid: 'FrontShopPersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eau parfumante et poudre pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Protection solaire',
                      uid: 'FrontShopPersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écran solaire pour le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopPersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopPersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour le bain et le corps',
                      uid: 'FrontShopPersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits pour le bain et le corps',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins pour le corps et le bain',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_bathandbodycare/wk13_featurecollecctiontile_bath-body-care_enfr.png',
                            imageLink:
                              '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins pour le corps et le bain',
                          uid: 'FrontShopPersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins intimes',
                  uid: 'FrontShopPersonalCareFeminineCareNavNode',
                  link: '/c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Serviettes hygiéniques et protège-dessous',
                      uid: 'FrontShopPersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Nettoyants et désodorisants pour hygiène intime',
                      uid: 'FrontShopPersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopPersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Traitements contre les infections aux levures',
                      uid: 'FrontShopPersonalCareFeminineCareYeastInfectionTreatmentsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/YeastInfectionTreatments/c/FS-PC-F400?nav=/shop/Categories/FeminineCare/YeastInfectionTreatments',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coupe menstruelle',
                      uid: 'FrontShopPersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits soins intimes ',
                          uid: 'FrontShopPersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins intimes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_intimatecare/wk05_featurecollecctiontile_intimatecare_enfr.png',
                            imageLink:
                              '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins intimes',
                          uid: 'FrontShopPersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Contrôle de la vessie & incontinence',
                  uid: 'FrontShopPersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Doublures et serviettes pour incontinence',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sous-vêtements protecteurs',
                      uid: 'FrontShopPersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareBladderControlFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins dentaires',
                  uid: 'FrontShopPersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Brosses à dents',
                      uid: 'FrontShopPersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brosses à dents électriques',
                          uid: 'FrontShopPersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses à dents',
                          uid: 'FrontShopPersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits de soins dentaires',
                      uid: 'FrontShopPersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dentifrice',
                          uid: 'FrontShopPersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blanchissement des dents',
                          uid: 'FrontShopPersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rince-bouches',
                          uid: 'FrontShopPersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rafraîchisseurs d’haleine',
                          uid: 'FrontShopPersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins dentaires',
                          uid: 'FrontShopPersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopPersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soie dentaire',
                          uid: 'FrontShopPersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopPersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins buccodentaires',
                          uid: 'FrontShopPersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v2/wk13_featurecollecctiontile_thoughtfulchoices_v2_enfr.png',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopPersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Soins buccaux',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk05/front-shop/feature-collection/featurecollectiontile_oralcare/wk05_featurecollecctiontile_oralcare_enfr.png',
                            imageLink:
                              '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Soins buccaux',
                          uid: 'FrontShopPersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Rasage et épilation',
                  uid: 'FrontShopPersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Crèmes et gels de rasage',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cires et crèmes dépilatoires',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoir électrique',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoirs et lames jetables',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Appareils dépilatoires',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires de toilette',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Rasage et épilation',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_shavinghair/wk17_featurecollecctiontile_shavinghairremoval_enfr.png',
                            imageLink:
                              '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Rasage et épilation',
                          uid: 'FrontShopPersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Pour hommes',
                  uid: 'FrontShopPersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopPersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes & gels de rasage',
                          uid: 'FrontShopPersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopPersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopPersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopPersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopPersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles à cheveux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de rasage et accessoires de toilette',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rasoirs électriques',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils dépilatoires',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de garde-robe',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bijoux',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soutiens-gorge accessoires',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bas et collants',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Chaussettes',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’hiver',
                          uid: 'FrontShopPersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de voyage',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires météorologiques',
                      uid: 'FrontShopPersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareToolsAccessFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Articles format voyage',
                  uid: 'FrontShopPersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopPersonalCareTravelSizedItemsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Lutte contre les insectes et animaux nuisibles',
                  uid: 'FrontShopPersonalCareInsectPestControlNavNode',
                  link: '/Shop/Catégories/Soins-personnels/Lutte-contre-les-insectes-et-animaux-nuisiblesLutte-contre-les-insectes-et-animaux-nuisibles/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Santé',
              uid: 'FrontShopHealthNavNode',
              link: '/Health?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Médicaments et traitements',
                  uid: 'FrontShopHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toux, rhume et grippe',
                      uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe',
                          uid: 'FrontShopHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins nasaux et aides-sommeil',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalRubNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicalRub/c/FS-MT-107?nav=/shop/Categories/MedicineAndTreatments/TopicalRub',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermomètres',
                          uid: 'FrontShopHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Abandon du tabac',
                      uid: 'FrontShopHealthMedicineAndTreatmentsQuitSmokingNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/QuitSmoking/c/FS-HT-M700?nav=/shop/Categories/MedicineAndTreatments/QuitSmoking',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Aides au sommeil',
                      uid: 'FrontShopHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Organisation des médicaments',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soulagement de la douleur',
                      uid: 'FrontShopHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soulagement des douleurs musculaires, dorsales et articulaires',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMuscleBackAndJointPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief/c/FS-HT-M202?nav=/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topiques pour le soulagement de la douleur',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement des hémorroïdes',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHemorrhoidReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HemorrhoidRelief/c/FS-HT-M206?nav=/shop/Categories/MedicineAndTreatments/HemorrhoidRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement contre la douleur buccale',
                          uid: 'FrontShopHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement chaud et froid',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la douleur et de la fièvre pour enfants',
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief/c/FS-HT-M204?nav=/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement des maux de tête et de la fièvre',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHeadacheAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief/c/FS-HT-M201?nav=/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement de santé cardiaque',
                          uid: 'FrontShopHealthMedicineAndTreatmentsHeartHealthTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose/c/FS-HT-M205?nav=/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Douleurs menstruelles',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMenstrualPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MenstrualPainRelief/c/FS-HT-M208?nav=/shop/Categories/MedicineAndTreatments/MenstrualPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Premiers soins',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fournitures pour pansements et ruban',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la peau',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fournitures de premiers soins',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins contre les poux',
                          uid: 'FrontShopHealthMedicineAndTreatmentsLiceCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/LiceCare/c/FS-HT-M406?nav=/shop/Categories/MedicineAndTreatments/LiceCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Articles de contention et vêtements médicaux',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin des brûlures et des plaies',
                          uid: 'FrontShopHealthMedicineAndTreatmentsBurnAndWoundCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BurnAndWoundCare/c/FS-HT-M404?nav=/shop/Categories/MedicineAndTreatments/BurnAndWoundCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sinus et allergies',
                      uid: 'FrontShopHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistaminiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins du nez',
                          uid: 'FrontShopHealthMedicineAndTreatmentsNasalCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M503?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé digestive',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Reflux gastrique',
                          uid: 'FrontShopHealthMedicineAndTreatmentsAcidRefluxNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/AcidReflux/c/FS-HT-M301?nav=/shop/Categories/MedicineAndTreatments/AcidReflux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fibres & Laxatives',
                          uid: 'FrontShopHealthMedicineAndTreatmentsFibresAndLaxativesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FibresAndLaxatives/c/FS-HT-M303?nav=/shop/Categories/MedicineAndTreatments/FibresAndLaxatives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mal des transports et nausées',
                          uid: 'FrontShopHealthMedicineAndTreatmentsMotionSicknessAndNauseaNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea/c/FS-HT-M305?nav=/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intolérance digestive',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lavements',
                          uid: 'FrontShopHealthMedicineAndTreatmentsEnemasNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Enemas/c/FS-HT-M307?nav=/shop/Categories/MedicineAndTreatments/Enemas',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la diarrhée',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiarrheaReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiarrheaRelief/c/FS-HT-M304?nav=/shop/Categories/MedicineAndTreatments/DiarrheaRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour les diabétiques',
                      uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Test de glycémie',
                          uid: 'FrontShopHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Administration de l’insuline',
                          uid: 'FrontShopHealthMedicineAndTreatmentsInsulinAdminstrationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/InsulinAdminstration/c/FS-HT-M602?nav=/shop/Categories/MedicineAndTreatments/InsulinAdminstration',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour diabétiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesSupplementsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSupplements/c/FS-HT-M603?nav=/shop/Categories/MedicineAndTreatments/DiabeticSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins de la peau pour diabétiques',
                          uid: 'FrontShopHealthMedicineAndTreatmentsDiabetesSkinCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Édulcorants',
                          uid: 'FrontShopHealthMedicineAndTreatmentsSweetenersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Sweeteners/c/FS-HT-M606?nav=/shop/Categories/MedicineAndTreatments/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Équipement de protection individuelle ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Équipement de protection individuelle ',
                          uid: 'FrontShopHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tylenol Soulagement de la douleur, extra-fort',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_tylenol/wk17_featurecollecctiontile_tylenol_enfr.png',
                            imageLink:
                              '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tylenol Soulagement de la douleur, extra-fort',
                          uid: 'FrontShopHealthMedicineAndTreatmentsTylenolPainReliefFeaturedCollectionNavNode',
                          link: '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamines et suppléments',
                  uid: 'FrontShopHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamines',
                      uid: 'FrontShopHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Multivitamines pour adultes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Multivitamines pour enfants',
                          uid: 'FrontShopHealthVitaminsAndSupplementsChildrensMultivitaminsAndVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins/c/FS-HT-V102?nav=/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine A',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminANavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminA/c/FS-HT-V104?nav=/shop/Categories/VitaminsAndSupplements/VitaminA',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine B',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminBNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminB/c/FS-HT-V105?nav=/shop/Categories/VitaminsAndSupplements/VitaminB',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine C',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminCNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminC/c/FS-HT-V106?nav=/shop/Categories/VitaminsAndSupplements/VitaminC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine D',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminDNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminD/c/FS-HT-V107?nav=/shop/Categories/VitaminsAndSupplements/VitaminD',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine E',
                          uid: 'FrontShopHealthVitaminsAndSupplementsVitaminENavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminE/c/FS-HT-V108?nav=/shop/Categories/VitaminsAndSupplements/VitaminE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamines prénatales',
                          uid: 'FrontShopHealthVitaminsAndSupplementsPrenatalVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/PrenatalVitamins/c/FS-HT-V103?nav=/shop/Categories/VitaminsAndSupplements/PrenatalVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments',
                      uid: 'FrontShopHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Huiles de poisson riches en oméga',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des articulations',
                          uid: 'FrontShopHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des yeux',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins des cheveux, des ongles et de la peau',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mélatonine',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments alimentaires naturels',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homéopathie',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Caféine',
                          uid: 'FrontShopHealthVitaminsAndSupplementsCaffeineNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Caffeine/c/FS-HT-V212?nav=/shop/Categories/VitaminsAndSupplements/Caffeine',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé du cœur',
                          uid: 'FrontShopHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des femmes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des hommes',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments de minéraux',
                      uid: 'FrontShopHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Calcium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsCalciumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Calcium/c/FS-HT-V301?nav=/shop/Categories/VitaminsAndSupplements/Calcium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fer',
                          uid: 'FrontShopHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnésium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Potassium',
                          uid: 'FrontShopHealthVitaminsAndSupplementsPotassiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Potassium/c/FS-HT-V304?nav=/shop/Categories/VitaminsAndSupplements/Potassium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Zinc',
                          uid: 'FrontShopHealthVitaminsAndSupplementsZincNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Zinc/c/FS-HT-V305?nav=/shop/Categories/VitaminsAndSupplements/Zinc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Autres minéraux',
                          uid: 'FrontShopHealthVitaminsAndSupplementsOtherMineralsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OtherMinerals/c/FS-HT-V306?nav=/shop/Categories/VitaminsAndSupplements/OtherMinerals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition et gestion du poids',
                      uid: 'FrontShopHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Barres protéinées et collations',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Édulcorants',
                          uid: 'FrontShopHealthVitaminsAndSupplementsSweetenersNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Sweeteners/c/FS-HT-V402?nav=/shop/Categories/VitaminsAndSupplements/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protéines liquides et en poudre',
                          uid: 'FrontShopHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Substituts de repas',
                          uid: 'FrontShopHealthVitaminsAndSupplementsMealReplacementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MealReplacements/c/FS-HT-V404?nav=/shop/Categories/VitaminsAndSupplements/MealReplacements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle de l’appétit',
                          uid: 'FrontShopHealthVitaminsAndSupplementsAppetiteControlNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AppetiteControl/c/FS-HT-V405?nav=/shop/Categories/VitaminsAndSupplements/AppetiteControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Gouttes oculaires antirougeur Lumify de Bausch + Lomb',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_bleyedrops/wk17_featurecollecctiontile_bauschlomb_enfr.png',
                            imageLink:
                              '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Gouttes oculaires antirougeur Lumify de Bausch + Lomb',
                          uid: 'FrontShopHealthVitaminsAndSupplementsEyeDropsFeaturedCollectionNavNode',
                          link: '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bien-être sexuel et planification familiale',
                  uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bien-être sexuel',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubrifiants et huile pour massage intime',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jouets sexuels',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptifs',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Planification familiale',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Trousses et tests d’ovulation',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tests de grossesse',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de bien-être sexuel ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de bien-être sexuel ',
                          uid: 'FrontShopHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins des yeux, des oreilles et des pieds',
                  uid: 'FrontShopHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soin des yeux',
                      uid: 'FrontShopHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Gouttes pour les yeux et soulagement',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeDropsAndLubricantsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants/c/FS-HT-E102?nav=/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour entretien des verres de contact',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour la santé oculaire',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Solution pour verres de contact',
                          uid: 'FrontShopHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lunettes',
                          uid: 'FrontShopHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des oreilles',
                      uid: 'FrontShopHealthEyeEarAndFootCareEarCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EarCare/c/FS-HT-E200?nav=/shop/Categories/EyeEarAndFootCare/EarCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Gouttes pour les oreilles',
                          uid: 'FrontShopHealthEyeEarAndFootCareEarDropsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarDrops/c/FS-HT-E201?nav=/shop/Categories/EyeEarAndFootCare/EarDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bouchons d’oreilles',
                          uid: 'FrontShopHealthEyeEarAndFootCareEarPlugsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarPlugs/c/FS-HT-E202?nav=/shop/Categories/EyeEarAndFootCare/EarPlugs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Articles de soins des pieds',
                      uid: 'FrontShopHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Chaussettes de contention',
                          uid: 'FrontShopHealthEyeEarAndFootCareCompressionSocksNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/CompressionSocks/c/FS-HT-E301?nav=/shop/Categories/EyeEarAndFootCare/CompressionSocks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coussinets et semelles intérieures',
                          uid: 'FrontShopHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pied d’athlète et antifongiques',
                          uid: 'FrontShopHealthEyeEarAndFootCareAthletesFootAndAntifungalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal/c/FS-HT-E303?nav=/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre les verrues',
                          uid: 'FrontShopHealthEyeEarAndFootCareWartRemovalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/WartRemoval/c/FS-HT-E304?nav=/shop/Categories/EyeEarAndFootCare/WartRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements pour les pieds',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments/c/FS-HT-E305?nav=/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des odeurs et de l’humidité',
                          uid: 'FrontShopHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins pour les diabétiques',
                          uid: 'FrontShopHealthEyeEarAndFootCareDiabetesCareNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/DiabeticCare/c/FS-HT-E308?nav=/shop/Categories/EyeEarAndFootCare/DiabeticCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins des pieds',
                          uid: 'FrontShopHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour la natation',
                      uid: 'FrontShopHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthEyeEarAndFootCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins de santé à domicile et conditionnement physique',
                  uid: 'FrontShopHealthHomeHealthAndFitnessCareNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bas et chaussettes de compression',
                      uid: 'FrontShopHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Balances, saturomètre et podomètres',
                      uid: 'FrontShopHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bien-être et appareils de massage',
                      uid: 'FrontShopHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sécurité pour la salle de bain',
                      uid: 'FrontShopHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tensiomètres',
                      uid: 'FrontShopHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cannes et béquilles',
                      uid: 'FrontShopHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Équipements et accessoires de conditionnement physique',
                      uid: 'FrontShopHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-&-Accessories/c/FS-HT-H700?nav=/shop/Categories/HomeHealthCare/FitnessEquipmentAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHealthHomeHealthCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Bébé et enfant',
              uid: 'FrontShopBabyAndChildNavNode',
              link: '/Baby-and-child?nav=/shop/babyandchild',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Soins pour bébés et enfants',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Couches et lingettes',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Couches',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Culottes d'entraînement",
                          uid: 'FrontShopBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre l’érythème fessier',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Recharges pour poubelles à couches',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lingettes pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour le corps et le bain',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et lotions pour le corps',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits pour le bain et shampooings',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotons-tiges',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huile pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres pour bébés',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé des enfants',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe pour enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la douleur et de la fièvre des enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief/c/FS-BC-B301?nav=/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Multivitamines pour enfants',
                          uid: 'FrontShopBabyAndChildBabyAndChildCareBabyAndChildrensSupplementsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements/c/FS-BC-B304?nav=/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sécurité et protection des enfants',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Jouets',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Vêtements et accessoires',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour bébés',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Alimentation et préparations',
                  uid: 'FrontShopBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Aliments et préparations pour bébés',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formule',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Aliments pour bébés et collations pour tout-petits',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Céréales pour bébés',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alimentation pédiatrique',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allaitement et heure du repas',
                      uid: 'FrontShopBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Essentiels pour l’allaitement',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’alimentation des tout-petits',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Biberons et tétines',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suces et jouets de dentition',
                          uid: 'FrontShopBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Jouets',
                  uid: 'FrontShopBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Maison et électronique',
              uid: 'FrontShopHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/shop/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Électronique',
                  uid: 'FrontShopHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/shop/Categories/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Systèmes audios',
                      uid: 'FrontShopHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écouteurs',
                          uid: 'FrontShopHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Haut-parleurs',
                          uid: 'FrontShopHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Piles',
                      uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Piles spécialisées',
                          uid: 'FrontShopHomeElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles alcalines',
                          uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles pour appareil auditif',
                          uid: 'FrontShopHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Accessoires de téléphone et d'appareil photo",
                      uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Appareils photos & accessoires',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Téléphones et accessoires',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cartes mémoire',
                          uid: 'FrontShopHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ordinateurs Et Technologies Connectées',
                      uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maison connectée',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Carnets',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablettes et lecteurs électroniques',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndEReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour ordinateurs et logiciels',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Montres intelligentes et GPS',
                          uid: 'FrontShopHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-&-Smart-Tech/Smartwatches/c/FS-EL-505?nav=/shop/Categories/Electronics/SmartWatchesAndGPS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Jeux vidéo',
                      uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles et accessoires de jeux',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jeux',
                          uid: 'FrontShopHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Produits électroniques Apple',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P3/WK12/menu-featuretile/menufeaturetile_apple_enfr.jpg',
                            imageLink: '/c/APPLE?nav=/shop/electronicselectronicsapplefeaturedcollection',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Produits électroniques Apple',
                          uid: 'FrontShopHomeAndElectronicsElectronicsFeaturedCollectionAppleNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Maison et style de vie',
                  uid: 'FrontShopHomeAndElectronicsHomewareNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Homeware?nav=/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bougies ',
                      uid: 'FrontShopHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffuseurs',
                      uid: 'FrontShopHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cartes de souhaits',
                      uid: 'FrontShopHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingsCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Saisonnier',
                      uid: 'FrontShopHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Parfums rafraîchissants',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Parfums rafraîchissants',
                          uid: 'FrontShopHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Électroménagers',
                  uid: 'FrontShopHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Linge de lit et matelas',
                  uid: 'FrontShopHomeAndElectronicsBeddingNavNode',
                  link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Matelas',
                      uid: 'FrontShopHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Oreillers ',
                      uid: 'FrontShopHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Couvertures lestées et housses de couette',
                      uid: 'FrontShopHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique saisonnière',
                  uid: 'FrontShopHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Cat%C3%A9gories/Maison-et-%C3%A9lectronique/Maison-et-style-de-vie/Saisonnier/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offres',
              uid: 'FrontShopOffersNavNode',
              link: '/c/FS-Offers?nav=/shop/offers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Solde',
                  uid: 'FrontShopOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Liquidation',
                  uid: 'FrontShopOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/clearance&q=:trending:promotions:Clearance:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeau avec achat',
                  uid: 'FrontShopOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=/shop/Categories/Offers/GWP&q=:trending:promotions:Gift+with+Purchase:showInStock:true&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Offres PC Optimum',
                  uid: 'FrontShopOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Ordonnances',
          uid: 'FrontShopPrescriptionNavNode',
          link: 'https://mypharmacy.shoppersdrugmart.ca/fr',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Services pharmaceutiques',
          uid: 'FrontShopPharmacyServicesLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/fr/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Santé et bien-être',
          uid: 'FrontShopHealthAndWellnessLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/fr/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Électroniques',
          uid: 'FrontShopElectronicsNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopPromotionsNavNode',
          link: 'https://shop.shoppersdrugmart.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopPCOptimumNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Autres services de Shoppers',
          uid: 'FrontShopMoreByShoppersNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/more-by-shoppers',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
      footer: [
        {
          name: 'Magasiner par catégorie populaire',
          link: null,
          uid: 'FrontShopFooterShopNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Beauté',
              link: '/Beauty',
              uid: 'FrontShopFooterShopBeautyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Soins Personnels',
              link: '/c/FS-PC?nav=%2Fshop%2Fpersonal&sort=trending&page=0',
              uid: 'FrontShopFooterShopPersonalCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Santé',
              link: '/c/FS-HT?nav=%2Fshop%2Fhealth&sort=trending&page=0',
              uid: 'FrontShopFooterShopHealthNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Bébé et enfant',
              link: '/c/FS-BC?nav=%2Fshop%2Fbaby&sort=trending&page=0',
              uid: 'FrontShopFooterShopBabyAndChildNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Électronique',
              link: '/c/FS-EL?nav=%2Fshop%2Felectronics&sort=trending&page=0',
              uid: 'FrontShopFooterShopElectronicsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Offres',
              link: '/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0',
              uid: 'FrontShopFooterShopOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Service à la clientèle',
          link: null,
          uid: 'FrontShopFooterCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Contactez nous',
              link: '/contactus',
              uid: 'FrontShopFooterContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Retours et échanges',
              link: 'https://shop.shoppersdrugmart.ca/editorials/returns',
              uid: 'FrontShopFooterReturnsExchangesNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://shop.shoppersdrugmart.ca/editorials/faq',
              uid: 'FrontShopFooterFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Livraison et gestion des commandes',
              link: 'https://shop.shoppersdrugmart.ca/editorials/shipping',
              uid: 'FrontShopFooterShippingHandlingNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Historique des commandes',
              link: '/my-account/orders',
              uid: 'FrontShopFooterOrderHistoryNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Des offres',
          link: null,
          uid: 'FrontShopFooterOffersNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Voir toutes les offres exclusives en magasin',
              link: 'https://www1.shoppersdrugmart.ca/fr/flyer',
              uid: 'FrontShopFooterInstoreExclusiveOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Voir la circulaire',
              link: 'https://www1.shoppersdrugmart.ca/fr/pcoptimum/in-store-offers',
              uid: 'FrontShopFooterVieweflyerNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Programme PC Optimum',
          link: null,
          uid: 'FrontShopFooterPCOptimumProgramNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Ouvrir une session',
              link: 'https://accounts.pcid.ca/login',
              uid: 'FrontShopFooterSignInNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Voir toutes les offres PC Optimum',
              link: 'https://www.pcoptimum.ca/',
              uid: 'FrontShopFooterViewOptimuOffersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Inscrivez-vous',
              link: 'https://www.pcoptimum.ca/register?sid=home|missrewards|getstarted2',
              uid: 'FrontShopFooterJoinNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'FAQ',
              link: 'https://loblaw.force.com/PCoptimumsupport/s/?language=fr',
              uid: 'FrontShopFooterOptimumFAQNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'À propos de Shoppers Drug Mart',
          link: null,
          uid: 'FrontShopFooterAboutShoppersDrugMartNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Nouvelles et annonces',
              link: 'https://www1.shoppersdrugmart.ca/fr/news',
              uid: 'FrontShopFooterNewsAndAnnouncementsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Notre entreprise',
              link: 'https://corporate.shoppersdrugmart.ca/fr-ca/Home.aspx',
              uid: 'FrontShopFooterCorporateNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: "Nouvelles de l'entreprise",
              link: 'https://media.loblaw.ca/French/centre-media/communiques-de-presse/default.aspx',
              uid: 'FrontShopFooterCorporateNewsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Responsabilité sociale',
              link: 'https://www1.shoppersdrugmart.ca/fr/love-you',
              uid: 'FrontShopFooterSocialResponsibilityNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Carrières',
              link: 'https://carrieres.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterCareersNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Acquisition de pharmacie',
              link: 'http://corporate.shoppersdrugmart.ca/fr-ca/pharmacy-acquisition',
              uid: 'FrontShopFooterPharmacyAcquisitionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Information juridique',
              link: 'http://corporate.shoppersdrugmart.ca/fr-ca/legal',
              uid: 'FrontShopFooterLegalNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Confidentialité',
              link: 'https://www.loblaw.ca/fr/privacy.html',
              uid: 'FrontShopFooterPrivacyNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'Service Clients',
          link: null,
          uid: 'FrontShopFooterSDMCustomerServiceNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Rappel de produit',
              link: 'https://www1.shoppersdrugmart.ca/fr/product-recall',
              uid: 'FrontShopFooterSDMProductRecallNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Contacter le support du magasin',
              link: 'https://www1.shoppersdrugmart.ca/fr/contact-us',
              uid: 'FrontShopFooterSDMContactUsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: "Obtenir de l'aide",
              link: 'https://gethelp.shoppersdrugmart.ca/',
              uid: 'FrontShopFooterSDMGetHelpNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Remboursements',
              link: 'https://www1.shoppersdrugmart.ca/fr/refunds',
              uid: 'FrontShopFooterSDMRefundsNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
        {
          name: 'En magasin',
          link: null,
          uid: 'FrontShopFooterVisitAStoreNavNode',
          hasChildren: true,
          child: [
            {
              name: 'Renouveler une ordonnance',
              link: 'https://mypharmacy.shoppersdrugmart.ca/fr',
              uid: 'FrontShopFooterRenewOrRefillPrescriptionNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Localisateur de magasin',
              link: 'https://stores.shoppersdrugmart.ca/fr/',
              uid: 'FrontShopFooterStoreLocatorNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Photo',
              link: 'https://www.shoppersphoto.ca/?lang=fr',
              uid: 'FrontShopFooterShoppersPhotoNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Shoppers Maison et Santé',
              link: 'https://www.shoppershomehealthcare.ca/',
              uid: 'FrontShopFooterShoppersHomeHealthCareNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
            {
              name: 'Cartes-cadeaux',
              link: 'https://www1.shoppersdrugmart.ca/fr/food-and-home/gift-cards',
              uid: 'FrontShopFooterGiftCardNavNode',
              hasChildren: false,
              __typename: 'CmsNode',
            },
          ],
          __typename: 'CmsNode',
        },
      ],
      navigationMobile: [
        {
          name: 'Magasiner',
          uid: 'FrontShopMobileShopNavNode',
          link: 'https://shop.shoppersdrugmart.ca/?lang=fr&_ga=2.29103732.979348982.1639514832-446882609.1635449602',
          hasChildren: true,
          __typename: 'CmsNode',
          child: [
            {
              name: 'Temps des Fêtes',
              uid: 'FrontShopMobileHolidaysNavNode',
              link: '/holiday-gifts',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Découvrir les Fêtes',
                  uid: 'FrontShopMobileHolidaysExploreHolidaysNavNode',
                  link: '/holiday-gifts',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Nos choix',
                  uid: 'FrontShopMobileHolidaysOurPicksNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Exclusivités en ligne',
                  uid: 'FrontShopMobileHolidaysOnlineExclusivesNavNode',
                  link: '/Shop/c/OnlineExcluHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: "Cadeaux par prix",
                  uid: 'FrontShopMobileHolidaysGiftsByPriceNavNode',
                  link: '/Shop/Home-%26-Seasonal-Gifts/Greeting-Cards/c/GreetingCardsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Moins de 25 $',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceCheapNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Moins de 50 $',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceMediumNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Aprice%3Aunder25%3Aprice%3A%2425-%2450',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopMobileHolidaysGiftsByPriceLuxuryNavNode',
                      link: '/c/Holiday?sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100%3AshowInStock%3Atrue',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Beauté',
                  uid: 'FrontShopMobileHolidaysBeautyGiftsNavNode',
                  link: '/Shop/c/BeautyGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Maquillage',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsMakeupNavNode',
                      link: '/Shop/c/MakeupHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Produits de soin de la peau',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsSkinCareNavNode',
                      link: '/Shop/c/SkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsFragrancesNavNode',
                      link: '/Shop/c/FragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins capillaires',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsHairCareNavNode',
                      link: '/Shop/c/HaircareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsToolsAccessoriesNavNode',
                      link: '/Shop/c/ToolsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et Maison',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsCandlesHomeNavNode',
                      link: '/Shop/Candles-%26-Home/c/CandlesAndHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Les Fêtes Quo Beauty',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsQuoBeautyNavNode',
                      link: '/Shop/c/QuoBeautyHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Calendriers de l’Avent',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsAdventCalendarsNavNode',
                      link: '/Shop/c/AdventCalendarsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections Découverte',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsDiscoveryCollectionsNavNode',
                      link: '/Shop/c/DiscoveryHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coffrets économiques',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsValueSetsNavNode',
                      link: '/Shop/c/ValueSetsHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux de luxe',
                      uid: 'FrontShopMobileHolidaysBeautyGiftsLuxuryGiftsNavNode',
                      link: '/Shop/c/LuxuryGifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Soins personnels',
                  uid: 'FrontShopMobileHolidaysPersonalCareGiftsNavNode',
                  link: '/Shop/c/PersonalCareHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux Techno',
                  uid: 'FrontShopMobileHolidaysElectronicGiftsNavNode',
                  link: '/Shop/c/ElectronicGiftsHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Jeux audio et vidéo',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsAudioVideoGamesNavNode',
                      link: '/Shop/c/AudioVideoGamesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Maison intelligente',
                      uid: 'FrontShopMobileHolidaysElectronicGiftsSmartTechNavNode',
                      link: '/Shop/c/SmartHomeHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Cadeaux Bien-être',
                  uid: 'FrontShopMobileHolidaysWellnessGiftsNavNode',
                  link: '/Shop/c/WellnessGiftsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Boutique pour hommes',
                  uid: 'FrontShopMobileHolidaysMensShopNavNode',
                  link: '/Shop/c/MensShopHoliday',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Parfums pour hommes',
                      uid: 'FrontShopMobileHolidaysMensShopMensFragrancesNavNode',
                      link: '/Shop/c/MensFragrancesHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Boutique pour hommes',
                      uid: 'FrontShopMobileHolidaysMensShopMensCareNavNode',
                      link: '/Shop/c/MensSkincareHoliday',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique pour enfants',
                  uid: 'FrontShopMobileHolidaysKidsShopNavNode',
                  link: '/Shop/c/KidsShopHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux pour animaux de compagnie',
                  uid: 'FrontShopMobileHolidaysGiftsForPetsNavNode',
                  link: '/Shop/c/GiftsforPets',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Pour le bas de Noël',
                  uid: 'FrontShopMobileHolidaysStockingStuffersNavNode',
                  link: '/Shop/c/StockingStuffersHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cadeaux saisonniers et pour la maison',
                  uid: 'FrontShopMobileHolidaysHomeSeasonalGiftsNavNode',
                  link: '/Shop/c/HomeHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Des choix bien réfléchis',
                  uid: 'FrontShopMobileHolidaysThoughtfulChoicesNavNode',
                  link: '/Shop/c/ThoughtfulChoicesHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Cartes de souhaits',
                  uid: 'FrontShopMobileHolidaysGreetingCardsNavNode',
                  link: '/Shop/c/GreetingCardsHoliday',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Beauté',
              uid: 'FrontShopMobileBeautyNavNode',
              link: '/Beauty?nav=/shop/beauty',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Maquillage',
                  uid: 'FrontShopMobileBeautyMakeupNavNode',
                  link: '/shop/Categories/Makeup/c/FS-MakeUp?nav=/shop/Categories/Makeup',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyMakeupNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-MakeUp&nav=%2Fshop%2FMakeUp%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyMakeupBestSellersNavNode',
                      link: '/c/BeautyMakeupBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Visage',
                      uid: 'FrontShopMobileBeautyMakeupFaceNavNode',
                      link: '/shop/Categories/Makeup/Face/c/FS-A100?nav=/shop/Categories/Makeup/Face',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fonds de teint',
                          uid: 'FrontShopMobileBeautyMakeupFoundationNavNode',
                          link: '/shop/Categories/Makeup/Foundation/c/FS-A107?nav=/shop/Categories/Makeup/Foundation',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes BB et CC',
                          uid: 'FrontShopMobileBeautyMakeupBBAndCCCreamsNavNode',
                          link: '/shop/Categories/Makeup/BBAndCCCreams/c/FS-A101?nav=/shop/Categories/Makeup/BBAndCCCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopMobileBeautyMakeupTintedMoisturizerNavNode',
                          link: '/shop/Categories/Makeup/TintedMoisturizer/c/FS-A110?nav=/shop/Categories/Makeup/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Correcteurs',
                          uid: 'FrontShopMobileBeautyMakeupConcealerNavNode',
                          link: '/shop/Categories/Makeup/Concealer/c/FS-A104?nav=/shop/Categories/Makeup/Concealer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases',
                          uid: 'FrontShopMobileBeautyMakeupPrimerNavNode',
                          link: '/shop/Categories/Makeup/Primer/c/FS-A106?nav=/shop/Categories/Makeup/Primer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres',
                          uid: 'FrontShopMobileBeautyMakeupPowderNavNode',
                          link: '/shop/Categories/Makeup/Powder/c/FS-A105?nav=/shop/Categories/Makeup/Powder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à joues',
                          uid: 'FrontShopMobileBeautyMakeupBlushNavNode',
                          link: '/shop/Categories/Makeup/Blush/c/FS-A102?nav=/shop/Categories/Makeup/Blush',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits bronzants',
                          uid: 'FrontShopMobileBeautyMakeupBronzerNavNode',
                          link: '/shop/Categories/Makeup/Bronzer/c/FS-A103?nav=/shop/Categories/Makeup/Bronzer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contouring',
                          uid: 'FrontShopMobileBeautyMakeupContourNavNode',
                          link: '/shop/Categories/Makeup/Contour/c/FS-A112?nav=/shop/Categories/Makeup/Contour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Illuminateurs',
                          uid: 'FrontShopMobileBeautyMakeupHighlighterNavNode',
                          link: '/shop/Categories/Makeup/Highlighter/c/FS-A113?nav=/shop/Categories/Makeup/Highlighter',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopMobileBeautyMakeupFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A114?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fixateurs de maquillage',
                          uid: 'FrontShopMobileBeautyMakeupSettingSprayNavNode',
                          link: '/shop/Categories/Makeup/SettingSpray/c/FS-A111?nav=/shop/Categories/Makeup/SettingSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopMobileBeautyMakeupMakeupRemoveryNavNode',
                          link: '/shop/Categories/Makeup/MakeupRemover/c/FS-A115?nav=/shop/Categories/Makeup/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Yeux',
                      uid: 'FrontShopMobileBeautyMakeupEyesNavNode',
                      link: '/shop/Categories/Makeup/Eyes/c/FS-A200?nav=/shop/Categories/Makeup/Eyes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Mascaras',
                          uid: 'FrontShopMobileBeautyMakeupMascaraNavNode',
                          link: '/shop/Categories/Makeup/Mascara/c/FS-A204?nav=/shop/Categories/Makeup/Mascara',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fards à paupières',
                          uid: 'FrontShopMobileBeautyMakeupEyeshadowNavNode',
                          link: '/shop/Categories/Makeup/Eyeshadow/c/FS-A203?nav=/shop/Categories/Makeup/Eyeshadow',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traceurs',
                          uid: 'FrontShopMobileBeautyMakeupEyelinerNavNode',
                          link: '/shop/Categories/Makeup/Eyeliner/c/FS-A202?nav=/shop/Categories/Makeup/Eyeliner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bases pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupEyePrimerNavNode',
                          link: '/shop/Categories/Makeup/EyePrimer/c/FS-A205?nav=/shop/Categories/Makeup/EyePrimer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/EyePalettes/c/FS-A206?nav=/shop/Categories/Makeup/EyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sourcils',
                          uid: 'FrontShopMobileBeautyMakeupBrowsNavNode',
                          link: '/shop/Categories/Makeup/Brows/c/FS-A201?nav=/shop/Categories/Makeup/Brows',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowAndLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowAndLashTools/c/FS-A207?nav=/shop/Categories/Makeup/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashTreatmentsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTreatments/c/FS-A208?nav=/shop/Categories/Makeup/BrowLashTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Faux cils',
                          uid: 'FrontShopMobileBeautyMakeupFalseEyelashesNavNode',
                          link: '/shop/Categories/Makeup/FalseEyelashes/c/FS-A209?nav=/shop/Categories/Makeup/FalseEyelashes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Lèvres',
                      uid: 'FrontShopMobileBeautyMakeupLipsNavNode',
                      link: '/shop/Categories/Makeup/Lips/c/FS-A300?nav=/shop/Categories/Makeup/Lips',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rouges à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipstickNavNode',
                          link: '/shop/Categories/Makeup/Lipstick/c/FS-A301?nav=/shop/Categories/Makeup/Lipstick',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brillants à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipGlossNavNode',
                          link: '/shop/Categories/Makeup/LipGloss/c/FS-A302?nav=/shop/Categories/Makeup/LipGloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Encres à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipStainNavNode',
                          link: '/shop/Categories/Makeup/LipStain/c/FS-A305?nav=/shop/Categories/Makeup/LipStain',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Repulpeurs à lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipPlumperNavNode',
                          link: '/shop/Categories/Makeup/LipPlumper/c/FS-A304?nav=/shop/Categories/Makeup/LipPlumper',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baumes et traitements pour les lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipBalmAndTreatmentNavNode',
                          link: '/shop/Categories/Makeup/LipBalmAndTreatment/c/FS-A306?nav=/shop/Categories/Makeup/LipBalmAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crayons contour des lèvres',
                          uid: 'FrontShopMobileBeautyMakeupLipLinerNavNode',
                          link: '/shop/Categories/Makeup/LipLiner/c/FS-A303?nav=/shop/Categories/Makeup/LipLiner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/Makeup/MakeupBrushesAndAccessories/c/FS-A400?nav=/shop/Categories/Makeup/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBrushesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBrushes/c/FS-A402?nav=/shop/Categories/Makeup/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopMobileBeautyMakeupSpongesNavNode',
                          link: '/shop/Categories/Makeup/Sponges/c/FS-A403?nav=/shop/Categories/Makeup/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyMakeupBrowLashToolsNavNode',
                          link: '/shop/Categories/Makeup/BrowLashTools/c/FS-A404?nav=/shop/Categories/Makeup/BrowLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyMakeupToolsNavNode',
                          link: '/shop/Categories/Makeup/Tools/c/FS-A405?nav=/shop/Categories/Makeup/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/Makeup/MakeupBagsAndCases/c/FS-A401?nav=/shop/Categories/Makeup/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Palettes de maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupPalettesNavNode',
                      link: '/shop/Categories/Makeup/MakeupPalettes/c/FS-A600?nav=/shop/Categories/Makeup/MakeupPalettes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Palettes pour les yeux',
                          uid: 'FrontShopMobileBeautyMakeupMakeupEyePalettesNavNode',
                          link: '/shop/Categories/Makeup/MakeupEyePalettes/c/FS-A601?nav=/shop/Categories/Makeup/MakeupEyePalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Palettes pour le visage et les joues',
                          uid: 'FrontShopMobileBeautyMakeupPalettesFaceAndCheekPalettesNavNode',
                          link: '/shop/Categories/Makeup/FaceAndCheekPalettes/c/FS-A602?nav=/shop/Categories/Makeup/FaceAndCheekPalettes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ongles',
                      uid: 'FrontShopMobileBeautyMakeupNailsNavNode',
                      link: '/shop/Categories/Makeup/Nails/c/FS-Nails?nav=/shop/Categories/Makeup/Nails',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Vernis à ongles',
                          uid: 'FrontShopMobileBeautyMakeupNailColourNavNode',
                          link: '/shop/Categories/Makeup/NailColour/c/FS-D300?nav=/shop/Categories/Makeup/NailColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Couches de base et de finition',
                          uid: 'FrontShopMobileBeautyMakeupTopAndBaseCoatsNavNode',
                          link: '/shop/Categories/Makeup/TopAndBaseCoats/c/FS-D400?nav=/shop/Categories/Makeup/TopAndBaseCoats',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'False Nails',
                          uid: 'FrontShopMobileBeautyMakeupFalseNailsNavNode',
                          link: '/shop/Categories/Makeup/FalseNails/c/FS-D450?nav=/shop/Categories/Makeup/FalseNails',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopMobileBeautyMakeupNailCareAndToolsNavNode',
                          link: '/shop/Categories/Makeup/NailCareAndTools/c/FS-D500?nav=/shop/Categories/Makeup/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopMobileBeautyMakeupMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/Makeup/MakeupGiftsAndSets/c/FS-H900?nav=/shop/Categories/Makeup/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyMakeupShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maquillage de Luxe',
                          uid: 'FrontShopMobileBeautyMakeupLuxuryFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Maquillage dermato',
                          uid: 'FrontShopMobileBeautyMakeupDermFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Maquillage',
                          uid: 'FrontShopMobileBeautyMakeupTCFilterNavNode',
                          link: '/c/FS-MakeUp?nav=%2Fshop%2FCategories%2FMakeup&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyMakeupFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopMobileBeautyMakeupTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/Makeup/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de maquillage',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-gifts/wk41_featurecollecctiontile_makeupgifts_enfr.png',
                            imageLink: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de maquillage',
                          uid: 'FrontShopMobileBeautyMakeupMGFeaturedCollectionsNavNode',
                          link: '/c/MakeupHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux des Fêtes Quo Beauty',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-makeup-qb-holiday/wk41_featurecollecctiontile_qbholiday_enfr.png',
                            imageLink: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux des Fêtes Quo Beauty',
                          uid: 'FrontShopMobileBeautyMakeupQBHGFeaturedCollectionsNavNode',
                          link: '/c/QuoBeautyHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins de la peau',
                  uid: 'FrontShopMobileBeautySkinCareNavNode',
                  link: '/shop/Categories/SkinCare/c/FS-SkinCare?nav=/shop/Categories/SkinCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautySkinCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-SkinCare&nav=%2Fshop%2FSkinCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautySkinCareBestSellersNavNode',
                      link: '/c/BeautySkinCareBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Hydratants pour le visage',
                      uid: 'FrontShopMobileBeautySkinCareFaceMoisturizersNavNode',
                      link: '/shop/Categories/SkinCare/FaceMoisturizers/c/FS-S100?nav=/shop/Categories/SkinCare/FaceMoisturizers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopMobileBeautySkinCareMoisturizersNavNode',
                          link: '/shop/Categories/SkinCare/Moisturizers/c/FS-S101?nav=/shop/Categories/SkinCare/Moisturizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes de nuit',
                          uid: 'FrontShopMobileBeautySkinCareNightCreamNavNode',
                          link: '/shop/Categories/SkinCare/NightCream/c/FS-S102?nav=/shop/Categories/SkinCare/NightCream',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceOilsNavNode',
                          link: '/shop/Categories/SkinCare/FaceOils/c/FS-S103?nav=/shop/Categories/SkinCare/FaceOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopMobileBeautySkinCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/SkinCare/NeckAndDécolleté/c/FS-S104?nav=/shop/Categories/SkinCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brumes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceMistsNavNode',
                          link: '/shop/Categories/SkinCare/FaceMists/c/FS-S105?nav=shop/Categories/SkinCare/FaceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Hydratants teintés',
                          uid: 'FrontShopMobileBeautySkinCareTintedMoisturizerNavNode',
                          link: '/shop/Categories/SkinCare/TintedMoisturizer/c/FS-S107?nav=/shop/Categories/SkinCare/TintedMoisturizer',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nettoyants',
                      uid: 'FrontShopMobileBeautySkinCareCleansersNavNode',
                      link: '/shop/Categories/SkinCare/Cleansers/c/FS-S200?nav=/shop/Categories/SkinCare/Cleansers',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceWashAndCleansersNavNode',
                          link: '/shop/Categories/SkinCare/FaceWashAndCleansers/c/FS-S201?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants et gommages pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceScrubsAndExfoliatorsNavNode',
                          link: '/shop/Categories/SkinCare/FaceScrubsAndExfoliators/c/FS-S202?nav=/shop/Categories/SkinCare/FaceScrubsAndExfoliators',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-S203?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Démaquillants',
                          uid: 'FrontShopMobileBeautySkinCareMakeupRemoverNavNode',
                          link: '/shop/Categories/SkinCare/MakeupRemover/c/FS-S204?nav=/shop/Categories/SkinCare/MakeupRemover',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Toniques',
                          uid: 'FrontShopMobileBeautySkinCareTonersNavNode',
                          link: '/shop/Categories/SkinCare/Toners/c/FS-S205?nav=shop/Categories/SkinCare/Toners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S206?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Traitements',
                      uid: 'FrontShopMobileBeautySkinCareTreatmentsNavNode',
                      link: '/shop/Categories/SkinCare/Treatments/c/FS-S300?nav=/shop/Categories/SkinCare/Treatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sérums',
                          uid: 'FrontShopMobileBeautySkinCareSerumsNavNode',
                          link: '/shop/Categories/SkinCare/Serums/c/FS-S301?nav=/shop/Categories/SkinCare/Serums',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins anti-âge',
                          uid: 'FrontShopMobileBeautySkinCareAntiAgingNavNode',
                          link: '/shop/Categories/SkinCare/AntiAging/c/FS-S302?nav=/shop/Categories/SkinCare/AntiAging',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins éclaircissants',
                          uid: 'FrontShopMobileBeautySkinCareBrighteningNavNode',
                          link: '/shop/Categories/SkinCare/Brightening/c/FS-S305?nav=/shop/Categories/SkinCare/Brightening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Traitements contre l'acné",
                          uid: 'FrontShopMobileBeautySkinCareAcneAndBlemishTreatmentsNavNode',
                          link: '/shop/Categories/SkinCare/AcneAndBlemishTreatments/c/FS-S303?nav=/shop/Categories/SkinCare/AcneAndBlemishTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialPeelsNavNode',
                          link: '/shop/Categories/SkinCare/FacialPeels/c/FS-S304?nav=/shop/Categories/SkinCare/FacialPeels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Masques',
                      uid: 'FrontShopMobileBeautySkinCareMasksNavNode',
                      link: '/shop/Categories/SkinCare/Masks/c/FS-S400?nav=/shop/Categories/SkinCare/Masks',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Masques pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceMasksNavNode',
                          link: '/shop/Categories/SkinCare/FaceMasks/c/FS-S401?nav=/shop/Categories/SkinCare/FaceMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques en feuille',
                          uid: 'FrontShopMobileBeautySkinCareSheetMasksNavNode',
                          link: '/shop/Categories/SkinCare/SheetMasks/c/FS-S402?nav=/shop/Categories/SkinCare/SheetMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeMasksNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S403?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins contour des yeux',
                      uid: 'FrontShopMobileBeautySkinCareEyeCareNavNode',
                      link: '/shop/Categories/SkinCare/EyeCare/c/FS-S500?nav=/shop/Categories/SkinCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeCreamsAndTreatmentNavNode',
                          link: '/shop/Categories/SkinCare/EyeCreamsAndTreatment/c/FS-S501?nav=/shop/Categories/SkinCare/EyeCreamsAndTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques contour des yeux',
                          uid: 'FrontShopMobileBeautySkinCareEyeMaskNavNode',
                          link: '/shop/Categories/SkinCare/EyeMasks/c/FS-S502?nav=/shop/Categories/SkinCare/EyeMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes et traitements pour les lèvres',
                      uid: 'FrontShopMobileBeautySkinCareLipBalmAndTreatmentNavNode',
                      link: '/shop/Categories/SkinCare/LipBalmAndTreatment/c/FS-S999?nav=/shop/Categories/SkinCare/LipBalmAndTreatment',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopMobileBeautySkinCareSunCareNavNode',
                      link: '/shop/Categories/SkinCare/SunCare/c/FS-S700?nav=/shop/Categories/SkinCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFaceSunscreenNavNode',
                          link: '/shop/Categories/SkinCare/FaceSunscreen/c/FS-S701?nav=/shop/Categories/SkinCare/FaceSunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Écrans solaires pour le corps',
                          uid: 'FrontShopMobileBeautySkinCareBodySunscreenNavNode',
                          link: '/shop/Categories/SkinCare/BodySunscreen/c/FS-S702?nav=/shop/Categories/SkinCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopMobileBeautySkinCareAfterSunNavNode',
                          link: '/shop/Categories/SkinCare/AfterSun/c/FS-S703?nav=/shop/Categories/SkinCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopMobileBeautySkinCareSelfTannersNavNode',
                      link: '/shop/Categories/SkinCare/SelfTanners/c/FS-S900?nav=/shop/Categories/SkinCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareToolsAndAccessories/c/FS-S800?nav=/shop/Categories/SkinCare/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils pour nettoyer le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialCleansingToolsNavNode',
                          link: '/shop/Categories/SkinCare/FacialCleansingTools/c/FS-S801?nav=/shop/Categories/SkinCare/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautySkinCareFacialWipeAndAccessoriesNavNode',
                          link: '/shop/Categories/SkinCare/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/SkinCare/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/SkinCare/SkinCareTreatmentDevices/c/FS-S803?nav=/shop/Categories/SkinCare/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins de la peau pour le corps',
                      uid: 'FrontShopMobileBeautySkinCareBodySkinCareNavNode',
                      link: '/c/FS-S666?nav=beauty/skincare/bodyskincare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopMobileBeautySkinCareSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/SkinCare/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/SkinCare/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautySkinCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soin de la peau de luxe',
                          uid: 'FrontShopMobileBeautySkinCareLuxuryFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin de la peau dermato',
                          uid: 'FrontShopMobileBeautySkinCareDermFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareTCFilterNavNode',
                          link: '/c/FS-SkinCare?nav=%2Fshop%2FCategories%2FSkinCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautySkinCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: "Outil D'analyse",
                          uid: 'FrontShopMobileSkincareSkinAnalysisToolsFeaturedCollectionsNavNode',
                          link: '/skindiagnostic?nav=shop/beauty/skincare/featuredcollection/tryourvirtualskinanalysistools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magasiner les soins de la peau selon les ingrédients',
                          uid: 'FrontShopMobileBeautySkinCareShopSkincareFeaturedCollectionsNavNode',
                          link: '/c/2022P3CLSK?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories?Beauty/SkinCare/FeaturedCollections/ShopSkinCareByIngredients',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins de la peau',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-skincare-gifts/wk41_featurecollecctiontile_skincaregifts_enfr.png',
                            imageLink: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins de la peau',
                          uid: 'FrontShopMobileBeautySkinCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/SkincareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins capillaires',
                  uid: 'FrontShopMobileBeautyHairCareNavNode',
                  link: '/shop/Categories/HairCare/c/FS-HairCare?nav=/shop/Categories/HairCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyHairCareNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-HairCare&nav=%2Fshop%2FHairCare%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyHairCareBestSellersNavNode',
                      link: '/c/BeautyHairBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Shampooings et revitalisants',
                      uid: 'FrontShopMobileBeautyHairCareShampoosAndConditionersNavNode',
                      link: '/shop/Categories/HairCare/ShampoosAndConditioners/c/FS-H100?nav=/shop/Categories/HairCare/ShampoosAndConditioners',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Shampooing',
                          uid: 'FrontShopMobileBeautyHairCareShampooNavNode',
                          link: '/shop/Categories/HairCare/Shampoo/c/FS-H101?nav=/shop/Categories/HairCare/Shampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Revitalisant',
                          uid: 'FrontShopMobileBeautyHairCareConditionerNavNode',
                          link: '/shop/Categories/HairCare/Conditioner/c/FS-H102?nav=/shop/Categories/HairCare/Conditioner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Shampooing sec',
                          uid: 'FrontShopMobileBeautyHairCareDryShampooNavNode',
                          link: '/shop/Categories/HairCare/DryShampoo/c/FS-H103?nav=/shop/Categories/HairCare/DryShampoo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Type de cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairTypeNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fins et plats',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeThinNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Raides',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeStraightNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ANORMAL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Ondulés et frisés',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeWavyNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ACURLY',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rêches et épais',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairTypeCoarseNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3AhairType%3ATHICK',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobileBeautyHairCareHairStylingToolsNavNode',
                      link: '/shop/Categories/HairCare/HairStylingTools/c/FS-H200?nav=/shop/Categories/HairCare/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobileBeautyHairCareBlowDryersNavNode',
                          link: '/shop/Categories/HairCare/BlowDryers/c/FS-H201?nav=/shop/Categories/HairCare/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobileBeautyHairCareStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/HairCare/StraightenersAndFlatIrons/c/FS-H202?nav=/shop/Categories/HairCare/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobileBeautyHairCareCurlingIronsNavNode',
                          link: '/shop/Categories/HairCare/CurlingIrons/c/FS-H203?nav=/shop/Categories/HairCare/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobileBeautyHairCareBrushesAndCombsNavNode',
                          link: '/shop/Categories/HairCare/BrushesAndCombs/c/FS-H204?nav=/shop/Categories/HairCare/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Préoccupation capillaire',
                      uid: 'FrontShopMobileBeautyHairCareHairConcernNavNode',
                      link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brillance',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernShineNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ASHINE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Abîmé',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDamagedNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADAMAGED',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des frisottis',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernFrizzControlNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AFRIZZ_CONTROL',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sécheresse et pellicules',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernDrynessAndDandruffNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3ADRYNESS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Volume',
                          uid: 'FrontShopMobileBeautyHairCareShopByHairConcernVolumizingNavNode',
                          link: '/c/FS-HairCare?sort=trending&page=0&q=%3Atrending%3Aconcern%3AVOLUMIZING',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits coiffants et traitements',
                      uid: 'FrontShopMobileBeautyHairCareStylingProductsAndTreatmentsNavNode',
                      link: '/shop/Categories/HairCare/StylingProductsAndTreatments/c/FS-H300?nav=/shop/Categories/HairCare/StylingProductsAndTreatments',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Traitements capillaires',
                          uid: 'FrontShopMobileBeautyHairCareHairTreatmentsNavNode',
                          link: '/shop/Categories/HairCare/HairTreatments/c/FS-H301?nav=/shop/Categories/HairCare/HairTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Masques capillaires',
                          uid: 'FrontShopMobileBeautyHairCareHairMasksNavNode',
                          link: '/shop/Categories/HairCare/HairMasks/c/FS-H302?nav=/shop/Categories/HairCare/HairMasks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateur pour cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairSprayNavNode',
                          link: '/shop/Categories/HairCare/HairSpray/c/FS-H303?nav=/shop/Categories/HairCare/HairSpray',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mousse capillaire',
                          uid: 'FrontShopMobileBeautyHairCareHairMousseNavNode',
                          link: '/shop/Categories/HairCare/HairMousse/c/FS-H304?nav=/shop/Categories/HairCare/HairMousse',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cire et gel pour cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairWaxAndGelNavNode',
                          link: '/shop/Categories/HairCare/HairWaxAndGel/c/FS-H305?nav=/shop/Categories/HairCare/HairWaxAndGel',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour perte et croissance des cheveux',
                          uid: 'FrontShopMobileBeautyHairCareHairLossAndRegrowthSupplementsNavNode',
                          link: '/shop/Categories/HairCare/HairLossAndRegrowthSupplements/c/FS-H306?nav=/shop/Categories/HairCare/HairLossAndRegrowthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Colorants capillaires',
                      uid: 'FrontShopMobileBeautyHairCareHairColourNavNode',
                      link: '/shop/Categories/HairCare/HairColour/c/FS-H400?nav=/shop/Categories/HairCare/HairColour',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Colorants capillaires permanents',
                          uid: 'FrontShopMobileBeautyHairCarePermanentHairColourNavNode',
                          link: '/shop/Categories/HairCare/PermanentHairColour/c/FS-H401?nav=/shop/Categories/HairCare/PermanentHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Retouche des racines',
                          uid: 'FrontShopMobileBeautyHairCareRootTouchUpNavNode',
                          link: '/shop/Categories/HairCare/RootTouchUp/c/FS-H402?nav=/shop/Categories/HairCare/RootTouchUp',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Colorants capillaires temporaires',
                          uid: 'FrontShopMobileBeautyHairCareTemporaryHairColourNavNode',
                          link: '/shop/Categories/HairCare/TemporaryHairColour/c/FS-H403?nav=/shop/Categories/HairCare/TemporaryHairColour',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairAccessoriesNavNode',
                      link: '/shop/Categories/HairCare/HairAccessories/c/FS-H500?nav=/shop/Categories/HairCare/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopMobileBeautyHairCareHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/HairCare/HeadbandsAndHeadWraps/c/FS-H501?nav=/shop/Categories/HairCare/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobileBeautyHairCareElasticsNavNode',
                          link: '/shop/Categories/HairCare/Elastics/c/FS-H502?nav=/shop/Categories/HairCare/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux et ensembles pour les cheveux',
                      uid: 'FrontShopMobileBeautyHairCareHairGiftsAndSetsNavNode',
                      link: '/shop/Categories/HairCare/HairGiftsAndSets/c/FS-H600?nav=/shop/Categories/HairCare/HairGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyHairCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins capilaires de luxe',
                          uid: 'FrontShopMobileBeautyHairCareLuxuryFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins capilaires dermato',
                          uid: 'FrontShopMobileBeautyHairCareDermFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins capillaires',
                          uid: 'FrontShopMobileBeautyHairCareTCFilterNavNode',
                          link: '/c/FS-HairCare?nav=%2Fshop%2FCategories%2FHairCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyHairCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis MC',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_thoughtfulchoices_v1/wk13_featurecollecctiontile_thoughtfulchoices_v1_enfr.png',
                            imageLink:
                              '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis MC',
                          uid: 'FrontShopMobileBeautyHairCareTCFeaturedCollectionsNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Cadeaux de soins capillaire',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-hair-care-gifts/wk41_featurecollecctiontile_haircaregifts_enfr.png',
                            imageLink: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de soins capillaire',
                          uid: 'FrontShopMobileBeautyHairCareGiftsFeaturedCollectionsNavNode',
                          link: '/c/HaircareHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Parfums',
                  uid: 'FrontShopMobileBeautyFragranceNavNode',
                  link: '/shop/Categories/Fragrance/c/FS-Fragrance?nav=/shop/Categories/Fragrance',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyFragranceNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Fragrance&nav=%2Fshop%2FFragrance%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyFragranceBestSellersNavNode',
                      link: '/c/BeautyFragranceBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour elles',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHerNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHer/c/FS-F100?nav=/shop/Categories/Fragrance/FragranceforHer',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyFragrancePerfumeNavNode',
                          link: '/shop/Categories/Fragrance/Perfume/c/FS-F101?nav=/shop/Categories/Fragrance/Perfume',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs et brumes parfumées pour le corps',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndFragranceMistsNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndFragranceMists/c/FS-F102?nav=/shop/Categories/Fragrance/BodySpraysAndFragranceMists',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour elle',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforherNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforher/c/FS-F103?nav=/shop/Categories/Fragrance/CelebrityFragrancesforher',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyFragranceHerFragranceBathAndBodyNavNode',
                          link: '/c/FS-F104?nav=beauty/fragrance/fragranceforher/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopMobileBeautyFragranceFragranceforHimNavNode',
                      link: '/shop/Categories/Fragrance/FragranceforHim/c/FS-F200?nav=/shop/Categories/Fragrance/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyFragranceCologneNavNode',
                          link: '/shop/Categories/Fragrance/Cologne/c/FS-F201?nav=/shop/Categories/Fragrance/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopMobileBeautyFragranceBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Fragrance/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Fragrance/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité pour lui',
                          uid: 'FrontShopMobileBeautyFragranceCelebrityFragrancesforhimNavNode',
                          link: '/shop/Categories/Fragrance/CelebrityFragrancesforhim/c/FS-F203?nav=/shop/Categories/Fragrance/CelebrityFragrancesforhim',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyFragranceHimFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/fragrance/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Bougies et parfums d'ambiance",
                      uid: 'FrontShopMobileBeautyFragranceHomeScentsAndCandlesNavNode',
                      link: '/shop/Categories/Fragrance/HomeScentsAndCandles/c/FS-F300?nav=/shop/Categories/Fragrance/HomeScentsAndCandles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopMobileBeautyFragranceFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/Fragrance/FragranceGiftsAndSets/c/FS-F400?nav=/shop/Categories/Fragrance/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums à bille et en format de voyage',
                      uid: 'FrontShopMobileBeautyFragranceRollerballsTravelsizeNavNode',
                      link: '/shop/Categories/Fragrance/RollerballsAndTravelSize/c/FS-F500?nav=/shop/Categories/Fragrance/RollerballsAndTravelSize',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyFragranceShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums de luxe',
                          uid: 'FrontShopMobileBeautyFragranceLuxuryFilterNavNode',
                          link: '/c/FS-Fragrance?nav=%2Fshop%2FCategories%2FFragrance&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyFragranceFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de parfums',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_fragrancegifts/wk41_featurecollecctiontile_fragrance_enfr.png',
                            imageLink: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de parfums',
                          uid: 'FrontShopMobileBeautyFragranceFragGiftsFeaturedCollectionsNavNode',
                          link: '/c/FragrancesHoliday?nav=/shop/Categories/Holiday/BeautyGifts/Fragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode',
                  link: '/shop/Categories/ToolsAndAccessories/c/FS-ToolsAccess?nav=/shop/Categories/ToolsAndAccessories',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-ToolsAccess&nav=%2Fshop%2FToolsAccess%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesBestSellersNavNode',
                      link: '/c/BeautyTools&AccessoriesBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires et pinceaux à maquillage',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories/c/FS-T100?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushesAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils pour les sourcils et les cils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrowAndLashToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrowAndLashTools/c/FS-T103?nav=/shop/Categories/ToolsAndAccessories/BrowAndLashTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Tools/c/FS-T104?nav=/shop/Categories/ToolsAndAccessories/Tools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses à maquillage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBagsAndCasesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases/c/FS-T105?nav=/shop/Categories/ToolsAndAccessories/MakeupBagsAndCases',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et soins des ongles',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesNailCareAndToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/NailCareAndTools/c/FS-T106?nav=/shop/Categories/ToolsAndAccessories/NailCareAndTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Éponges',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSpongesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Sponges/c/FS-T102?nav=/shop/Categories/ToolsAndAccessories/Sponges',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pinceaux à maquillage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesMakeupBrushesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/MakeupBrushes/c/FS-T101?nav=/shop/Categories/ToolsAndAccessories/MakeupBrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils et accessoires de soins de la peau',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareToolsAndAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories/c/FS-T200?nav=/shop/Categories/ToolsAndAccessories/SkinCareToolsAndAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialCleansingToolsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialCleansingTools/c/FS-T201?nav=/shop/Categories/ToolsAndAccessories/FacialCleansingTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires et lingettes pour le visage',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesFacialWipesAndAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories/c/FS-T202?nav=/shop/Categories/ToolsAndAccessories/FacialWipesAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins de la peau',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesSkinCareTreatmentDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices/c/FS-T203?nav=/shop/Categories/ToolsAndAccessories/SkinCareTreatmentDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-T400?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-T401?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-T402?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-T403?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-T404?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour les cheveux',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-T500?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-T501?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et bandanas',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesHandbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps/c/FS-T502?nav=/shop/Categories/ToolsAndAccessories/HandbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-T503?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'FrontShopMobileBeautyToolsAndAccessoriesNavNode en vedette',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils de coiffure',
                          uid: 'FrontShopMobileToolsAndAccessoriesSalonLevelHairToolsFeaturedCollectionsNavNode',
                          link: '/c/FS-T400?nav=shop/beauty/toolsandaccessories/featuredcollection/salonlevelhairtools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de Quo Beauty',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesByQuoBeautyFeaturedCollectionsNavNode',
                          link: '/c/QUO%2CBEAUTY-FS-ToolsAccess?nav=shop/beauty/toolsandaccessories/featuredcollections/toolsandaccesssoriesbyquobeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyToolsAndAccessoriesShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et accessoires de luxe',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesLuxuryFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils et accessoires dermato',
                          uid: 'FrontShopMobileBeautyToolsAndAccessoriesDermFilterNavNode',
                          link: '/c/FS-ToolsAccess?nav=%2Fshop%2FCategories%2FToolsAndAccessories&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Boutique masculine',
                  uid: 'FrontShopMobileBeautyMenNavNode',
                  link: '/shop/Categories/Men/c/FS-Mens?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyMenNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-Mens&nav=%2Fshop%2FMens%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Meilleurs Vendeurs',
                      uid: 'FrontShopMobileBeautyMenBestSellersNavNode',
                      link: '/c/BeautyMensBestSellers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Soins de la peau pour lui',
                      uid: 'FrontShopMobileBeautyMenSkinCareforHimNavNode',
                      link: '/shop/Categories/Men/SkinCareforHim/c/FS-M100?nav=/shop/Categories/Men/SkinCareforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Hydratants',
                          uid: 'FrontShopMobileBeautyMenMoisturizersNavNode',
                          link: '/shop/Categories/Men/Moisturizers/c/FS-M101?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Nettoyants et accessoires',
                          uid: 'FrontShopMobileBeautyMenCleansersAndAccessoriesNavNode',
                          link: '/shop/Categories/Men/CleansersAndAccessories/c/FS-M102?nav=/shop/Categories/Men/CleansersAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitements',
                          uid: 'FrontShopMobileBeautyMenTreatmentsNavNode',
                          link: '/shop/Categories/Men/Treatments/c/FS-M103?nav=/shop/Categories/Men/Treatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Baume à lèvres',
                          uid: 'FrontShopMobileBeautyMenLipBalmNavNode',
                          link: '/shop/Categories/Men/LipBalm/c/FS-M104?nav=/shop/Categories/Men/LipBalm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins solaires',
                      uid: 'FrontShopMobileBeautyMenSunCareNavNode',
                      link: '/shop/Categories/Men/SunCare/c/FS-M105?nav=/shop/Categories/Men/SunCare',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Parfums pour lui',
                      uid: 'FrontShopMobileBeautyMenFragranceforHimNavNode',
                      link: '/shop/Categories/Men/FragranceforHim/c/FS-F200?nav=/shop/Categories/Men/FragranceforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Parfums',
                          uid: 'FrontShopMobileBeautyMenCologneNavNode',
                          link: '/shop/Categories/Men/Cologne/c/FS-F201?nav=/shop/Categories/Men/Cologne',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vaporisateurs pour le corps et déodorants',
                          uid: 'FrontShopMobileBeautyMenBodySpraysAndDeodorantNavNode',
                          link: '/shop/Categories/Men/BodySpraysAndDeodorant/c/FS-F202?nav=/shop/Categories/Men/BodySpraysAndDeodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums de célébrité',
                          uid: 'FrontShopMobileBeautyMenCelebrityFragrancesNavNode',
                          link: '/shop/Categories/Men/CelebrityFragrances/c/FS-F203?nav=/shop/Categories/Men/CelebrityFragrances',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Parfums Bain et Corps',
                          uid: 'FrontShopMobileBeautyMenFragranceBathAndBodyNavNode',
                          link: '/c/FS-F204?nav=beauty/mens/fragranceforhim/fragrancebathandbody',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopMobileBeautyMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-M500?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Outils et produits de rasage',
                          uid: 'FrontShopMobileBeautyMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-M501?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-rasage',
                          uid: 'FrontShopMobileBeautyMenAfterShaveNavNode',
                          link: '/shop/Categories/Men/AfterShave/c/FS-M502?nav=/shop/Categories/Men/AfterShave',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopMobileBeautyMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-M503?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobileBeautyMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-M504?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobileBeautyMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-M505?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins capillaires pour lui',
                      uid: 'FrontShopMobileBeautyMenHairforHimNavNode',
                      link: '/shop/Categories/Men/HairforHim/c/FS-M400?nav=/shop/Categories/Men/HairforHim',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopMobileBeautyMenMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/Men/MensGiftsAndSets/c/FS-M600?nav=/shop/Categories/Men/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyMenShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soins masculins de luxe',
                          uid: 'FrontShopMobileBeautyMenLuxuryFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins masculins dermato',
                          uid: 'FrontShopMobileBeautyMenDermFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins pour hommes',
                          uid: 'FrontShopMobileBeautyMenTCFilterNavNode',
                          link: '/c/FS-Mens?nav=%2Fshop%2FCategories%2FMen&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyMensFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux pour hommes',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-mens-gifts/wk41_featurecollecctiontile_mens_enfr.png',
                            imageLink: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux pour hommes',
                          uid: 'FrontShopMobileBeautyMensGiftsFeaturedCollectionsNavNode',
                          link: '/c/MensShopHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Marques',
                  uid: 'FrontShopMobileBeautyBrandsNavNode',
                  link: '/all-brands?nav=/shop/beauty/shopallbrand',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Marques Populaires',
                      uid: 'FrontShopMobileBeautyBrandsPopularShopByBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dyson',
                          uid: 'FrontShopMobileBeautyBrandsDysonPopularNavNode',
                          link: '/c/DYSON?nav=shop/beauty/shopbybrand/Dyson',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lancome',
                          uid: 'FrontShopMobileBeautyBrandsLancomePopularNavNode',
                          link: '/c/LANCOME?nav=shop/beauty/shopbybrand/Lancome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'R.E.M. Beauty',
                          uid: 'FrontShopMobileBeautyBrandsREMBeautyPopularNavNode',
                          link: '/Shop/R-E-M-Beauty/c/R.E.M.BEAUTY?sort=trending&page=0',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'La Roche Posay',
                          uid: 'FrontShopMobileBeautyBrandsLaRochePosayPopularNavNode',
                          link: '/c/LA,ROCHE,POSAY?nav=shop/beauty/shopbybrand/LaRochePosay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'CeraVe',
                          uid: 'FrontShopMobileBeautyBrandsCeraVePopularNavNode',
                          link: '/c/CERAVE?nav=shop/beauty/shopbybrand/CeraVe',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Quo Beauty',
                          uid: 'FrontShopMobileBeautyBrandsQuoBeautyPopularNavNode',
                          link: '/c/QUO,BEAUTY?nav=shop/beauty/shopbybrand/QuoBeauty',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "L'Oreal",
                          uid: 'FrontShopMobileBeautyBrandsLOrealPopularNavNode',
                          link: "/c/L'OREAL?nav=shop/beauty/shopbybrand/LOreal",
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Olay',
                          uid: 'FrontShopMobileBeautyBrandsOlayPopularNavNode',
                          link: '/c/OLAY?nav=shop/beauty/shopbybrand/Olay',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Marques en vedette',
                      uid: 'FrontShopMobileBeautyBrandsFeaturedBrandsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Tom Ford',
                          uid: 'FrontShopMobileBeautyBrandsTomFordFeaturedBrandsNavNode',
                          link: '/c/TOM,FORD?nav=shop/beauty/shopbybrand/tomford',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Laura Mercier',
                          uid: 'FrontShopMobileBeautyBrandsLauraMercierFeaturedBrandsNavNode',
                          link: '/c/LAURA,MERCIER?nav=shop/beauty/shopbybrand/LauraMercier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Versed',
                          uid: 'FrontShopMobileBeautyBrandsVersedFeaturedBrandsNavNode',
                          link: '/c/VERSED?nav=shop/beauty/shopbybrand/Versed',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Dior',
                          uid: 'FrontShopMobileBeautyBrandsDiorFeaturedBrandsNavNode',
                          link: '/c/DIOR?nav=shop/beauty/shopbybrand/Dior',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Too Faced',
                          uid: 'FrontShopMobileBeautyBrandsTooFacedFeaturedBrandsNavNode',
                          link: '/c/TOO,FACED?nav=shop/beauty/shopbybrand/TooFaced',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'NARS',
                          uid: 'FrontShopMobileBeautyBrandsNarsFeaturedBrandsNavNode',
                          link: '/c/NARS?nav=shop/beauty/shopbybrand/NARS',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Foreo',
                          uid: 'FrontShopMobileBeautyBrandsForeoFeaturedBrandsNavNode',
                          link: '/c/FOREO?nav=shop/beauty/shopbybrand/Foreo',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Kylie by Kylie Jenner',
                          uid: 'FrontShopMobileBeautyBrandsKylieFeaturedBrandsNavNode',
                          link: '/c/KYLIE?nav=shop/beauty/shopbybrand/featuredbrand/kyliebykyliejenner',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Florence By Mills',
                          uid: 'FrontShopMobileBeautyBrandsFlorenceByMillsFeaturedBrandsNavNode',
                          link: '/c/FLORENCE,BY,MILLS?nav=shop/beauty/shopbybrand/featuredbrand/florencebymills',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Cadeaux et ensembles',
                  uid: 'FrontShopMobileBeautyGiftsAndSetsNavNode',
                  link: '/shop/Categories/GiftsAndSets/c/FS-GiftSets?nav=/shop/Categories/GiftsAndSets',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Nouvelles Arrivées',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNewArrivalsNavNode',
                      link: '/c/FS-new-arrivals?q=%3Atrending%3Acategory%3AFS-GiftSets&nav=%2Fshop%2FGiftSets%2FNewArrivals&sort=trending&page=0',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Maquillage',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMakeupGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MakeupGiftsAndSets/c/FS-G100?nav=/shop/Categories/GiftsAndSets/MakeupGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins de la peau',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsSkinCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets/c/FS-G200?nav=/shop/Categories/GiftsAndSets/SkinCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Soins capillaires',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsHairCareGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/HairCareGiftsAndSets/c/FS-G400?nav=/shop/Categories/GiftsAndSets/HairCareGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Parfums',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsFragranceGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/FragranceGiftsAndSets/c/FS-G300?nav=/shop/Categories/GiftsAndSets/FragranceGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles - Boutique masculine',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsMensGiftsAndSetsNavNode',
                      link: '/shop/Categories/GiftsAndSets/MensGiftsAndSets/c/FS-G600?nav=/shop/Categories/GiftsAndSets/MensGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobileBeautyGiftAndSetsShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles de luxe',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsLuxuryFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ALuxury',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cadeaux et ensembles dermato',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsDermFilterNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3ADerm',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyGiftAndSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Outils de Beauté',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsBeautyToolsNavNode',
                      link: '/c/BeautyTools?nav=beauty/giftsandsets/beautytools',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Beauté naturelle',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsNaturalBeautyNavNode',
                      link: '/c/NaturalBeauty?nav=beauty/giftsandsets/naturalbeauty',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Chandelles et cadeaux pour la maison',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsCandlesAndHomeGiftsNavNode',
                      link: '/c/CandlesAndHomeGifts?nav=beauty/giftsandsets/candlesandhomegifts',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux Par Prix',
                      uid: 'FrontShopMobileBeautyGiftsAndSetsGiftedByPriceNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Sous 25$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets25orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 50$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets50orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sous 100$',
                          uid: 'FrontShopMobileBeautyGiftsAndSets100orLessNavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3A%252425%2B-%2B%252450%3Aprice%3Aunder25%3Aprice%3A%252450%2B-%2B%2524100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sur 100$',
                          uid: 'FrontShopMobileBeautyGiftsAndSetsOver100NavNode',
                          link: '/c/FS-GiftSets?nav=%2Fshop%2FCategories%2FGiftsAndSets&sort=trending&page=0&q=%3Atrending%3Aprice%3Aover100',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections en vedette',
                      uid: 'FrontShopMobileBeautyGiftsSetsFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Coffrets-cadeaux rapport prix',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-value-gifts/wk41_featurecollecctiontile_valuesets_enfr.png',
                            imageLink: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Coffrets-cadeaux rapport prix',
                          uid: 'FrontShopMobileBeautyValueGiftSetsFeaturedCollectionsNavNode',
                          link: '/c/ValueSetsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: "Calendriers de l'Avent",
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P11/wk41/fct/fct-advent/wk41_featurecollecctiontile_advent_enfr.png',
                            imageLink:
                              '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                            __typename: 'NavPromoNode',
                          },
                          name: "Calendriers de l'Avent",
                          uid: 'FrontShopMobileBeautyAdventCalendarsFeaturedCollectionsNavNode',
                          link: '/c/AdventCalendarsHoliday?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'Soins personnels',
              uid: 'FrontShopMobilePersonalCareNavNode',
              link: '/Personal-care?nav=/shop/personal',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Produits pour le corps et le bain',
                  uid: 'FrontShopMobilePersonalCareBathBodyCareNavNode',
                  link: '/shop/Categories/BathBodyCare/c/FS-PC-BathBodyCare?nav=/shop/Categories/BathBodyCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soins corporels',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCareNavNode',
                      link: '/shop/Categories/BathBodyCare/BodyCare/c/FS-PC-B100?nav=/shop/Categories/BathBodyCare/BodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et beurres pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyCreamsAndButtersNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyCreamsAndButters/c/FS-PC-B101?nav=/shop/Categories/BathBodyCare/BodyCreamsAndButters',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyLotions/c/FS-PC-B102?nav=/shop/Categories/BathBodyCare/BodyLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes raffermissantes et pour les vergetures',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFirmingAndStretchMarkCreamsNavNode',
                          link: '/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams/c/FS-PC-B103?nav=/shop/Categories/BathBodyCare/FirmingAndStretchMarkCreams',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huiles pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyOilsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyOils/c/FS-PC-B104?nav=/shop/Categories/BathBodyCare/BodyOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cou et décolleté',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareNeckAndDécolletéNavNode',
                          link: '/shop/Categories/BathBodyCare/NeckAndDécolleté/c/FS-PC-B105?nav=/shop/Categories/BathBodyCare/NeckAndDécolleté',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Bain et douche',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndShowerNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndShower/c/FS-PC-B200?nav=/shop/Categories/BathBodyCare/BathAndShower',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Nettoyants pour le corps et gels de douche',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyWashAndShowerGelsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyWashAndShowerGels/c/FS-PC-B201?nav=/shop/Categories/BathBodyCare/BodyWashAndShowerGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sels de bains et bain moussant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathSoaksAndBubbleBathNavNode',
                          link: '/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath/c/FS-PC-B202?nav=/shop/Categories/BathBodyCare/BathSoaksAndBubbleBath',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Exfoliants corporels',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodyScrubsNavNode',
                          link: '/shop/Categories/BathBodyCare/BodyScrubs/c/FS-PC-B203?nav=/shop/Categories/BathBodyCare/BodyScrubs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de bain',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBathAccessoriesNavNode',
                          link: '/shop/Categories/BathBodyCare/BathAccessories/c/FS-PC-B204?nav=/shop/Categories/BathBodyCare/BathAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des mains et des pieds',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareHandAndFootCareNavNode',
                      link: '/shop/Categories/BathBodyCare/HandAndFootCare/c/FS-PC-B300?nav=/shop/Categories/BathBodyCare/HandAndFootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Savons à main',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSoapsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSoaps/c/FS-PC-B301?nav=/shop/Categories/BathBodyCare/HandSoaps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Désinfectants pour les mains',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandSanitizersNavNode',
                          link: '/shop/Categories/BathBodyCare/HandSanitizers/c/FS-PC-B302?nav=/shop/Categories/BathBodyCare/HandSanitizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lotions et crèmes pour les mains',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareHandCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BathBodyCare/HandCreamsAndLotions/c/FS-PC-B303?nav=/shop/Categories/BathBodyCare/HandCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et masques pour les pieds',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCreamsAndTreatments/c/FS-PC-B304?nav=/shop/Categories/BathBodyCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Outils de soins des pieds',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareFootCareToolsNavNode',
                          link: '/shop/Categories/BathBodyCare/FootCareTools/c/FS-PC-B305?nav=/shop/Categories/BathBodyCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Baumes pour les lèvres',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareLipBalmsNavNode',
                      link: '/shop/Categories/BathBodyCare/LipBalms/c/FS-PC-B400?nav=/shop/Categories/BathBodyCare/LipBalms',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Déodorant et antisudorifique',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantAndAntiperspirantNavNode',
                      link: '/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant/c/FS-PC-B500?nav=/shop/Categories/BathBodyCare/DeodorantAndAntiperspirant',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Déodorant',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareDeodorantNavNode',
                          link: '/shop/Categories/BathBodyCare/Deodorant/c/FS-PC-B501?nav=/shop/Categories/BathBodyCare/Deodorant',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Eau parfumante et poudre pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySpraysAndPowderNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySpraysAndPowder/c/FS-PC-B502?nav=/shop/Categories/BathBodyCare/BodySpraysAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Protection solaire',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSunCareNavNode',
                      link: '/shop/Categories/BathBodyCare/SunCare/c/FS-PC-B600?nav=/shop/Categories/BathBodyCare/SunCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écran solaire pour le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBodySunscreenNavNode',
                          link: '/shop/Categories/BathBodyCare/BodySunscreen/c/FS-PC-B602?nav=/shop/Categories/BathBodyCare/BodySunscreen',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Après-soleil',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareAfterSunNavNode',
                          link: '/shop/Categories/BathBodyCare/AfterSun/c/FS-PC-B603?nav=/shop/Categories/BathBodyCare/AfterSun',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Autobronzants',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareSelfTannersNavNode',
                      link: '/shop/Categories/BathBodyCare/SelfTanners/c/FS-PC-B700?nav=/shop/Categories/BathBodyCare/SelfTanners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour le bain et le corps',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareBathAndBodyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets/c/FS-PC-B800?nav=/shop/Categories/BathBodyCare/BathAndBodyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits pour le bain et le corps',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Bath-%26-Body-Care/c/FS-PC-BathBodyCare?nav=%2Fshop%2FCategories%2FBathBodyCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareBathBodyCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl: null,
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/bathbodycare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins pour le corps et le bain',
                          uid: 'FrontShopMobilePersonalCareBathBodyCareBBCFeaturedCollectionNavNode',
                          link: '/c/FS-PC-BathBodyCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/BathBodyCare/FeaturedCollections/BathBodyCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Contrôle de la vessie & incontinence',
                  uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceNavNode',
                  link: '/shop/Categories/BladderControlAndIncontinence/c/FS-PC-BladderControlAndIncontinence?nav=/shop/Categories/BladderControlAndIncontinence',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Doublures et serviettes pour incontinence',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceIncontinencePadsAndLinersL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners/c/FS-PC-I100?nav=/shop/Categories/BladderControlAndIncontinence/IncontinencePadsAndLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sous-vêtements protecteurs',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceProtectiveUnderwearAndBriefsL2L3NavNode',
                      link: '/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs/c/FS-PC-I200?nav=/shop/Categories/BladderControlAndIncontinence/ProtectiveUnderwearAndBriefs',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: ' Nouveau! Hygiène féminine Thinx ',
                      uid: 'FrontShopMobilePersonalCareBladderControlAndIncontinenceThinxFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins intimes',
                  uid: 'FrontShopMobilePersonalCareFeminineCareNavNode',
                  link: 'c/FS-PC-FeminineCare?nav=/shop/Categories/IntimateCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Serviettes hygiéniques et protège-dessous',
                      uid: 'FrontShopMobilePersonalCareFeminineCarePadsAndPantyLinersL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/PadsAndPantyLiners/c/FS-PC-F100?nav=/shop/Categories/FeminineCare/PadsAndPantyLiners',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Traitements contre les infections aux levures',
                      uid: 'FrontShopMobilePersonalCareFeminineCareYeastInfectionTreatmentsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/YeastInfectionTreatments/c/FS-PC-F400?nav=/shop/Categories/FeminineCare/YeastInfectionTreatments',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Nettoyants et désodorisants pour hygiène intime',
                      uid: 'FrontShopMobilePersonalCareFeminineCareIntimateCleaningAndDeodorantsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants/c/FS-PC-F500?nav=/shop/Categories/FeminineCare/IntimateCleaningAndDeodorants',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tampons',
                      uid: 'FrontShopMobilePersonalCareFeminineCareTamponsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Tampons/c/FS-PC-F200?nav=/shop/Categories/FeminineCare/Tampons',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Coupe menstruelle',
                      uid: 'FrontShopMobilePersonalCareFeminineCareCupsL2L3NavNode',
                      link: '/shop/Categories/FeminineCare/Cups/c/FS-PC-F300?nav=/shop/Categories/FeminineCare/Cups',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareFeminineCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits soins intimes',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Feminine-Care/c/FS-PC-FeminineCare?nav=%2Fshop%2FCategories%2FFeminineCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareFeminineCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl: null,
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareFeminineCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/femininecare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins intimes',
                          uid: 'FrontShopMobilePersonalCareFeminineCareIntimateFeaturedCollectionNavNode',
                          link: '/c/FS-PC-FeminineCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/IntimateCare/FeaturedCollections/IntimateCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Nettoyant féminin Vagisil ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vagisil/wk25_featurecollecctiontile_vagisil_enfr.png',
                            imageLink:
                              '/c/VAGISIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/FeminineCare/FeaturedCollections/Vagisil',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Nettoyant féminin Vagisil ',
                          uid: 'FrontShopMobilePersonalCareFeminineCareVagisilFeaturedCollectionNavNode',
                          link: '/c/VAGISIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/FeminineCare/FeaturedCollections/Vagisil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins dentaires',
                  uid: 'FrontShopMobilePersonalCareOralCareNavNode',
                  link: '/shop/Categories/OralCare/c/FS-PC-OralCare?nav=/shop/Categories/OralCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Brosses à dents',
                      uid: 'FrontShopMobilePersonalCareOralCareToothbrushesNavNode',
                      link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O100?nav=/shop/Categories/OralCare/Toothbrushes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Brosses à dents électriques',
                          uid: 'FrontShopMobilePersonalCareOralCareElectricalToothbrushesNavNode',
                          link: '/shop/Categories/OralCare/ElectricalToothbrushes/c/FS-PC-O101?nav=/shop/Categories/OralCare/ElectricalToothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses à dents',
                          uid: 'FrontShopMobilePersonalCareOralCareToothbrushsNavNode',
                          link: '/shop/Categories/OralCare/Toothbrushes/c/FS-PC-O102?nav=/shop/Categories/OralCare/Toothbrushes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Produits de soins dentaires',
                      uid: 'FrontShopMobilePersonalCareOralCareOralCareProductsNavNode',
                      link: '/shop/Categories/OralCare/OralCareProducts/c/FS-PC-O200?nav=/shop/Categories/OralCare/OralCareProducts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Dentifrice',
                          uid: 'FrontShopMobilePersonalCareOralCareToothpasteNavNode',
                          link: '/shop/Categories/OralCare/Toothpaste/c/FS-PC-O201?nav=/shop/Categories/OralCare/Toothpaste',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Blanchissement des dents',
                          uid: 'FrontShopMobilePersonalCareOralCareTeethWhiteningNavNode',
                          link: '/shop/Categories/OralCare/TeethWhitening/c/FS-PC-O202?nav=/shop/Categories/OralCare/TeethWhitening',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rince-bouches',
                          uid: 'FrontShopMobilePersonalCareOralCareMouthwashAndRinsesNavNode',
                          link: '/shop/Categories/OralCare/MouthwashAndRinses/c/FS-PC-O203?nav=/shop/Categories/OralCare/MouthwashAndRinses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rafraîchisseurs d’haleine',
                          uid: 'FrontShopMobilePersonalCareOralCareBreathFreshenersNavNode',
                          link: '/shop/Categories/OralCare/BreathFresheners/c/FS-PC-O204?nav=/shop/Categories/OralCare/BreathFresheners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins dentaires',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalCareNavNode',
                          link: '/shop/Categories/OralCare/DentalCare/c/FS-PC-O206?nav=/shop/Categories/OralCare/DentalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Oral Hygiene Accessories',
                          uid: 'FrontShopMobilePersonalCareOralCareOralHygieneAccessoriesNavNode',
                          link: '/shop/Categories/OralCare/OralHygieneAccessories/c/FS-PC-O207?nav=/shop/Categories/OralCare/OralHygieneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soie dentaire',
                          uid: 'FrontShopMobilePersonalCareOralCareDentalFlossNavNode',
                          link: '/shop/Categories/OralCare/DentalFloss/c/FS-PC-O205?nav=/shop/Categories/OralCare/DentalFloss',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Magasiner par:',
                      uid: 'FrontShopMobilePersonalCareOralCareShopByNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Des choix bien réfléchis : Produits de soins buccodentaires',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFilterNavNode',
                          link: '/Shop/Categories/Personal-Care/Oral-Care/c/FS-PC-OralCare?nav=%2Fshop%2FCategories%2FOralCare&sort=trending&page=0&q=%3Atrending%3AshopByCollection%3AThoughtful%2BChoices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareOralCareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Des choix bien réfléchis',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2021/P6/WK24/thoughtful-choices/collection-tile/menufeaturedtile_TC_personalcare.jpg',
                            imageLink: '/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Des choix bien réfléchis',
                          uid: 'FrontShopMobilePersonalCareOralCareTCFeaturedCollectionNavNode',
                          link: '/Shop/Thoughtful-Choices/c/SDM-TC?nav=/shop/personalcare/oralcare/featuredcollections/tc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins buccaux',
                          uid: 'FrontShopMobilePersonalCareOralCareOralCareFeaturedCollectionNavNode',
                          link: '/c/FS-PC-OralCare?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue?nav=/shop/Categories/PersonalCare/OralCare/FeaturedCollections/OralCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Rasage et épilation',
                  uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalNavNode',
                  link: '/shop/Categories/ShavingAndHairRemoval/c/FS-PC-ShavingAndHairRemoval?nav=/shop/Categories/ShavingAndHairRemoval',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Crèmes et gels de rasage',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingCreamsAndGelsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels/c/FS-PC-S100?nav=/shop/Categories/ShavingAndHairRemoval/ShavingCreamsAndGels',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cires et crèmes dépilatoires',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairWaxesAndRemovalCreamsL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams/c/FS-PC-S300?nav=/shop/Categories/ShavingAndHairRemoval/HairWaxesAndRemovalCreams',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoir électrique',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalElectricShaversL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/ElectricShavers/c/FS-PC-S400?nav=/shop/Categories/ShavingAndHairRemoval/ElectricShavers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Rasoirs et lames jetables',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalDisposableRazorAndBladesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades/c/FS-PC-S500?nav=/shop/Categories/ShavingAndHairRemoval/DisposableRazorAndBlades',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Appareils dépilatoires',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalHairRemovalDevicesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices/c/FS-PC-S600?nav=/shop/Categories/ShavingAndHairRemoval/HairRemovalDevices',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires de toilette',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalGroomingAccessoriesL2L3NavNode',
                      link: '/shop/Categories/ShavingAndHairRemoval/GroomingAccessories/c/FS-PC-S700?nav=/shop/Categories/ShavingAndHairRemoval/GroomingAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rasage et épilation',
                          uid: 'FrontShopMobilePersonalCareShavingAndHairRemovalShavingFeaturedCollectionNavNode',
                          link: '/c/FS-PC-S400?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/PersonalCare/ShavingAndHairRemoval/FeaturedCollections/ShavingAndHairRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Pour hommes',
                  uid: 'FrontShopMobilePersonalCareMenNavNode',
                  link: '/shop/Categories/Men/c/FS-PC-Men?nav=/shop/Categories/Men',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Rasage pour lui',
                      uid: 'FrontShopMobilePersonalCareMenShavingforHimNavNode',
                      link: '/shop/Categories/Men/ShavingforHim/c/FS-PC-M100?nav=/shop/Categories/Men/ShavingforHim',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes & gels de rasage',
                          uid: 'FrontShopMobilePersonalCareMenShavingCreamsAndGelsNavNode',
                          link: '/shop/Categories/Men/ShavingCreamsAndGels/c/FS-PC-M101?nav=/shop/Categories/Men/ShavingCreamsAndGels',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoir électrique',
                          uid: 'FrontShopMobilePersonalCareMenElectricShaversNavNode',
                          link: '/shop/Categories/Men/ElectricShavers/c/FS-PC-M104?nav=/shop/Categories/Men/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobilePersonalCareMenDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/Men/DisposableRazorAndBlades/c/FS-PC-M105?nav=/shop/Categories/Men/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobilePersonalCareMenGroomingAccessoriesNavNode',
                          link: '/shop/Categories/Men/GroomingAccessories/c/FS-PC-M106?nav=/shop/Categories/Men/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobilePersonalCareMenFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Outils et accessoires',
                  uid: 'FrontShopMobilePersonalCareToolsAccessNavNode',
                  link: '/shop/Categories/ToolsAccess/c/FS-PC-ToolsAccess?nav=/shop/Categories/ToolsAccess',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Outils de coiffure',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairStylingToolsNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairStylingTools/c/FS-PC-T100?nav=/shop/Categories/ToolsAndAccessories/HairStylingTools',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fers à friser',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesCurlingIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/CurlingIrons/c/FS-PC-T103?nav=/shop/Categories/ToolsAndAccessories/CurlingIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Sèche-cheveux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBlowDryersNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BlowDryers/c/FS-PC-T101?nav=/shop/Categories/ToolsAndAccessories/BlowDryers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fers à lisser et fers plats',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesStraightenersAndFlatIronsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons/c/FS-PC-T102?nav=/shop/Categories/ToolsAndAccessories/StraightenersAndFlatIrons',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Brosses et peignes',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBrushesAndCombsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BrushesAndCombs/c/FS-PC-T104?nav=/shop/Categories/ToolsAndAccessories/BrushesAndCombs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour cheveux',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/HairAccessories/c/FS-PC-T200?nav=/shop/Categories/ToolsAndAccessories/HairAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Pinces et épingles à cheveux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesClipsAndPinsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ClipsAndPins/c/FS-PC-T201?nav=/shop/Categories/ToolsAndAccessories/ClipsAndPins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bandeaux et serre-tête',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHeadbandsAndHeadWrapsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps/c/FS-PC-T202?nav=/shop/Categories/ToolsAndAccessories/HeadbandsAndHeadWraps',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Élastiques',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElasticsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Elastics/c/FS-PC-T203?nav=/shop/Categories/ToolsAndAccessories/Elastics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Outils de rasage et accessoires de toilette',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesShavingAndGroomingToolsAndAcessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories/c/FS-PC-T300?nav=/shop/Categories/ToolsAndAccessories/ShavingAndGroomingToolsAndAcessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Rasoirs électriques',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesElectricShaversNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/ElectricShavers/c/FS-PC-T301?nav=/shop/Categories/ToolsAndAccessories/ElectricShavers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Rasoirs et lames jetables',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesDisposableRazorAndBladesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades/c/FS-PC-T302?nav=/shop/Categories/ToolsAndAccessories/DisposableRazorAndBlades',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils dépilatoires',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHairRemovalDevicesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HairRemovalDevices/c/FS-PC-T303?nav=/shop/Categories/ToolsAndAccessories/HairRemovalDevices',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires de toilette',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesGroomingAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/GroomingAccessories/c/FS-PC-T304?nav=/shop/Categories/ToolsAndAccessories/GroomingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de garde-robe',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WardrobeAccessories/c/FS-PC-T400?nav=/shop/Categories/ToolsAndAccessories/WardrobeAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Bijoux',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesJewelleryNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Jewellery/c/FS-PC-T401?nav=/shop/Categories/ToolsAndAccessories/Jewellery',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soutiens-gorge accessoires',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesBraAccessoriesNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/BraAccessories/c/FS-PC-T402?nav=/shop/Categories/ToolsAndAccessories/BraAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bas et collants',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesHosieryAndTightsNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/HosieryAndTights/c/FS-PC-T403?nav=/shop/Categories/ToolsAndAccessories/HosieryAndTights',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Chaussettes',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesSocksNavNode',
                          link: '/shop/Categories/ToolsAndAccessories/Socks/c/FS-PC-T404?nav=/shop/Categories/ToolsAndAccessories/Socks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’hiver',
                          uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWardrobeAccessoriesWinterAccessoriesNavNode',
                          link: '/c/FS-PC-T405?nav=shop/PersonalCare/ToolsAndAccessories/WardrobeAccessories/WinterAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires de voyage',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesTravelAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/TravelAccessories/c/FS-PC-T500?nav=/shop/Categories/ToolsAndAccessories/TravelAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Accessoires météorologiques',
                      uid: 'FrontShopMobilePersonalCareToolsAndAccessoriesWeatherAccessoriesNavNode',
                      link: '/shop/Categories/ToolsAndAccessories/WeatherAccessories/c/FS-PC-T600?nav=/shop/Categories/ToolsAndAccessories/WeatherAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Articles format voyage',
                  uid: 'FrontShopMobilePersonalCareTravelSizedItemsNavNode',
                  link: '/shop/Categories/TravelSizedItems/c/FS-PC-TravelSizedItems?nav=/shop/Categories/TravelSizedItems',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Lutte contre les insectes et animaux nuisibles',
                  uid: 'FrontShopMobilePersonalCareInsectPestControlNavNode',
                  link: '/Shop/Catégories/Soins-personnels/Lutte-contre-les-insectes-et-animaux-nuisiblesLutte-contre-les-insectes-et-animaux-nuisibles/c/FS-PC-InsectPestControl?sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Santé',
              uid: 'FrontShopMobileHealthNavNode',
              link: '/Health?nav=/shop/health',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Médicaments et traitements',
                  uid: 'FrontShopMobileHealthMedicineAndTreatmentsNavNode',
                  link: '/shop/Categories/MedicineAndTreatments/c/FS-HT-MedicineAndTreatments?nav=/shop/Categories/MedicineAndTreatments',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Toux, rhume et grippe',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFlu/c/FS-HT-M100?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFlu',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluMedicationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication/c/FS-HT-M101?nav=/shop/Categories/MedicineAndTreatments/CoughColdAndFluMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Children's Medication",
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsCoughColdAndFluChildrensMedicationNavNode',
                          link: '/Shop/Children%27s-Medication/c/FS-HT-M102?nav=/shop/Categories/Health/MedicineandTreatments/CoughColdandFlu/ChildrensMedication',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins nasaux et aides-sommeil',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareAndSleepAidsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M104?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Humidifiers, Purifiers & Vaporizers',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHumidifiersPurifiersAndVaporizersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers/c/FS-HT-M105?nav=/shop/Categories/MedicineAndTreatments/HumidifiersPurifiersAndVaporizers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalRubNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicalRub/c/FS-MT-107?nav=/shop/Categories/MedicineAndTreatments/TopicalRub',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Thermomètres',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsThermometersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Thermometers/c/FS-HT-M106?nav=/shop/Categories/MedicineAndTreatments/Thermometers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soulagement de la douleur',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPainReliefNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PainRelief/c/FS-HT-M200?nav=/shop/Categories/MedicineAndTreatments/PainRelief',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Soulagement des maux de tête et de la fièvre',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHeadacheAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief/c/FS-HT-M201?nav=/shop/Categories/MedicineAndTreatments/HeadacheAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement des douleurs musculaires, dorsales et articulaires',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMuscleBackAndJointPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief/c/FS-HT-M202?nav=/shop/Categories/MedicineAndTreatments/MuscleBackAndJointPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Topiques pour le soulagement de la douleur',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTopicalPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/TopicPainRelief/c/FS-HT-M203?nav=/shop/Categories/MedicineAndTreatments/TopicPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement des hémorroïdes',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHemorrhoidReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HemorrhoidRelief/c/FS-HT-M206?nav=/shop/Categories/MedicineAndTreatments/HemorrhoidRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement contre la douleur buccale',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsOralPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/OralPainRelief/c/FS-HT-M209?nav=/shop/Categories/MedicineAndTreatments/OralPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement chaud et froid',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHotAndColdTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HotAndColdTreatment/c/FS-HT-M210?nav=/shop/Categories/MedicineAndTreatments/HotAndColdTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement de santé cardiaque',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsHeartHealthTreatmentNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose/c/FS-HT-M205?nav=/shop/Categories/MedicineAndTreatments/HeartHealthAndLowDose',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la douleur et de la fièvre pour enfants',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief/c/FS-HT-M204?nav=/shop/Categories/MedicineAndTreatments/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Douleurs menstruelles',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMenstrualPainReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MenstrualPainRelief/c/FS-HT-M208?nav=/shop/Categories/MedicineAndTreatments/MenstrualPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé digestive',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveHealthNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DigestiveHealth/c/FS-HT-M300?nav=/shop/Categories/MedicineAndTreatments/DigestiveHealth',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Reflux gastrique',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAcidRefluxNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/AcidReflux/c/FS-HT-M301?nav=/shop/Categories/MedicineAndTreatments/AcidReflux',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsProbioticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Probiotics/c/FS-HT-M302?nav=/shop/Categories/MedicineAndTreatments/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fibres & Laxatives',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFibresAndLaxativesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FibresAndLaxatives/c/FS-HT-M303?nav=/shop/Categories/MedicineAndTreatments/FibresAndLaxatives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mal des transports et nausées',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMotionSicknessAndNauseaNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea/c/FS-HT-M305?nav=/shop/Categories/MedicineAndTreatments/MotionSicknessAndNausea',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Intolérance digestive',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDigestiveIntoleranceNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DigestiveIntolerance/c/FS-HT-M306?nav=/shop/Categories/MedicineAndTreatments/DigestiveIntolerance',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la diarrhée',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiarrheaReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiarrheaRelief/c/FS-HT-M304?nav=/shop/Categories/MedicineAndTreatments/DiarrheaRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lavements',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsEnemasNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Enemas/c/FS-HT-M307?nav=/shop/Categories/MedicineAndTreatments/Enemas',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Premiers soins',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/FirstAid/c/FS-HT-M400?nav=/shop/Categories/MedicineAndTreatments/FirstAid',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Fournitures pour pansements et ruban',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBandagingSuppliesAndTapeNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape/c/FS-HT-M401?nav=/shop/Categories/MedicineAndTreatments/BandagingSuppliesAndTape',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antiseptiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntisepticsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antiseptics/c/FS-HT-M402?nav=/shop/Categories/MedicineAndTreatments/Antiseptics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la peau',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSkinReliefNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/SkinRelief/c/FS-HT-M403?nav=/shop/Categories/MedicineAndTreatments/SkinRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fournitures de premiers soins',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsFirstAidSuppliesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/FirstAidSupplies/c/FS-HT-M405?nav=/shop/Categories/MedicineAndTreatments/FirstAidSupplies',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins contre les poux',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsLiceCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/LiceCare/c/FS-HT-M406?nav=/shop/Categories/MedicineAndTreatments/LiceCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Articles de contention et vêtements médicaux',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsMedicalSupportsAndGarmentsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments/c/FS-HT-M407?nav=/shop/Categories/MedicineAndTreatments/MedicalSupportsAndGarments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soin des brûlures et des plaies',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsBurnAndWoundCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/BurnAndWoundCare/c/FS-HT-M404?nav=/shop/Categories/MedicineAndTreatments/BurnAndWoundCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sinus et allergies',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsAllergyAndSinusNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/AllergyAndSinus/c/FS-HT-M500?nav=/shop/Categories/MedicineAndTreatments/AllergyAndSinus',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Antihistaminiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Antihistamines/c/FS-HT-M501?nav=/shop/Categories/MedicineAndTreatments/Antihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines/c/FS-HT-M502?nav=/shop/Categories/MedicineAndTreatments/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins du nez',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsNasalCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/NasalCare/c/FS-HT-M503?nav=/shop/Categories/MedicineAndTreatments/NasalCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour les diabétiques',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesCareNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/DiabeticCare/c/FS-HT-M600?nav=/shop/Categories/MedicineAndTreatments/DiabeticCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Test de glycémie',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsGlucoseTestingNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/GlucoseTesting/c/FS-HT-M601?nav=/shop/Categories/MedicineAndTreatments/GlucoseTesting',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Administration de l’insuline',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsInsulinAdminstrationNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/InsulinAdminstration/c/FS-HT-M602?nav=/shop/Categories/MedicineAndTreatments/InsulinAdminstration',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour diabétiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesSupplementsNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSupplements/c/FS-HT-M603?nav=/shop/Categories/MedicineAndTreatments/DiabeticSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins de la peau pour diabétiques',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsDiabetesSkinCareNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/DiabeticSkincare/c/FS-HT-M605?nav=/shop/Categories/MedicineAndTreatments/DiabeticSkincare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Édulcorants',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsSweetenersNavNode',
                          link: '/shop/Categories/MedicineAndTreatments/Sweeteners/c/FS-HT-M606?nav=/shop/Categories/MedicineAndTreatments/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Abandon du tabac',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsQuitSmokingNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/QuitSmoking/c/FS-HT-M700?nav=/shop/Categories/MedicineAndTreatments/QuitSmoking',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Aides au sommeil',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsSleepAidsNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/SleepAids/c/FS-HT-M800?nav=/shop/Categories/MedicineAndTreatments/SleepAids',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Organisation des médicaments',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsPillOrganizationNavNode',
                      link: '/shop/Categories/MedicineAndTreatments/PillOrganization/c/FS-HT-M900?nav=/shop/Categories/MedicineAndTreatments/PillOrganization',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthMedicineAndTreatmentsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Équipement de protection individuelle ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P1/wk01/front-shop/featurecollecctiontile_ppe/wk01_featurecollecctiontile_ppe_enfr.jpg',
                            imageLink:
                              '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Équipement de protection individuelle ',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsPPEFeaturedCollectionNavNode',
                          link: '/c/PPE?nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/PPE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Advil pour le soulagement rapide de la douleur',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_advil/wk13_featurecollecctiontile_advil_enfr.png',
                            imageLink:
                              '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/Advil',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Advil pour le soulagement rapide de la douleur',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsAdvilFeaturedCollectionNavNode',
                          link: '/c/ADVIL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/Advil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Tylenol Soulagement de la douleur, extra-fort',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_tylenol/wk17_featurecollecctiontile_tylenol_enfr.png',
                            imageLink:
                              '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Tylenol Soulagement de la douleur, extra-fort',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsTylenolPainReliefFeaturedCollectionNavNode',
                          link: '/c/TYLENOL?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/MedicineAndTreatments/FeaturedCollections/TylenolPainRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement efficace de la douleur Voltaren',
                          uid: 'FrontShopMobileHealthMedicineAndTreatmentsVoltarenFeaturedCollectionNavNode',
                          link: '/c/SDM-TC?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Beauty/HairCare/FeaturedCollections/TC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Vitamines et suppléments',
                  uid: 'FrontShopMobileHealthVitaminsAndSupplementsNavNode',
                  link: '/shop/Categories/VitaminsAndSupplements/c/FS-HT-VitaminsAndSupplements?nav=/shop/Categories/VitaminsAndSupplements',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Vitamines',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Vitamins/c/FS-HT-V100?nav=/shop/Categories/VitaminsAndSupplements/Vitamins',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Multivitamines pour enfants',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsChildrensMultivitaminsAndVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins/c/FS-HT-V102?nav=/shop/Categories/VitaminsAndSupplements/ChildrensMultivitaminsAndVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine A',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminANavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminA/c/FS-HT-V104?nav=/shop/Categories/VitaminsAndSupplements/VitaminA',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine B',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminBNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminB/c/FS-HT-V105?nav=/shop/Categories/VitaminsAndSupplements/VitaminB',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine C',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminCNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminC/c/FS-HT-V106?nav=/shop/Categories/VitaminsAndSupplements/VitaminC',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine D',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminDNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminD/c/FS-HT-V107?nav=/shop/Categories/VitaminsAndSupplements/VitaminD',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamine E',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaminENavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/VitaminE/c/FS-HT-V108?nav=/shop/Categories/VitaminsAndSupplements/VitaminE',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Multivitamines pour adultes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAdultsMultivitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins/c/FS-HT-V101?nav=/shop/Categories/VitaminsAndSupplements/AdultsMultivitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Vitamines prénatales',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsPrenatalVitaminsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/PrenatalVitamins/c/FS-HT-V103?nav=/shop/Categories/VitaminsAndSupplements/PrenatalVitamins',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/Supplements/c/FS-HT-V200?nav=/shop/Categories/VitaminsAndSupplements/Supplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Huiles de poisson riches en oméga',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOmegaFishOilsAndEssentialFattyAcidsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids/c/FS-HT-V201?nav=/shop/Categories/VitaminsAndSupplements/OmegaFishOilsAndEssentialFattyAcids',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Probiotiques',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProbioticsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Probiotics/c/FS-HT-V203?nav=/shop/Categories/VitaminsAndSupplements/Probiotics',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des articulations',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsJointHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/JointHealth/c/FS-HT-V204?nav=/shop/Categories/VitaminsAndSupplements/JointHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des yeux',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/EyeHealth/c/FS-HT-V205?nav=/shop/Categories/VitaminsAndSupplements/EyeHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins des cheveux, des ongles et de la peau',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHairNailsAndSkinHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth/c/FS-HT-V207?nav=/shop/Categories/VitaminsAndSupplements/HairNailsAndSkinHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Mélatonine',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMelatoninNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Melatonin/c/FS-HT-V209?nav=/shop/Categories/VitaminsAndSupplements/Melatonin',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments alimentaires naturels',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHealthFoodSupplementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements/c/FS-HT-V210?nav=/shop/Categories/VitaminsAndSupplements/HealthFoodSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Homéopathie',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHomeopathyNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Homeopathy/c/FS-HT-V211?nav=/shop/Categories/VitaminsAndSupplements/Homeopathy',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Caféine',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsCaffeineNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Caffeine/c/FS-HT-V212?nav=/shop/Categories/VitaminsAndSupplements/Caffeine',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé du cœur',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsHeartHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/HeartHealth/c/FS-HT-V206?nav=',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des femmes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWomensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/WomensHealth/c/FS-HT-V214?nav=/shop/Categories/VitaminsAndSupplements/WomensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Santé des hommes',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMensHealthNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MensHealth/c/FS-HT-V213?nav=/shop/Categories/VitaminsAndSupplements/MensHealth',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Suppléments de minéraux',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsMineralSupplementsNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/MineralSupplements/c/FS-HT-V300?nav=/shop/Categories/VitaminsAndSupplements/MineralSupplements',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Calcium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsCalciumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Calcium/c/FS-HT-V301?nav=/shop/Categories/VitaminsAndSupplements/Calcium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Fer',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsIronNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Iron/c/FS-HT-V302?nav=/shop/Categories/VitaminsAndSupplements/Iron',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Magnésium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMagnesiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Magnesium/c/FS-HT-V303?nav=/shop/Categories/VitaminsAndSupplements/Magnesium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Potassium',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsPotassiumNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Potassium/c/FS-HT-V304?nav=/shop/Categories/VitaminsAndSupplements/Potassium',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Zinc',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsZincNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Zinc/c/FS-HT-V305?nav=/shop/Categories/VitaminsAndSupplements/Zinc',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Autres minéraux',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOtherMineralsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/OtherMinerals/c/FS-HT-V306?nav=/shop/Categories/VitaminsAndSupplements/OtherMinerals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Nutrition et gestion du poids',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsNutritionAndWeightManagementNavNode',
                      link: '/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement/c/FS-HT-V400?nav=/shop/Categories/VitaminsAndSupplements/NutritionAndWeightManagement',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Barres protéinées et collations',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinBarsAndSnacksNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks/c/FS-HT-V401?nav=/shop/Categories/VitaminsAndSupplements/ProteinBarsAndSnacks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Protéines liquides et en poudre',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsProteinLiquidAndPowderNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder/c/FS-HT-V403?nav=/shop/Categories/VitaminsAndSupplements/ProteinLiquidAndPowder',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Substituts de repas',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsMealReplacementsNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/MealReplacements/c/FS-HT-V404?nav=/shop/Categories/VitaminsAndSupplements/MealReplacements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle de l’appétit',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsAppetiteControlNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/AppetiteControl/c/FS-HT-V405?nav=/shop/Categories/VitaminsAndSupplements/AppetiteControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Édulcorants',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsSweetenersNavNode',
                          link: '/shop/Categories/VitaminsAndSupplements/Sweeteners/c/FS-HT-V402?nav=/shop/Categories/VitaminsAndSupplements/Sweeteners',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHealthVitaminsAndSupplementsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Webber Naturals pour le sommeil et le soulagement du stress',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P4/wk13/feature-collection/featuredcollectiontile_webber/wk13_featurecollecctiontile_webber_enfr.png',
                            imageLink:
                              '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitamines Webber Naturals',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsWebberNaturalsFeaturedCollectionNavNode',
                          link: '/c/WEBBER?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/vitaminsandsupplements/featuredcollections/webbernaturals',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Gouttes oculaires antirougeur Lumify de Bausch + Lomb',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P5/wk17/front-shop/featuredcollectiontile_bleyedrops/wk17_featurecollecctiontile_bauschlomb_enfr.png',
                            imageLink:
                              '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Gouttes oculaires antirougeur Lumify de Bausch + Lomb',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsEyeDropsFeaturedCollectionNavNode',
                          link: '/c/BAUSCH,LOMB?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/EyeDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Multivitamines gélifiées Olly',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_ollygummyvitamins/wk25_featurecollecctiontile_ollygummy_enfr.png',
                            imageLink:
                              '/c/OLLY?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollection/Olly',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Multivitamines gélifiées Olly',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsOllyFeaturedCollectionNavNode',
                          link: '/c/OLLY?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollection/Olly',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: {
                            name: 'Vitamines Vitalux Advanced ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2023/P7/wk25/front-shop/fct_vitaluxvitamins/wk25_featurecollecctiontile_vitalux_enfr.png',
                            imageLink:
                              '/c/Vitalux?sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=/shop/Categories/Health/VitaminsAndSupplements/FeaturedCollections/Vitalux',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Vitamines Vitalux Advanced ',
                          uid: 'FrontShopMobileHealthVitaminsAndSupplementsVitaluxFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Bien-être sexuel et planification familiale',
                  uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningNavNode',
                  link: '/shop/Categories/SexualWelnessAndFamilyPlanning/c/FS-HT-SexualWelnessAndFamilyPlanning?nav=/shop/Categories/SexualWelnessAndFamilyPlanning',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bien-être sexuel',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness/c/FS-HT-S100?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/SexualWellness',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Lubrifiants et huile pour massage intime',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningLubricantsAndIntimateMassageOilsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils/c/FS-HT-S103?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/LubricantsAndIntimateMassageOils',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jouets pour adultes',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningAdultToysNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys/c/FS-HT-S104?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/AdultToys',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Condoms',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningCondomsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms/c/FS-HT-S101?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Condoms',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contraceptifs',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningContraceptivesNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives/c/FS-HT-S102?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/Contraceptives',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Planification familiale',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFamilyPlanningNavNode',
                      link: '/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning/c/FS-HT-S200?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/FamilyPlanning',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Tests de grossesse',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningPregnancyTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests/c/FS-HT-S201?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/PregnancyTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Trousses et tests d’ovulation',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningOvulationKitsAndTestsNavNode',
                          link: '/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests/c/FS-HT-S202?nav=/shop/Categories/SexualWelnessAndFamilyPlanning/OvulationKitsAndTests',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Cadeaux de bien-être sexuel ',
                      uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningFeaturedCollectionNavNode',
                      link: '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Cadeaux de bien-être sexuel ',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_sexualwellnesstoys/wk41_featurecollecctiontile_sexualwellness_enfr.png',
                            imageLink:
                              '/c/FS-HT-S104?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/health/sexualwellnessandfamilyplanning/featuredcollections/sexualwellnessgifts',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Cadeaux de bien-être sexuel ',
                          uid: 'FrontShopMobileHealthSexualWelnessAndFamilyPlanningSexualWellnessFeaturedCollectionNavNode',
                          link: null,
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Soins des yeux, des oreilles et des pieds',
                  uid: 'FrontShopMobileHealthEyeEarAndFootCareNavNode',
                  link: '/shop/Categories/EyeEarAndFootCare/c/FS-HT-EyeEarAndFootCare?nav=/shop/Categories/EyeEarAndFootCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Soin des yeux',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EyeCare/c/FS-HT-E100?nav=/shop/Categories/EyeEarAndFootCare/EyeCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Gouttes pour les yeux et soulagement',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeDropsAndLubricantsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants/c/FS-HT-E102?nav=/shop/Categories/EyeEarAndFootCare/EyeDropsAndLubricants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour entretien des verres de contact',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeCareAccessoriesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeCareAccessories/c/FS-HT-E104?nav=/shop/Categories/EyeEarAndFootCare/EyeCareAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suppléments pour la santé oculaire',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeHealthSupplementsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements/c/FS-HT-E105?nav=/shop/Categories/EyeEarAndFootCare/EyeHealthSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lunettes',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEyeglassesNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/Eyeglasses/c/FS-HT-E103?nav=/shop/Categories/EyeEarAndFootCare/Eyeglasses',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Solution pour verres de contact',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareContactLensSolutionNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/ContactLensSolution/c/FS-HT-E101?nav=/shop/Categories/EyeEarAndFootCare/ContactLensSolution',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins des oreilles',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareEarCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/EarCare/c/FS-HT-E200?nav=/shop/Categories/EyeEarAndFootCare/EarCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Gouttes pour les oreilles',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEarDropsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarDrops/c/FS-HT-E201?nav=/shop/Categories/EyeEarAndFootCare/EarDrops',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Bouchons d’oreilles',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareEarPlugsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/EarPlugs/c/FS-HT-E202?nav=/shop/Categories/EyeEarAndFootCare/EarPlugs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Articles de soins des pieds',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/FootCare/c/FS-HT-E300?nav=/shop/Categories/EyeEarAndFootCare/FootCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Chaussettes de contention',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareCompressionSocksNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/CompressionSocks/c/FS-HT-E301?nav=/shop/Categories/EyeEarAndFootCare/CompressionSocks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Coussinets et semelles intérieures',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareInsertsInsolesAndCushionsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions/c/FS-HT-E302?nav=/shop/Categories/EyeEarAndFootCare/InsertsInsolesAndCushions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Pied d’athlète et antifongiques',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareAthletesFootAndAntifungalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal/c/FS-HT-E303?nav=/shop/Categories/EyeEarAndFootCare/AthletesFootAndAntifungal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre les verrues',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareWartRemovalNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/WartRemoval/c/FS-HT-E304?nav=/shop/Categories/EyeEarAndFootCare/WartRemoval',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Crèmes et traitements pour les pieds',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCreamsAndTreatmentsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments/c/FS-HT-E305?nav=/shop/Categories/EyeEarAndFootCare/FootCreamsAndTreatments',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Contrôle des odeurs et de l’humidité',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareOdorAndWetnessControlNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl/c/FS-HT-E307?nav=/shop/Categories/EyeEarAndFootCare/OdorAndWetnessControl',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soins pour les diabétiques',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareDiabetesCareNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/DiabeticCare/c/FS-HT-E308?nav=/shop/Categories/EyeEarAndFootCare/DiabeticCare',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Appareils de soins des pieds',
                          uid: 'FrontShopMobileHealthEyeEarAndFootCareFootCareToolsNavNode',
                          link: '/shop/Categories/EyeEarAndFootCare/FootCareTools/c/FS-HT-E309?nav=/shop/Categories/EyeEarAndFootCare/FootCareTools',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Accessoires pour la natation',
                      uid: 'FrontShopMobileHealthEyeEarAndFootCareSwimAccessoriesNavNode',
                      link: '/shop/Categories/EyeEarAndFootCare/SwimAccessories/c/FS-HT-E500?nav=/shop/Categories/EyeEarAndFootCare/SwimAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Soins de santé à domicile et conditionnement physique',
                  uid: 'FrontShopMobileHealthHomeHealthCareAndFitnessNavNode',
                  link: '/shop/Categories/HomeHealthCare/c/FS-HT-HomeHealthCare?nav=/shop/Categories/HomeHealthCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bas et chaussettes de compression',
                      uid: 'FrontShopMobileHealthHomeHealthCareCompressionHosieryAndStockingsNavNode',
                      link: '/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings/c/FS-HT-H100?nav=/shop/Categories/HomeHealthCare/CompressionHosieryAndStockings',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Balances, saturomètre et podomètres',
                      uid: 'FrontShopMobileHealthHomeHealthCareScalesPulseOximeterAndPedometersNavNode',
                      link: '/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers/c/FS-HT-H300?nav=/shop/Categories/HomeHealthCare/ScalesPulseOximeterAndPedometers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Bien-être et appareils de massage',
                      uid: 'FrontShopMobileHealthHomeHealthCareBodyWellnessAndMassagersNavNode',
                      link: '/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers/c/FS-HT-H500?nav=/shop/Categories/HomeHealthCare/BodyWellnessAndMassagers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Sécurité pour la salle de bain',
                      uid: 'FrontShopMobileHealthHomeHealthCareBathroomSafetyNavNode',
                      link: '/shop/Categories/HomeHealthCare/BathroomSafety/c/FS-HT-H600?nav=/shop/Categories/HomeHealthCare/BathroomSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Tensiomètres',
                      uid: 'FrontShopMobileHealthHomeHealthCareBloodPressureMonitorsNavNode',
                      link: '/shop/Categories/HomeHealthCare/BloodPressureMonitors/c/FS-HT-H400?nav=/shop/Categories/HomeHealthCare/BloodPressureMonitors',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cannes et béquilles',
                      uid: 'FrontShopMobileHealthHomeHealthCareCaneAndCrutchesNavNode',
                      link: '/shop/Categories/HomeHealthCare/CaneAndCrutches/c/FS-HT-H200?nav=/shop/Categories/HomeHealthCare/CaneAndCrutches',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Équipements et accessoires de conditionnement physique',
                      uid: 'FrontShopMobileHealthHomeHealthCareFitnessEquipmentAndAccessoriesNavNode',
                      link: '/Shop/Categories/Health/Home-Health-Care/Fitness-Equipment-%26-Accessories/c/FS-HT-H700',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
              ],
            },
            {
              name: 'Bébé et enfant',
              uid: 'FrontShopMobileBabyAndChildNavNode',
              link: '/Baby-and-child?nav=/shop/babyandchild',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Soins pour bébés et enfants',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyCare?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Couches et lingettes',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersAndWipesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/DiapersAndWipes/c/FS-BC-B100?nav=/shop/Categories/BabyAndChildCare/DiapersAndWipes',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Couches',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiapersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/Diapers/c/FS-BC-B105?nav=/shop/Categories/BabyAndChildCare/Diapers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: "Culottes d'entraînement",
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareTrainingPantsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/TrainingPants/c/FS-BC-B101?nav=/shop/Categories/BabyAndChildCare/TrainingPants',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Traitement contre l’érythème fessier',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperRashTreatmentNavNode',
                          link: '/shop/Categories/BabyAndChildCare/DiaperRashTreatment/c/FS-BC-B102?nav=/shop/Categories/BabyAndChildCare/DiaperRashTreatment',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Recharges pour poubelles à couches',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareDiaperPailsRefillsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChangingAccessories/c/FS-BC-B104?nav=/shop/Categories/BabyAndChildCare/ChangingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Lingettes pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyWipesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyWipes/c/FS-BC-B103?nav=/shop/Categories/BabyAndChildCare/BabyWipes',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Soins pour le corps et le bain',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBathAndBodyCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BathAndBodyCare/c/FS-BC-B200?nav=/shop/Categories/BabyAndChildCare/BathAndBodyCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Crèmes et lotions pour le corps',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBodyCreamsAndLotionsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions/c/FS-BC-B206?nav=/shop/Categories/BabyAndChildCare/BodyCreamsAndLotions',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Produits pour le bain et shampooings',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyBathAndShampoosNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyBathAndShampoos/c/FS-BC-B201?nav=/shop/Categories/BabyAndChildCare/BabyBathAndShampoos',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cotons-tiges',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareCottonSwabsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/CottonSwabs/c/FS-BC-B202?nav=/shop/Categories/BabyAndChildCare/CottonSwabs',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Huile pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyOilNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyOil/c/FS-BC-B203?nav=/shop/Categories/BabyAndChildCare/BabyOil',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Poudres pour bébés',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyPowdersNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyPowders/c/FS-BC-B204?nav=/shop/Categories/BabyAndChildCare/BabyPowders',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Santé des enfants',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensHealthCareNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildrensHealthCare/c/FS-BC-B300?nav=/shop/Categories/BabyAndChildCare/ChildrensHealthCare',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Médicaments pour la toux, le rhume et la grippe pour enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensCoughColdAndFluNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu/c/FS-BC-B302?nav=/shop/Categories/BabyAndChildCare/ChildrensCoughColdAndFlu',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Antihistaminiques pour enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensAntihistaminesNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensAntihistamines/c/FS-BC-B303?nav=/shop/Categories/BabyAndChildCare/ChildrensAntihistamines',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Soulagement de la douleur et de la fièvre des enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildrensPainAndFeverReliefNavNode',
                          link: '/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief/c/FS-BC-B301?nav=/shop/Categories/BabyAndChildCare/ChildrensPainAndFeverRelief',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Multivitamines pour enfants',
                          uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyAndChildrensSupplementsNavNode',
                          link: '/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements/c/FS-BC-B304?nav=/shop/Categories/BabyAndChildCare/BabyAndChildrensSupplements',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Sécurité et protection des enfants',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareChildproofingAndSafetyNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ChildproofingAndSafety/c/FS-BC-B400?nav=/shop/Categories/BabyAndChildCare/ChildproofingAndSafety',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Jouets',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                      link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Vêtements et accessoires',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareClothingAndAccessoriesNavNode',
                      link: '/shop/Categories/BabyAndChildCare/ClothingAndAccessories/c/FS-BC-B600?nav=/shop/Categories/BabyAndChildCare/ClothingAndAccessories',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cadeaux et ensembles pour bébés',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareBabyGiftsAndSetsNavNode',
                      link: '/shop/Categories/BabyAndChildCare/BabyGiftsAndSets/c/FS-BC-B700?nav=/shop/Categories/BabyAndChildCare/BabyGiftsAndSets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileBabyAndChildBabyAndChildCareFeaturedCollectionsNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Alimentation et préparations',
                  uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNavNode',
                  link: '/shop/Categories/BabyAndChildCare/c/FS-BC-BabyFeeding?nav=/shop/Categories/BabyAndChildCare',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Aliments et préparations pour bébés',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndFormulaNavNode',
                      link: '/shop/Categories/FeedingAndFormula/BabyFoodAndFormula/c/FS-BC-F100?nav=/shop/Categories/FeedingAndFormula/BabyFoodAndFormula',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Formule',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaFormulaNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Formula/c/FS-BC-F101?nav=/shop/Categories/FeedingAndFormula/Formula',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Aliments pour bébés et collations pour tout-petits',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyFoodAndToddlerSnacksNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyFood/c/FS-BC-F102?nav=/shop/Categories/FeedingAndFormula/BabyFood',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Céréales pour bébés',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyCerealNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyCereal/c/FS-BC-F105?nav=/shop/Categories/FeedingAndFormula/BabyCereal',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Alimentation pédiatrique',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPediatricNutritionNavNode',
                          link: '/shop/Categories/FeedingAndFormula/PediatricNutrition/c/FS-BC-F103?nav=/shop/Categories/FeedingAndFormula/PediatricNutrition',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Allaitement et heure du repas',
                      uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaNurisngAndMealtimeNavNode',
                      link: '/shop/Categories/FeedingAndFormula/NurisngAndMealtime/c/FS-BC-F200?nav=/shop/Categories/FeedingAndFormula/NurisngAndMealtime',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Biberons et tétines',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBabyBottlesAndNipplesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples/c/FS-BC-F203?nav=/shop/Categories/FeedingAndFormula/BabyBottlesAndNipples',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Suces et jouets de dentition',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaPacifierNavNode',
                          link: '/shop/Categories/FeedingAndFormula/Pacifier/c/FS-BC-F204?nav=/shop/Categories/FeedingAndFormula/Pacifier',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour l’alimentation des tout-petits',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaToddlerFeedingAccessoriesNavNode',
                          link: '/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories/c/FS-BC-F202?nav=/shop/Categories/FeedingAndFormula/ToddlerFeedingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Essentiels pour l’allaitement',
                          uid: 'FrontShopMobileBabyAndChildFeedingAndFormulaBreastfeedingEssentialsNavNode',
                          link: '/shop/Categories/FeedingAndFormula/BreastfeedingEssentials/c/FS-BC-F201?nav=/shop/Categories/FeedingAndFormula/BreastfeedingEssentials',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Jouets',
                  uid: 'FrontShopMobileBabyAndChildBabyAndChildCareToysNavNode',
                  link: '/shop/Categories/BabyAndChildCare/Toys/c/FS-BC-B500?nav=/shop/Categories/BabyAndChildCare/Toys',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Maison et électronique',
              uid: 'FrontShopMobileHomeAndElectronicsNavNode',
              link: '/Electronics?nav=/shop/homeandelectronics',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Électronique',
                  uid: 'FrontShopMobileHomeAndElectronicsElectronicsNavNode',
                  link: '/shop/Categories/Electronics/c/FS-EL-Electronics?nav=/mobile/shop/Categories/HomeAndElectronics/Electronics',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Systèmes audios',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioNavNode',
                      link: '/shop/Categories/Electronics/Audio/c/FS-EL-301?nav=/shop/Categories/Electronics/Audio',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Écouteurs',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioHeadphonesEarbudsNavNode',
                          link: '/shop/c/FS-EL-403?nav=/shop/Categories/Electronics/Audio/HeadphonesAndEarbuds',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Haut-parleurs',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsAudioSpeakersNavNode',
                          link: '/shop/c/FS-EL-306?nav=/shop/Categories/Electronics/Audio/Speakers',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Piles',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesNavNode',
                      link: '/shop/Categories/Electronics/Batteries/c/FS-EL-100?nav=/shop/Categories/Electronics/Batteries',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Piles spécialisées',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesSpecialtyBatteriesNavNode',
                          link: '/shop/c/FS-EL-103?nav=/shop/Categories/Electronics/Batteries/SpecialtyBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles alcalines',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesAlkalineBatteriesNavNode',
                          link: '/shop/c/FS-EL-101?nav=/shop/Categories/Electronics/Batteries/AlkalineBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Piles pour appareil auditif',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsBatteriesHearingAidBatteriesNavNode',
                          link: '/shop/c/FS-EL-102?nav=/shop/Categories/Electronics/BatteriesHearingAidBatteries',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: "Accessoires de téléphone et d'appareil photo",
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesNavNode',
                      link: '/shop/c/FS-EL-400?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Appareils photos et accessoires',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesCamerasAndAccessoriesNavNode',
                          link: '/shop/c/FS-EL-401?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/CamerasAndAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Téléphones et accessoires',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesPhoneAccessoriesNavNode',
                          link: '/shop/c/FS-EL-404?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/PhoneAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Cartes mémoire',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsCamerasAndPhoneAccessoriesMemorycardsNavNode',
                          link: '/shop/c/FS-EL-402?nav=/shop/Categories/Electronics/CamerasAndPhoneAccessories/Memorycards',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Ordinateurs Et Technologies Connectées',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNavNode',
                      link: '/shop/c/FS-EL-500?nav=/shop/Categories/Electronics/ComputersAndSmartTech',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Maison connectée',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechConnectedHomeNavNode',
                          link: '/shop/c/FS-EL-501?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Connectedhome',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Carnets',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechNotebooksNavNode',
                          link: '/shop/c/FS-EL-502?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Notebooks',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Tablettes et lecteurs électroniques',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechTabletsAndeReadersNavNode',
                          link: '/shop/c/FS-EL-503?nav=/shop/Categories/Electronics/ComputersAndSmartTech/Tablets',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Accessoires pour ordinateurs et logiciels',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputerAccessoriesAndSoftwareNavNode',
                          link: '/shop/Categories/Electronics/ComputerAccessories/c/FS-EL-304?nav=/shop/Categories/Electronics/ComputerAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Montres intelligentes et GPS',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsComputersAndSmartTechSmartwatchesNavNode',
                          link: '/Shop/Categories/Electronics/Electronics/Computers-%26-Smart-Tech/Smartwatches/c/FS-EL-505',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Jeux vidéo',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesNavNode',
                      link: '/shop/Categories/Electronics/VideoGames/c/FS-EL-200?nav=/shop/Categories/Electronics/VideoGames',
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: null,
                          name: 'Consoles et accessoires de jeux ',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesConsolesAndGamingAccessoriesNavNode',
                          link: '/shop/c/FS-EL-201?nav=/shop/Categories/Electronics/VideoGames/ConsolesAndGamingAccessories',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                        {
                          navPromo: null,
                          name: 'Jeux',
                          uid: 'FrontShopMobileHomeAndElectronicsElectronicsVideoGamesGamesNavNode',
                          link: '/shop/c/FS-EL-202?nav=/shop/Categories/Electronics/VideoGames/Games',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHomeAndElectronicsElectronicsFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Maison et style de vie',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareNavNode',
                  link: '/c/FS-EL-Homeware?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Bougies ',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareCandlesNavNode',
                      link: '/c/FS-EL-H200?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Candles',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Diffuseurs',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareDiffusersNavNode',
                      link: '/c/FS-EL-H300?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/Diffusers',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Cartes de souhaits',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareGreetingCardsNavNode',
                      link: '/c/FS-EL-H500?nav=/shop/Categories/HomeAndElectronics/Homeware/GreetingCards',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Saisonnier',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareSeasonalDecorNavNode',
                      link: '/c/FS-EL-H100?nav=/mobile/shop/Categories/HomeAndElectronics/Homeware/SeasonalDecor',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Collections En Vedette',
                      uid: 'FrontShopMobileHomeAndElectronicsHomewareFeaturedCollectionNavNode',
                      link: null,
                      hasChildren: true,
                      __typename: 'CmsNode',
                      child: [
                        {
                          navPromo: {
                            name: 'Parfums rafraîchissants',
                            imageUrl:
                              'https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-creative/2022/P11/wk41/collection-tiles/featuredcollectiontile_homerefreshingscents/wk41_featurecollecctiontile_refreshingscents_enfr.png',
                            imageLink:
                              '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                            __typename: 'NavPromoNode',
                          },
                          name: 'Parfums rafraîchissants',
                          uid: 'FrontShopMobileHomeAndElectronicsHomewareRefreshingScentsFeaturedCollectionNavNode',
                          link: '/c/FS-EL-H200?&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue&nav=shop/homeandelectronics/homeandlifestyle/featuredcollections/refreshingscents',
                          hasChildren: false,
                          __typename: 'CmsNode',
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'Électroménagers',
                  uid: 'FrontShopMobileHomeAndElectronicsHomewareAppliancesNavNode',
                  link: '/c/FS-EL-H600?nav=/shop/Categories/HomeAndElectronics/Homeware/Appliances',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Linge de lit et matelas',
                  uid: 'FrontShopMobileHomeAndElectronicsBeddingNavNode',
                  link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-Bedding?nav=/shop/Categories/HomeAndElectronics/Bedding',
                  hasChildren: true,
                  __typename: 'CmsNode',
                  child: [
                    {
                      name: 'Matelas',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingMattressesNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B100?nav=/shop/Categories/HomeAndElectronics/Mattresses',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Oreillers ',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingPillowsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B200?nav=/shop/Categories/HomeAndElectronics/Pillows',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                    {
                      name: 'Couvertures lestées et housses de couette',
                      uid: 'FrontShopMobileHomeAndElectronicsBeddingWeightedBlanketsNavNode',
                      link: 'https://shop.shoppersdrugmart.ca/Shop/Categories/Home-%26-Electronics/Homeware/c/FS-EL-B300?nav=/shop/Categories/HomeAndElectronics/WeightedBlankets',
                      hasChildren: false,
                      __typename: 'CmsNode',
                      child: null,
                    },
                  ],
                },
                {
                  name: 'Boutique saisonnière',
                  uid: 'FrontShopMobileHomeAndElectronicsHalloweenNavNode',
                  link: '/Shop/Cat%C3%A9gories/Maison-et-%C3%A9lectronique/Maison-et-style-de-vie/Saisonnier/c/FS-EL-H100?nav=%2Fshop%2FCategories%2FHomeAndElectronics%2FHomeware%2FSeasonalDecor&sort=newest&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
            {
              name: 'Offres',
              uid: 'FrontShopMobileOffersNavNode',
              link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue',
              hasChildren: true,
              __typename: 'CmsNode',
              child: [
                {
                  name: 'Solde',
                  uid: 'FrontShopMobileOffersSaleNavNode',
                  link: '/shop/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3ASale%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Clearance Fr',
                  uid: 'FrontShopMobileOffersClearanceNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AClearance%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Gift with Purchase Fr',
                  uid: 'FrontShopMobileOffersGWPBeautyNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?q=%3Atrending%3Apromotions%3AGift%2Bwith%2BPurchase%3AshowInStock%3Atrue&sort=trending&page=0',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
                {
                  name: 'Offres PC Optimum',
                  uid: 'FrontShopMobileOffersPCOptimumOffersNavNode',
                  link: '/Shop/Categories/Offers/c/FS-Offers?nav=%2Fshop%2Foffers&sort=trending&page=0&q=%3Atrending%3AshowInStock%3Atrue%3Apromotions%3APC%2BOptimum%2BOffer',
                  hasChildren: false,
                  __typename: 'CmsNode',
                  child: null,
                },
              ],
            },
          ],
        },
        {
          name: 'Ordonnances',
          uid: 'FrontShopMobilePrescriptionNavNode',
          link: 'https://mypharmacy.shoppersdrugmart.ca/fr',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Services pharmaceutiques',
          uid: 'FrontShopMobilePharmacyServicesLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/fr/health-and-wellness/pharmacy-services',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Santé et bien-être',
          uid: 'FrontShopMobileHealthAndWellnessLocaledLink',
          link: 'https://www.shoppersdrugmart.ca/fr/health-and-wellness',
          hasChildren: null,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Électroniques',
          uid: 'FrontShopMobileElectronicsNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/electronics',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Promotions',
          uid: 'FrontShopMobilePromotionsNavNode',
          link: 'https://shop.shoppersdrugmart.ca/Promotions',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'PC Optimum',
          uid: 'FrontShopMobilePCOptimumNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/pcoptimum',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
        {
          name: 'Autres services de Shoppers',
          uid: 'FrontShopMobileMoreByShoppersNavNode',
          link: 'https://www1.shoppersdrugmart.ca/fr/more-by-shoppers',
          hasChildren: false,
          __typename: 'CmsNode',
          child: null,
        },
      ],
    },
  },
};
